function checkGift() {
    $.getJSON("/cart.js", function(t) {
        var e = t.items;
        $(".gift_item").show();
        for (let a = 0; a < e.length; a++) {
            var o = e[a].handle;
            $(".gift_item").each(function() {
                $(this).data("handle") === o && $(this).hide()
            })
        }
        if ($(".gift_item:visible").length === 0) {
            $(".gift-label-id").hide();
            $(".discount-code-box-and-shipping-label").add('hide-border-bottom');
            console.log('yes hide');
        } else {
            $(".gift-label-id").show();
             $(".discount-code-box-and-shipping-label").remove('hide-border-bottom');
            console.log('yes show');
        }
    })
}
window.afterCartShowAction = function() {
    $.getJSON("/cart.js", function(t) {
        var e = t.items;
        $(".gift_item").show();
        for (let a = 0; a < e.length; a++) {
            var o = e[a].handle;
            $(".gift_item").each(function() {
                $(this).data("handle") === o && $(this).hide()
            })
        }
        if ($(".gift_item:visible").length === 0) {
            $(".gift-label-id").hide();
            $(".discount-code-box-and-shipping-label").add('hide-border-bottom');
            console.log('yes hide');
        } else {
            $(".gift-label-id").show();
             $(".discount-code-box-and-shipping-label").remove('hide-border-bottom');
            console.log('yes show');
        }
    })
}


function shippingBar(t) {
    var e = 0,
        a = window.free_shipping_text.free_shipping_message_1,
        o = window.free_shipping_text.free_shipping_message_2,
        i = window.free_shipping_text.free_shipping_message_3,
        n = window.free_shipping_text.free_shipping_message_4,
        s = 0,
        r = window.free_shipping_text.free_shipping_1,
        l = window.free_shipping_color1,
        d = window.free_shipping_color2,
        c = window.free_shipping_color3,
        p = parseInt(window.free_shipping_price) * ((window.Shopify && Shopify.currency && Shopify.currency.rate) ? parseFloat(Shopify.currency.rate) : 1);    window.multi_lang && translator.isLang2() && (a = window.lang2.cart.general.free_shipping_message_1, o = window.lang2.cart.general.free_shipping_message_2, i = window.lang2.cart.general.free_shipping_message_3, r = window.lang2.cart.general.free_shipping_1);
    var u = parseInt(t.total_price) / 100,
        _ = Math.round(100 * u / p);
    u >= p ? e = 1 : (s = parseInt(p - u), a = o + " " + Shopify.formatMoney(100 * s, window.money_format) + " " + i + "<b>  " + n + " </b>", r = window.free_shipping_text.free_shipping_2), _ >= 100 && (_ = 100), 0 == _ && ella.checkItemsInDropdownCart();
    var g = c;
    _ <= 30 ? g = l : _ <= 70 && (g = d);
    let widthValue = _ + '%';
    $('.progress-bar-mixed').css('--free-shipping-width', widthValue);
    if (_ === 100) {
        $(document).find('.progress-bar-mixed').addClass('shipping-free');
    } else {
        $(document).find('.progress-bar-mixed').removeClass('shipping-free');
    }
    var h = '<div class="progress_shipping" role="progressbar" style="height: 15px; margin-top: 10px; margin-bottom: 10px;background-color: #e1dfd6;-webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);box-shadow: inset 0 1px 2px rgba(0,0,0,.1);">    <div class="progress-meter" style="position: relative;display: block;height: 100%;background-color: ' + g + ";text-align: center; line-height: 15px;color: #ffffff;width: " + _ + '%; -webkit-animation: 2s linear 0s normal none infinite running progress-bar-stripes;animation: 2s linear 0s normal none infinite running progress-bar-stripes;background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,rgba(0,0,0,0) 25%,rgba(0,0,0,0) 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,rgba(0,0,0,0) 75%,rgba(0,0,0,0));background-image:linear-gradient(45deg, rgb(255 255 255) 25%, rgba(0, 0, 0, 0) 25%, rgb(0 0 0 / 0%) 50%, rgb(255 255 255) 50%, rgb(255 255 255 / 0%) 75%, rgb(0 0 0) 75%, rgb(0 0 0)); background-size: 40px 40px; transition: 0.9s linear; transition-property: width, background-color;">' + _ + "%</div>  </div>";
    $(".free_shipping_progress").html(h), $(".free_shipping_massage1").html(a), $("#dropdown-cart .summary .free_shipping .text").html(r)
}
$(document).ready(function() {
        setTimeout(function() {
            checkGift()
        }, 3e3)
    }),
    function(t) {
        var e, a, o, i = t("body"),
            n = t(document),
            s = t("html"),
            r = t(window),
            l = ".wrapper-overlay",
            d = t("#sidebar-cart"),
            c = (d.find(".btn-remove"), d.find(".cart-empty")),
            p = d.find(".mini-products-list"),
            u = d.find(".cart-footer"),
            _ = localStorage.getItem("items") ? JSON.parse(localStorage.getItem("items")) : [],
            g = localStorage.getItem("compareArr") ? JSON.parse(localStorage.getItem("compareArr")) : [];
        localStorage.setItem("items", JSON.stringify(_)), localStorage.setItem("compareArr", JSON.stringify(g)), _.length && (_ = JSON.parse(localStorage.getItem("items"))), g.length && (g = JSON.parse(localStorage.getItem("compareArr"))), n.ready(function() {
            e = t("[data-menu-mb-toogle]"), o = (a = t("#dropdown-cart")).find(".mini-products-list"), n.ajaxStart(function() {
                f.isAjaxLoading = !0
            }), n.ajaxStop(function() {
                f.isAjaxLoading = !1
            }), f.init()
        });
        var h = r.innerWidth();
        r.off("resize.initMenuMobile").on("resize.initMenuMobile", function() {
            var e;
            clearTimeout(e), e = setTimeout(function() {
                var e = r.innerWidth();
                (e < 1200 && h >= 1200 || e >= 1200 && h < 1200) && (f.showHideMenuMobile(), f.initToggleMuiltiLangCurrency(), f.addTextMuiltiOptionActive(t("#lang-switcher"), t("#lang-switcher [data-value].active"), t("[data-language-label]")), f.addTextMuiltiOptionActive(t("#currencies"), t("#currencies [data-currency].active"), t("[data-currency-label]")), f.initDropdownColFooter(), f.dropdownCart(), f.dropdownCustomer(), f.stickyFixedTopMenu()), h = e
            }, 0)
        }), t("#shopify-section-collection-template-suppermarket").length || r.on("resize", function() {
            f.setActiveViewModeMediaQuery()
        });
        var f = {
            ellaTimeout: null,
            isSidebarAjaxClick: !1,
            isAjaxLoading: !1,
            init: function() {
               this.cartFreeDisocuntItemBased(), this.cartDrawerWhislisttrigger(), this.closeHeaderTop(), this.showHideMenuMobile(), this.closeAllOnMobile(), this.initToggleGlobe(), this.initToggleMuiltiLangCurrency(), this.addTextMuiltiOptionActive(t("#lang-switcher"), t("#lang-switcher [data-value].active"), t("[data-language-label]")), this.addTextMuiltiOptionActive(t("#currencies"), t("#currencies [data-currency].active"), t("[data-currency-label]")), this.initDropdownColFooter(), this.initScrollTop(), this.dropdownCart(), this.initColorSwatchGrid(), this.initQuickshop(), this.dropdownCustomer(), this.initNewsLetterPopup(), this.addEventShowOptions(), this.changeQuantityAddToCart(), this.initAddToCart(), this.editCart(), this.beforeYouLeave(), this.initFreeShippingMessage(), this._videoPopup(), this.initProductReview(), this.showPopupShare(), this.copyText(), this.showPopupStoreAvailability(), this.homeMoreLess(), this.ask_an_expert_scroll(), this.hideSizechart(), i.hasClass("enable_hover_video_product_items") && this.swapHoverVideo(), i.hasClass("template-index") || i.hasClass("template-page") || (this.initGroupedAddToCart(), this.initSliderFeaturedProducts()), t("[data-lookbook-icon]").length && this.addEventLookbookModal(), t("[data-countdown]").length && this.initCountdown(), this.initCountdownNormal(), this.checkbox_checkout(), this.checkbox_submit(), i.hasClass("template-page") && (this.collectionProduct(), this.CollectionMenu()), t("[data-menu-tab]").length ? this._multiHomepage() : this.menu_ajax(), this.loaderScript(), this.initInfiniteScrollingHomepage(), t("[data-home-product-tabs]").length && this.clickedActiveProductTabs(), t("[data-scroll-down]").length && this.handleScrollDown(), this.loaderProductCard(), (i.hasClass("template-collection") || i.hasClass("template-search")) && (this.historyAdapter(), this.initInfiniteScrolling(), this.initPaginationPage(), this.initCompareIcons(), this.doAddOrRemoveCompare(), this.initCompareSelected()), (i.hasClass("template-collection") || i.hasClass("template-product")) && this.loadJsonProductcard(), i.hasClass("template-collection") && (this.filterToolbar(), this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart(), this.initSidebar(), this.subCollectionSlider(), this._showmore_html()), this.initOpenSidebar(), this.closeSidebar(), this.initChangeQuantityButtonEvent(), this.initQuantityInputChangeEvent(), this.removeCartItem(), this.initQuickView(), this.stickyFixedTopMenu(), this.openSearchForm(), i.hasClass("template-product") && (this.initCustomerViewProductShop(), this.initProductMoreview(t("[data-more-view-product] .product-img-box")), this.initZoom(), this.initSoldOutProductShop(), this.productPageInitProductTabs(), this.changeSwatch("#add-to-cart-form .swatch :radio"), this.initStickyForProductFullWidth(), this.initStickyAddToCart(), this.wrapTable(), this._addonCompareColorPopup(), t(".frequently-bought-together-block").length > 0 && this.initBundleProducts(), this.productRecomendation(), this.appendProductRecomendation(), this.notifyinStock(), this.initDropdownSubCategoriesAtSidebar(), this.initProductVideo(), t(".product-template-slider").length && this._notifySoldoutSlider(), this.initSidebarProductSlider()), i.hasClass("template-cart") && (this.checkBundleProducts(), this._cartCountDown(), this._giftCard()), this.initWishListIcons(), this.doAddOrRemoveWishlish(), i.hasClass("template-page") && t(".wishlist-page").length && this.initWishLists(), 1025 > r.innerWidth() && this.initToggleSubMenuMobile()
            },
            showPopupStoreAvailability: function() {
                i.off("click.button_store", ".store-availability-information__button").on("click.button_store", ".store-availability-information__button", function(t) {
                    i.addClass("show_store_availability")
                }), i.off("click.close_store", ".store-availabilities-modal__close").on("click.close_store", ".store-availabilities-modal__close", function(t) {
                    i.removeClass("show_store_availability")
                }), i.on("click", function(e) {
                    0 === t(e.target).closest(".store-availabilities-modal").length && 0 === t(e.target).closest(".store-availability-information__button").length && i.removeClass("show_store_availability")
                })
            },
            showPopupShare: function() {
                t(".icon-share").click(function() {
                    t(".wrapper-social-popup").addClass("active")
                }), i.on("click", function(e) {
                    0 === t(e.target).closest(".wrapper-social-popup").length && 0 === t(e.target).closest(".icon-share").length && t(".wrapper-social-popup").removeClass("active")
                }), t(".wrapper-social-popup .title-close svg").on("click", function(e) {
                    t(".wrapper-social-popup").removeClass("active")
                })
            },
            copyText: function() {
                var e = !1;
                i.off("click.copyText", ".social-garment-link").on("click.copyText", ".social-garment-link", function(a) {
                    if (!1 == e) {
                        var o = t(this).find(".txt_copy");
                        o.select(), document.execCommand("Copy"), o.val("Link copied"), e = !0
                    }
                })
            },
            notifyinStock: function() {
                t("#soldOut-button").click(function() {
                    "closed" != t.cookie("soldOut") && t.cookie("soldOut", "closed", {
                        expires: 1,
                        path: "/"
                    })
                }), t("#ask_an_expert .actions .btn").click(function() {
                    t.cookie("soldOut", "", {
                        expires: -1,
                        path: "/"
                    })
                })
            },
            sliderMegaMenu: function() {
                t(".featuredProductCarousel").length && t(".featuredProductCarousel").slick({
                    infinite: !1,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: !1,
                    arrows: !0,
                    autoplay: !1,
                    get nextArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>'
                    },
                    get prevArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>'
                    },
                    speed: 1e3,
                    responsive: [{
                        breakpoint: 1450,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: !1,
                            arrows: !0
                        }
                    }, {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: !1,
                            arrows: !0
                        }
                    }, {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 370,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: !0,
                            arrows: !1
                        }
                    }]
                })
            },
            subCollectionSlider: function() {
                t("[data-slider-sub-collection]").length && t("[data-slider-sub-collection]").slick({
                    infinite: !1,
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    dots: !1,
                    arrows: !0,
                    autoplay: !1,
                    get nextArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>'
                    },
                    get prevArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>'
                    },
                    speed: 1e3,
                    responsive: [{
                        breakpoint: 1450,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6
                        }
                    }, {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    }, {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            dots: !0,
                            arrows: !1
                        }
                    }, {
                        breakpoint: 370,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: !0,
                            arrows: !1
                        }
                    }]
                })
            },
            productCartslider: function() {
                t("[data-product-cart-slider]").length && !t("[data-product-cart-slider]").hasClass("slick-slider") && t("[data-product-cart-slider]").slick({
                    infinite: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    get arrows() {
                        if ("layout_style_fullwidth" == window.layout_style) return this.arrows = !0;
                        return this.arrows = !1
                    },
                    get dots() {
                        if ("layout_style_fullwidth" == window.layout_style) return this.dots = !1;
                        return this.dots = !0
                    },
                    autoplay: !1,
                    get nextArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                        return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                    },
                    get prevArrow() {
                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                        if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                        return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                    },
                    speed: 1e3
                })
            },
            closeHeaderTop: function() {
                var e = t(".header-top"),
                    a = e.find("[data-close-header-top]");
                "closed" == t.cookie("headerTop") ? e.remove() : e.css("opacity", 1), a.off("click.closeHeaderTop").on("click.closeHeaderTop", function(a) {
                    a.preventDefault(), a.stopPropagation(), e.remove(), t.cookie("headerTop", "closed", {
                        expires: 1,
                        path: "/"
                    })
                })
            },
            showHideMenuMobile: function() {
                e.length && e.is(":visible") && e.off("click.showMenuMobile").on("click.showMenuMobile", function(e) {
                    e.preventDefault(), e.stopPropagation(), s.toggleClass("translate-overlay"), t(".close-menu-mb").toggleClass("menu-open"), t(".main-menu.jas-mb-style").css({
                        overflow: ""
                    }), t(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open")
                })
            },
            closeAllOnMobile: function() {
                i.off("click.close", l).on("click.close", l, function(e) {
                    e.preventDefault(), e.stopPropagation(), s.removeClass("translate-overlay cart-show customer-show sidebar-open options-show"), t(".close-menu-mb").removeClass("menu-open"), i.removeClass("show_store_availability"), t(".main-menu.jas-mb-style").css({
                        overflow: ""
                    }), t(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open"), t("body").hasClass("open_beforeYouLeave") && 0 === t(e.target).closest("#before-you-leave").length && 0 === t(e.target).closest(".search-form-wrapper").length && t("body").removeClass("open_beforeYouLeave"), s.removeClass("search-open")
                })
            },
            initToggleGlobe: function() {
                t(".wrapper-icon").on("click", function(e) {
                    t(this).parent().toggleClass("active"), t(".lang-currency-groups").slideUp(400), t(".item-location").hasClass("active") && t(".lang-currency-groups").slideDown(400), f.initToggleMuiltiLangCurrency()
                }), i.on("click", function(e) {
                    t(".item-location").hasClass("active") && 0 === t(event.target).closest(".item-location").length && (e.preventDefault(), t(".item-location").removeClass("active"), t(".lang-currency-groups").slideUp(400))
                })
            },
            initToggleMuiltiLangCurrency: function() {
                var e = t(".lang-currency-groups").find(".btn-group").find(".dropdown-label");
                t(".lang-currency-groups-8").length ? (t(document).on("click", ".lang-currency-groups-8", function(e) {
                    t(".lang-currency-groups-8").toggleClass("show")
                }), t(document).on("click", function(e) {
                    var a = t(".home-slideshow .slide-action");
                    t(".lang-currency-groups-8 ").hasClass("show") && !a.has(e.target).length && 0 === t(event.target).closest(".lang-currency-groups-8 ").length && t(".lang-currency-groups-8 ").removeClass("show")
                })) : e.length && e.is(":visible") ? (e.off("click.toggleMuiltiOption").on("click.toggleMuiltiOption", function(a) {
                    a.preventDefault(), a.stopPropagation();
                    var o = t(this).next();
                    o.is(":visible") ? o.slideUp(300) : (e.next(".dropdown-menu").hide(), o.slideDown(300))
                }), f.hideMuiltiLangCurrency()) : e.next(".dropdown-menu").css({
                    display: ""
                })
            },
            hideMuiltiLangCurrency: function() {
                n.off("click.hideMuiltiLangCurrency").on("click.hideMuiltiLangCurrency", function(e) {
                    var a = t(".lang-currency-groups .dropdown-menu");
                    a.is(e.target) || a.has(e.target).length || a.slideUp(300)
                })
            },
            addTextMuiltiOptionActive: function(t, e, a) {
                if (a.length) {
                    var o = e.html();
                    t.prev(a).html(o)
                }
            },
            initInfiniteScrollingHomepage: function() {
                t("[data-new-arrivals-product]").each(function() {
                    var e = t(this),
                        a = e.find(".infinite-scrolling-homepage"),
                        o = e.find(".infinite-scrolling-homepage a");
                    a.length && o.off("click.showMoreProduct").on("click.showMoreProduct", function(a) {
                        if (!t(this).hasClass("view-all-collection")) {
                            if (a.preventDefault(), a.stopPropagation(), t(this).hasClass("ajax-loading")) return !1;
                            t(this).addClass("ajax-loading");
                            var o = t(this).attr("data-collection"),
                                i = t(this).attr("data-limit"),
                                n = t(this).attr("data-total-products"),
                                s = parseInt(t(this).attr("data-page"));
                            t(this).hasClass("disabled") || f.doAjaxInfiniteScrollingGetContentSection(n, o, i, s, a, e)
                        }
                    })
                })
            },
            doAjaxInfiniteScrollingGetContentSection(e, a, o, i, n, s) {
                t.ajax({
                    type: "get",
                    url: window.router + "/collections/" + a,
                    cache: !1,
                    data: {
                        view: "sorting",
                        constraint: "limit=" + o + "+page=" + i
                    },
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(r) {
                        s.find(".products-grid").append(r);
                        var l = s.find(".products-grid").find(".grid-item").length;
                        if (t(r).length == o && l < 50 ? t(n.currentTarget).attr("data-page", i + 1) : e > 50 ? t(n.currentTarget).text(window.inventory_text.view_all_collection).attr("href", window.router + "/collections/" + a).addClass("view-all-collection") : t(n.currentTarget).remove(), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    },
                    complete: function() {
                        f.hideLoading(), t(n.currentTarget).removeClass("ajax-loading"), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    }
                })
            },
            initSliderFeaturedProducts: function() {
                t("[data-featured-products]").each(function() {
                    var e = t(this),
                        a = e.find(".products-grid"),
                        o = a.data("row"),
                        i = t(".halo-product-content .pro-page [data-has-right-sidebar]");
                    a.not(".slick-initialized") && a.slick({
                        get slidesToShow() {
                            if (i.length) return this.slidesToShow = 5;
                            return this.slidesToShow = a.data("row")
                        },
                        get vertical() {
                            if (a.hasClass("verticle") && t(".relate-verticle").length) return this.vertical = !0;
                            return this.vertical = !1
                        },
                        get slidesToScroll() {
                            if (a.hasClass("verticle")) return this.slidesToScroll = 1;
                            return this.slidesToScroll = a.data("row")
                        },
                        speed: 1e3,
                        infinite: !1,
                        get dots() {
                            if (e.hasClass("has-banner") || "supermarket" == window.product_style || "surfup" == window.product_style) return this.dots = !0;
                            return this.dots = !1
                        },
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1400,
                            settings: {
                                get slidesToShow() {
                                    if (e.hasClass("has-banner")) return this.slidesToShow = 3;
                                    if (o > 5) return this.slidesToShow = 5;
                                    if ("supermarket" == window.product_style || "surfup" == window.product_style) return this.slidesToShow = 4;
                                    return this.slidesToShow = 2
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("has-banner")) return this.slidesToScroll = 3;
                                    if (a.hasClass("verticle")) return this.slidesToScroll = 1;
                                    if (o >= 4) return this.slidesToScroll = 4;
                                    return o = 3, this.slidesToScroll = 3
                                }
                            }
                        }, {
                            breakpoint: 1200,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                vertical: !1,
                                get slidesToShow() {
                                    if (e.hasClass("has-banner")) return this.slidesToShow = 2;
                                    if (o >= 4) return this.slidesToShow = 4;
                                    return o = 3, this.slidesToShow = 3
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("has-banner")) return this.slidesToScroll = 2;
                                    if (o >= 4) return this.slidesToScroll = 4;
                                    return o = 3, this.slidesToScroll = 3
                                }
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                vertical: !1,
                                get slidesToShow() {
                                    if (o >= 3) return this.slidesToShow = 3;
                                    return this.slidesToShow = 2
                                },
                                get slidesToScroll() {
                                    if (o >= 3) return this.slidesToScroll = 3;
                                    return this.slidesToScroll = 2
                                }
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: !1,
                                vertical: !1,
                                dots: !0
                            }
                        }]
                    })
                })
            },
            initSliderRelatedProduct: function() {
                t("[data-related-products-slider]").each(function() {
                    var e = t(this),
                        a = e.find(".products-grid"),
                        o = a.data("row"),
                        i = t(".halo-product-content .pro-page [data-has-right-sidebar]");
                    a.not(".slick-initialized") && a.slick({
                        get slidesToShow() {
                            if (i.length) return this.slidesToShow = 5;
                            return this.slidesToShow = a.data("row")
                        },
                        get vertical() {
                            if (a.hasClass("verticle") && t(".relate-verticle").length) return this.vertical = !0;
                            return this.vertical = !1
                        },
                        get slidesToScroll() {
                            if (a.hasClass("verticle")) return this.slidesToScroll = 1;
                            return this.slidesToScroll = a.data("row")
                        },
                        speed: 1e3,
                        infinite: !1,
                        get dots() {
                            if (e.hasClass("has-banner") || "supermarket" == window.product_style || "surfup" == window.product_style) return this.dots = !0;
                            return this.dots = !1
                        },
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1400,
                            settings: {
                                get slidesToShow() {
                                    if (e.hasClass("has-banner")) return this.slidesToShow = 3;
                                    if (o > 5) return this.slidesToShow = 5;
                                    if ("supermarket" == window.product_style || "surfup" == window.product_style) return this.slidesToShow = 4;
                                    return this.slidesToShow = 2
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("has-banner")) return this.slidesToScroll = 3;
                                    if (a.hasClass("verticle")) return this.slidesToScroll = 1;
                                    if (o >= 4) return this.slidesToScroll = 4;
                                    return o = 3, this.slidesToScroll = 3
                                }
                            }
                        }, {
                            breakpoint: 1200,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                vertical: !1,
                                get slidesToShow() {
                                    if (e.hasClass("has-banner")) return this.slidesToShow = 2;
                                    if (o >= 4) return this.slidesToShow = 4;
                                    return o = 3, this.slidesToShow = 3
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("has-banner")) return this.slidesToScroll = 2;
                                    if (o >= 4) return this.slidesToScroll = 4;
                                    return o = 3, this.slidesToScroll = 3
                                }
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                vertical: !1,
                                get slidesToShow() {
                                    if (o >= 3) return this.slidesToShow = 3;
                                    return this.slidesToShow = 2
                                },
                                get slidesToScroll() {
                                    if (o >= 3) return this.slidesToScroll = 3;
                                    return this.slidesToScroll = 2
                                }
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: !1,
                                vertical: !1,
                                dots: !0
                            }
                        }]
                    })
                })
            },
            loaderProductCard: function() {
                var e = !1;
                t(document).ajaxStart(function() {
                    e = !0
                }), t(document).ajaxStop(function() {
                    e = !1
                });
                var a = t("[data-loader-product]"),
                    o = function() {
                        a.each(function() {
                            var e = this.getBoundingClientRect().top,
                                a = t(this);
                            if (!a.hasClass("ajax-loaded")) {
                                var o = a.data("collection"),
                                    i = a.data("limit"),
                                    n = a.data("grid"),
                                    s = a.data("layout"),
                                    r = a.attr("sectionId");
                                e < window.innerHeight + 10 && t.ajax({
                                    type: "get",
                                    url: window.router + "/collections/" + o,
                                    cache: !1,
                                    data: {
                                        view: "list_product",
                                        constraint: "limit=" + i + "+layout=" + s + "+grid=" + n + "+sectionId=" + r
                                    },
                                    beforeSend: function() {
                                        a.addClass("ajax-loaded")
                                    },
                                    success: function(e) {
                                        "" != o && a.find(".products-grid").html(e), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                                    },
                                    complete: function() {
                                        if (void 0 != a.attr("data-featured-products-section")) {
                                            if ("carousel" == s) {
                                                var e = a.find(".products-grid"),
                                                    o = e.data("row"),
                                                    i = t(".halo-product-content .pro-page [data-has-right-sidebar]");
                                                window.innerWidth < 1200 && a.on("afterChange", function(e, a) {
                                                    var o = function(t, e) {
                                                        var a = t[0].getBoundingClientRect(),
                                                            o = window.innerHeight || document.documentElement.clientHeight;
                                                        return e = e || 0, a.bottom >= 0 - e / 1.5 && a.right >= 0 && a.top <= o + e && a.left <= (window.innerWidth || document.documentElement.clientWidth)
                                                    };
                                                    t(".product-item[data-product-id]").each(function(e, a) {
                                                        if (t(this), o(t(a), -100)) {
                                                            var i = t(this);
                                                            if (!i[0].hasAttribute("data-json-product")) {
                                                                if (i.hasClass("json-loading")) return;
                                                                i.addClass("json-loading");
                                                                var n = i.find(".product-title").attr("href");
                                                                t.ajax({
                                                                    type: "GET",
                                                                    url: n,
                                                                    data: {
                                                                        view: "get_json"
                                                                    },
                                                                    cache: !1,
                                                                    dataType: "html",
                                                                    success: function(t) {
                                                                        var e = JSON.parse(t);
                                                                        i.attr("data-json-product", JSON.stringify(e))
                                                                    },
                                                                    complete: function() {
                                                                        i.removeClass("json-loading")
                                                                    }
                                                                })
                                                            }
                                                        }
                                                    })
                                                }), e.not(".slick-initialized") && e.slick({
                                                    get slidesToShow() {
                                                        if (i.length) return this.slidesToShow = 5;
                                                        return this.slidesToShow = e.data("row")
                                                    },
                                                    get vertical() {
                                                        if (e.hasClass("verticle")) return this.vertical = !0;
                                                        return this.vertical = !1
                                                    },
                                                    get slidesToScroll() {
                                                        if (e.hasClass("verticle")) return this.slidesToScroll = 1;
                                                        return this.slidesToScroll = e.data("row")
                                                    },
                                                    speed: 1e3,
                                                    infinite: !1,
                                                    get dots() {
                                                        if (a.hasClass("has-banner") || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.dots = !0;
                                                        return this.dots = !1
                                                    },
                                                    get nextArrow() {
                                                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                                        if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                                        return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                                                    },
                                                    get prevArrow() {
                                                        if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                                        if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                                        return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                                                    },
                                                    responsive: [{
                                                        breakpoint: 1400,
                                                        settings: {
                                                            get slidesToShow() {
                                                                if (a.hasClass("has-banner")) {
                                                                    if (a.hasClass("layout_style_4")) return this.slidesToShow = 2;
                                                                    return this.slidesToShow = 3
                                                                }
                                                                if (o > 5) return this.slidesToShow = 5;
                                                                return this.slidesToShow = e.data("row")
                                                            },
                                                            get slidesToScroll() {
                                                                if (a.hasClass("has-banner")) return this.slidesToScroll = 3;
                                                                if (e.hasClass("verticle")) return this.slidesToScroll = 1;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            }
                                                        }
                                                    }, {
                                                        breakpoint: 1281,
                                                        dots: !0,
                                                        arrows: !1,
                                                        vertical: !1,
                                                        settings: {
                                                            get slidesToShow() {
                                                                if (a.parents(".featured-products").hasClass("layout_style_7") && a.hasClass("col-md-12")) return this.slidesToShow = 2;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            },
                                                            get slidesToScroll() {
                                                                if (a.parents(".featured-products").hasClass("layout_style_7") && a.hasClass("col-md-12")) return this.slidesToScroll = 2;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            }
                                                        }
                                                    }, {
                                                        breakpoint: 1200,
                                                        settings: {
                                                            dots: !0,
                                                            arrows: !1,
                                                            vertical: !1,
                                                            get slidesToShow() {
                                                                if (a.hasClass("has-banner")) return this.slidesToShow = 2;
                                                                if (o >= 4) return this.slidesToShow = 4;
                                                                return o = 3, this.slidesToShow = 3
                                                            },
                                                            get slidesToScroll() {
                                                                if (a.hasClass("has-banner")) return this.slidesToScroll = 2;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            }
                                                        }
                                                    }, {
                                                        breakpoint: 1025,
                                                        dots: !0,
                                                        arrows: !1,
                                                        vertical: !1,
                                                        settings: {
                                                            get slidesToShow() {
                                                                if (a.parents(".featured-products").hasClass("layout_style_7") && a.hasClass("col-md-12")) return this.slidesToShow = 2;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            },
                                                            get slidesToScroll() {
                                                                if (a.parents(".featured-products").hasClass("layout_style_7") && a.hasClass("col-md-12")) return this.slidesToScroll = 2;
                                                                if (o >= 4) return this.slidesToScroll = 4;
                                                                return o = 3, this.slidesToScroll = 3
                                                            }
                                                        }
                                                    }, {
                                                        breakpoint: 992,
                                                        settings: {
                                                            dots: !0,
                                                            arrows: !1,
                                                            vertical: !1,
                                                            get slidesToShow() {
                                                                if (!(o >= 3) || a.hasClass("layout_style_5") || a.hasClass("layout_style_6")) return this.slidesToShow = 2;
                                                                return this.slidesToShow = 3
                                                            },
                                                            get slidesToScroll() {
                                                                if (!(o >= 3) || a.hasClass("layout_style_5") || a.hasClass("layout_style_6")) return this.slidesToScroll = 2;
                                                                return this.slidesToScroll = 3
                                                            }
                                                        }
                                                    }, {
                                                        breakpoint: 768,
                                                        settings: {
                                                            slidesToShow: 2,
                                                            slidesToScroll: 2,
                                                            arrows: !1,
                                                            vertical: !1,
                                                            dots: !0
                                                        }
                                                    }]
                                                })
                                            }
                                            if (f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                                        }
                                    }
                                })
                            }
                        })
                    };
                window.addEventListener("load", function t() {
                    o(), window.addEventListener("scroll", o)
                })
            },
            collectionProduct: function() {
                t("[data-collection-product] .products-grid").each(function() {
                    var e = t(this);
                    e.not(".slick-initialized") && e.slick({
                        rows: 2,
                        slidesToShow: 2,
                        infinite: !1,
                        dots: !0,
                        speed: 800,
                        arrows: !1,
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                slidesPerRow: 1,
                                slidesToShow: 2,
                                rows: 2
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                slidesPerRow: 1,
                                slidesToShow: 2,
                                rows: 2
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesPerRow: 1,
                                slidesToShow: 2,
                                dots: !0,
                                rows: 2
                            }
                        }]
                    })
                })
            },
            CollectionMenu: function() {
                t("[data-collection-menu-slider]").each(function() {
                    var e = t(this);
                    e.not(".slick-initialized") && e.slick({
                        slidesToShow: e.data("rows"),
                        slidesToScroll: 1,
                        dots: !1,
                        infinite: !1,
                        speed: 800,
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        }]
                    })
                })
            },
            initDropdownColFooter: function() {
                var e = t(".site-footer .dropdow-mb");
                window.innerWidth < 768 ? e.length && e.off("click.slideToggle").on("click.slideToggle", function() {
                    t(this).next().slideToggle(), t(this).toggleClass("open")
                }) : e.next().css({
                    display: ""
                })
            },
            initScrollTop: function() {
                var e = t("#back-top");
                r.scroll(function() {
                    t(this).scrollTop() > 220 ? e.fadeIn(400) : e.fadeOut(400), t("[data-masonry]").length && t(".site-nav-dropdown [data-masonry]").masonry({
                        columnWidth: ".grid-sizer",
                        itemSelector: "[data-gridItem]"
                    })
                }), e.off("click.scrollTop").on("click.scrollTop", function(e) {
                    return e.preventDefault(), e.stopPropagation(), t("html, body").animate({
                        scrollTop: 0
                    }, 400), !1
                })
            },
            dropdownCustomer: function() {
                this.initDropdownCustomerTranslate(t("[data-user-mobile-toggle]"), "customer-show"), this.initDropdownCustomerTranslate(t(".header-05 .customer-links"), "customer-show"), window.innerWidth >= 1200 && this.initDropdownCustomerTranslate(t("[data-user-pc-translate]"), "customer-show"), this.closeDropdownCustomerTranslate(), this.initDropdownCustomer()
            },
            initDropdownCustomerTranslate: function(t, e) {
                t.length && t.is(":visible") && t.off("click.dropdownCustomerMobile").on("click.dropdownCustomerMobile", function(t) {
                    t.preventDefault(), t.stopPropagation(), s.addClass(e)
                })
            },
            closeTranslate: function(e, a) {
                t(e).length && i.off("click.closeCustomer", e).on("click.closeCustomer", e, function(t) {
                    t.preventDefault(), t.stopPropagation(), s.removeClass(a)
                })
            },
            closeDropdownCustomerTranslate: function() {
                f.closeTranslate("#dropdown-customer .close-customer", "customer-show")
            },
            appendCustomerForPCHeaderDefault: function() {
                var e = t(".header-default .header-panel-bt .customer-links"),
                    a = t("#dropdown-customer");
                window.innerWidth >= 1200 ? a.appendTo(e) : a.appendTo(i)
            },
            appendCustomerForPCHeader05: function() {
                t(".header-05 .header-panel-bt .customer-links"), t("#dropdown-customer").appendTo(i)
            },
            appendCustomerForPCHeader07: function() {
                t(".header-07 .header-panel-bt .customer-links"), t("#dropdown-customer").appendTo(i)
            },
            doDropdownCustomerPCHeaderDefault: function() {
                var e = t("[data-dropdown-user]");
                window.innerWidth >= 1200 && e.off("click.toogleCustomer").on("click.toogleCustomer", function(e) {
                    e.preventDefault(), e.stopPropagation(), t(this).siblings("#dropdown-customer").slideToggle()
                })
            },
            doDropdownCustomerPCHeader05: function() {
                t("[data-dropdown-user]").off("click.toogleCustomer").on("click.toogleCustomer", function(e) {
                    e.preventDefault(), e.stopPropagation(), t(this).siblings("#dropdown-customer").slideToggle()
                })
            },
            doDropdownCustomerPCHeader07: function() {
                t("[data-dropdown-user]").off("click.toogleCustomer").on("click.toogleCustomer", function(e) {
                    e.preventDefault(), e.stopPropagation(), t(this).siblings("#dropdown-customer").slideToggle()
                })
            },
            initDropdownCustomer: function() {
                var e = t(".site-header");
                e.hasClass("header-default") && (this.appendCustomerForPCHeaderDefault(), this.doDropdownCustomerPCHeaderDefault()), e.hasClass("header-05") && (this.appendCustomerForPCHeader05(), this.doDropdownCustomerPCHeader05()), e.hasClass("header-07") && (this.appendCustomerForPCHeader07(), this.doDropdownCustomerPCHeader07())
            },
            dropdownCart: function() {
                this.closeDropdownCartTranslate(), this.initDropdownCartMobile(), this.initDropdownCartDesktop(), this.checkItemsInDropdownCart(), this.removeItemDropdownCart()
            },
            appendDropdownCartForMobile: function() {
                var e = t(".wrapper-top-cart");
                window.innerWidth < 1200 ? a.appendTo(i) : a.appendTo(e)
            },
            closeDropdownCartTranslate: function() {
                f.closeTranslate("#dropdown-cart .close-cart", "cart-show", "#reload_page")
            },
            initDropdownCartMobile: function() {
                var e = t(".header-mb, [data-cart-header-parallax], [data-cart-header-02], [data-cart-header-04], [data-cart-header-05], [data-cart-header-supermarket], [data-cart-sidebar]").find("[data-cart-toggle]");
                t("body.template-cart").length ? e.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function(e) {
                    e.preventDefault(), e.stopPropagation(), t([document.documentElement, document.body]).animate({
                        scrollTop: t(".wrapper-cart-template").offset().top - t(".main-menu").outerHeight()
                    }, 500)
                }) : e.off("click.initDropdownCartMobile").on("click.initDropdownCartMobile", function(t) {
                    t.preventDefault(), t.stopPropagation(), s.toggleClass("cart-show"), f.productCartslider()
                })
            },
            initDropdownCartDesktop: function() {
                t(".site-header").hasClass("header-default-cart") && (f.appendDropdownCartForMobile(), f.initDropdownCartForHeaderDefault())
            },
            addEventShowOptions: function() {
                var t = "[data-show-options]";
                n.off("click.showOptions", t).on("click.showOptions", t, function(t) {
                    t.preventDefault(), t.stopPropagation(), s.toggleClass("options-show")
                }), f.closeTranslate(".lang-currency-groups .close-option", "options-show")
            },
            initDropdownCartForHeaderDefault: function() {
                var e = t(".wrapper-top-cart"),
                    o = e.find("[data-cart-toggle]");
                var close = e.find('.close-cart');
                o.length && o.is(":visible") ? t("body.template-cart").length ? o.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function(e) {
                    e.preventDefault(), e.stopPropagation(), t([document.documentElement, document.body]).animate({
                        scrollTop: t(".wrapper-cart-template").offset().top - t(".main-menu").outerHeight()
                    }, 1e3)
                }) : "click" == window.dropdowncart_type ? o.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function(t) {
                    t.preventDefault(), t.stopPropagation(), e.toggleClass("is-open"), a.slideToggle()
                }) : (o.click(function() {
                    var o = t("#dropdown-customer");
                    o.is(":visible") && o.hide(), e.hasClass("is-open") || (e.addClass("is-open"), a.slideDown())
                }), close.click(function() {
                    e.hasClass("is-open") && (e.removeClass("is-open"), a.slideUp())
                })) : a.css("display", "")
            },
            checkItemsInDropdownCart: function() {
                var t = a.find(".no-items"),
                    e = a.find(".has-items");
                o.children().length ? (e.show(), t.hide(), c.hide(), p.show(), u.show()) : (e.hide(), t.show(), c.show(), p.hide(), u.hide())
            },
            removeItemDropdownCart: function(e) {
                 let removeClickTimeout;
                 let removeInProgress = false; 
                a.find(".btn-remove"), a.find(".item-quantity"), t(document).off("click.cartRemove").on("click.cartRemove", ".btn-remove", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    if (removeInProgress) return;
                    removeInProgress = true;
                    // var a = t(this).parents(".item").attr("id");
                    if (!a) {
                        removeInProgress = false;
                        return;
                    }
                    const $btn = t(this);
                    const itemId = $btn.closest(".item").attr("id");
                    const removeKey = $btn.attr("data-key");

                    if (!removeKey) {
                        console.error("No data-key found for remove button");
                        removeInProgress = false;
                        return;
                    }
                    let loadermodelButton = document.querySelector('.loading-modal');
                    if(loadermodelButton){
                        loadermodelButton.style.display = 'block';
                    }


                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: removeKey,
                            quantity: 0,
                        }),
                    })
                    .then((res) => res.json())
                    .then((cart) => {
                        console.log("🛒 Updated cart:", cart);
                        Shopify.getCart(function(t) {
                          f.doUpdateDropdownCart(t)
                        })
 
                        setTimeout(function() {
                            if (typeof checkGift === "function") checkGift();
                        }, 3000);
 
                            removeInProgress = false;
                            if (loadermodelButton) {
                                loadermodelButton.style.display = 'none';
                            }
                    })
                    .catch((err) => {
                        console.error("❌ Remove error:", err);
 
                        if (loadermodelButton) {
                            loadermodelButton.style.display = 'none';
                        }
                    });
                    // a = a.match(/\d+/g), Shopify.removeItem(a, function(e) {
                    //     t("#cart-item-" + a).remove(), t("#sidebar-cart-item-" + a).remove(), f.doUpdateDropdownCart(e), f.checkBundleProducts(), setTimeout(function() {
                    //         checkGift()
                    //     }, 3e3),setTimeout(() => {
                    //         removeInProgress = false;
                    //         if(loadermodelButton){
                    //             loadermodelButton.style.display = 'none';
                    //         }
                    //     }, 1000);
                    // })
                }), t(document).on("change", ".item-quantity", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.closest("[data-product-id]").data("product-id"),
                        i = parseInt(a.val());
                    t(this).parents(".item").addClass("cur--change"), f.doAjaxUpdatePopupCart(i, o)
                })
            },
            updateDropdownCart: function() {
                Shopify.getCart(function(t) {
                    f.doUpdateDropdownCart(t)
                })
            },
            cartDrawerWhislisttrigger:function(){
                var newdatadrawer = document.querySelector(".whislist-data-update-button");
                if (newdatadrawer) {
                    newdatadrawer.addEventListener("click", (event) => {
                    this.updateDropdownCart();
                    // window.updateFreeGiftProgress();
                    // window.updateFreeGiftProgressJewelry();
                    window.updateAllFreeGiftProgress();
                    console.log('yes run ');
                    setTimeout(function() {
                      checkGift()
                    }, 3e3)
                    });
                }
            },
            // cartFreeDisocuntItemBased: function(count){
            //     const selectors = document.querySelectorAll('.get_discount_free_funcitonality');
            //     if (!selectors.length) return;

            //     selectors.forEach(el => {
            //         const target = parseInt(el.dataset.itemdiscount) || 0;
            //         const percent = target ? Math.min((count / target) * 100, 100) : 0;

            //         // 🔍 Only run fallback if percent is NaN
            //         if (isNaN(percent)) {
            //         const newDataCountLoad = document.querySelector('[data-getCartDataCount]');
            //         if (newDataCountLoad) {
            //             const countLoadFree = parseInt(newDataCountLoad.getAttribute('data-getCartDataCount')) || 0;
            //             const percentNew = target ? Math.min((countLoadFree / target) * 100, 100) : 0;
            //             el.style.setProperty('--width_discount_funciton', `${percentNew}%`);
            //             console.log("Fallback percent:", percentNew);
            //         }
            //         } else {
            //         el.style.setProperty('--width_discount_funciton', `${percent}%`);
            //         console.log("Normal percent:", percent);
            //         }
            //     });
            //      window.cartDiscountUpdate();
            // },
           cartFreeDisocuntItemBased: function(count) {
                const selectors    = document.querySelectorAll('.get_discount_free_funcitonality');
                const remainTexts  = document.querySelectorAll('.item-remain-off');
                const notUnlockMsg = document.querySelectorAll('.feature-not-unlock-massage');
                const unlockMsg    = document.querySelectorAll('.freature-unlock-massage');

                let resolvedCount = parseInt(count, 10);
                if (isNaN(resolvedCount)) {
                    const countEl = document.querySelector('[data-getCartDataCount]');
                    resolvedCount = countEl ? (parseInt(countEl.getAttribute('data-getCartDataCount'), 10) || 0) : 0;
                }

                selectors.forEach(el => {
                    const target    = parseInt(el.dataset.itemdiscount, 10) || 0;
                    const remaining = Math.max(target - resolvedCount, 0);
                    const percent   = target ? Math.min((resolvedCount / target) * 100, 100) : 0;

                    el.style.setProperty('--width_discount_funciton', `${percent}%`);

                    remainTexts.forEach(s => {
                        s.textContent = remaining;
                    });

                    if (resolvedCount >= target) {
                        notUnlockMsg.forEach(m => m.style.display = "none");
                        unlockMsg.forEach(m => {
                            m.style.display = "inline-block";
                            m.textContent = m.dataset.text;
                        });
                    } else {
                        notUnlockMsg.forEach(m => m.style.display = "inline-block");
                        unlockMsg.forEach(m => m.style.display = "none");
                    }
                });

                window.cartDiscountUpdate();
            },

            doUpdateDropdownCart: function(e) {
                console.log(e);
                // window.updateFreeGiftProgress();
                // window.updateFreeGiftProgressJewelry();
                window.updateAllFreeGiftProgress();
                this.cartFreeDisocuntItemBased(e.item_count);
                var i = '<li class="item {freeGiftTrue}" id="cart-item-{ID}" data-product-id="{ID}"><a href="{URL}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a class="product-name" href="{URL}">{TITLE}</a><div class="cart-collateral">{COMPARE_PRICE_HTML}<span class="price">{PRICE}</span></div><div class="quantity-plus-product-options"><div class="option"><small>{VARIANT}</small><a href="JavaScript:void(0);" class="product-details__edit" data-cart-edit aria-label="link" data-url="{URL}&view=cart_edit" data-id="{ID}" data-quantity="{QUANTITY}"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 48 48" width="144px" height="144px"><path d="M 10.5 6 C 7.468 6 5 8.468 5 11.5 L 5 36 C 5 39.309 7.691 42 11 42 L 22.605469 42 C 22.858469 41.042 23.225516 39.759 23.728516 38 L 11 38 C 9.897 38 9 37.103 9 36 L 9 16 L 39 16 L 39 22.521484 C 39.427 22.340484 39.8615 22.188422 40.3125 22.107422 C 40.7065 22.036422 41.102859 21.992953 41.505859 22.001953 C 42.015859 22.001953 42.515 22.067641 43 22.181641 L 43 11.5 C 43 8.468 40.532 6 37.5 6 L 10.5 6 z M 13.5 20 A 1.50015 1.50015 0 1 0 13.5 23 L 15.5 23 A 1.50015 1.50015 0 1 0 15.5 20 L 13.5 20 z M 21.5 20 C 20.672 20 20 20.671 20 21.5 C 20 22.329 20.672 23 21.5 23 L 34.5 23 C 35.328 23 36 22.329 36 21.5 C 36 20.671 35.328 20 34.5 20 L 21.5 20 z M 41.498047 24 C 41.224047 24.001 40.946969 24.025172 40.667969 24.076172 C 39.783969 24.235172 38.939563 24.696156 38.226562 25.410156 L 26.427734 37.208984 C 26.070734 37.565984 25.807969 38.011141 25.667969 38.494141 L 24.097656 43.974609 C 24.025656 44.164609 23.993 44.365406 24 44.566406 C 24.013 44.929406 24.155594 45.288406 24.433594 45.566406 C 24.710594 45.843406 25.067688 45.986 25.429688 46 C 25.630688 46.007 25.834391 45.975344 26.025391 45.902344 L 31.505859 44.332031 C 31.988859 44.192031 32.431062 43.930266 32.789062 43.572266 L 44.589844 31.773438 C 45.303844 31.060437 45.764828 30.216031 45.923828 29.332031 C 45.973828 29.053031 45.997047 28.775953 45.998047 28.501953 C 46.001047 27.307953 45.540687 26.179312 44.679688 25.320312 C 43.820687 24.460313 42.692047 23.998 41.498047 24 z M 13.5 26 A 1.50015 1.50015 0 1 0 13.5 29 L 15.5 29 A 1.50015 1.50015 0 1 0 15.5 26 L 13.5 26 z M 21.5 26 C 20.672 26 20 26.671 20 27.5 C 20 28.329 20.672 29 21.5 29 L 31.808594 29 L 34.779297 26.027344 C 34.688297 26.010344 34.596 26 34.5 26 L 21.5 26 z M 13.5 32 A 1.50015 1.50015 0 1 0 13.5 35 L 15.5 35 A 1.50015 1.50015 0 1 0 15.5 32 L 13.5 32 z M 21.5 32 C 20.672 32 20 32.671 20 33.5 C 20 34.329 20.672 35 21.5 35 L 25.808594 35 L 28.808594 32 L 21.5 32 z"/></svg></a></div><div class="quantity"><form class="form-group cart-form"><label for="selectQuantity">Quantity:</label><div class="cart-quantity"><div class="qty-group"><a href="#" data-minus-quantity-cart="" class="minus button"></a><input class="custom-input-quantity" name="quantity" id="updates{ID}" data-qtt-id1="quantity{ID}" value="{QUANTITY}" type="text" /><a href="#" data-plus-quantity-cart="" class="plus button"></a></div></div></form></div></div></div><div class="whislist-button-fields"><a href="javascript:void(0)" data-href="{cart_url}/change?line={indexing}&amp;quantity=0" title="Remove This Item" data-key="{key}" class="btn-remove custom-button">Remove</a><div class="swish-wishlist-injected"><wishlist-button-collection data-product-handle="{HANDLE}" data-variant-id="{ID}" show-text="" icon="wishlist" align-self="center" align-content="center" wk-loaded=""><wk-button><button type="button" aria-label="Add to Wishlist" class="wk-button wk-align-center wk-align-content-center"><span class="wk-text">Add to Wishlist</span></button></wk-button></wishlist-button-collection></div></div></li>';
                if (t("[data-cart-count]").text(e.item_count), t(".wrapper-cartCount").show(), a.find(".discount-code-box-and-shipping-label .price").html(Shopify.formatMoney(e.original_total_price, window.money_format)),a.find(".summary .price").html(Shopify.formatMoney(e.total_price, window.money_format)), t("#sidebar-cart").find(".cart-footer .notranslate").html(Shopify.formatMoney(e.total_price, window.money_format)), e.item_count > 0) {
                    for (var n = t(".item.cur--change").data("product-id"), s = parseInt(t(".item.cur--change").find('input[name="quantity"]').data("line")), r = parseInt(t(".item.cur--change").find('input[name="quantity"]').val()), l = 0; l < e.items.length; l++) {
                        var d = i,
                            c = e.items[l].id,
                            p = [];
                        var currentIndex = l; 
                        var lineIndex = l + 1;
                        var propertiesItems = e.items[l].properties;
                        let propertesYesFind = '';
                        if (propertiesItems && propertiesItems._free_gift === "true" || propertiesItems._free_gift_Jewelry_box === 'true' ) {
                           propertesYesFind = 'FreeGiftItem';
                        }else{
                           propertesYesFind = '';
                        }
                        var productUrl = e.items[l].url,
                            handleOnly = "";
                        var key = e.items[l].key;
                        var cart_url = window.ShopifyRoutes.cart;
                        console.log(key);
 
                        if (productUrl && productUrl.includes("/products/")) {
                            let split1 = productUrl.split("/products/")[1] || "";
                            handleOnly = split1.split("?variant=")[0] || "";
                        }
 
                        /* ====== COMPARE PRICE LOGIC START ====== */
                        var comparePriceHtml = '';
                        var itemPrice = e.items[l].price; // current selling price (in cents)
                        var itemHandle = e.items[l].handle;
                        var itemVariantId = e.items[l].id;
 
                        // Self-invoking function to fetch compare_at_price from product JSON
                        (function(handle, variantId, price, cartItemId) {
                            t.getJSON('/products/' + handle + '.js', function(product) {
                                var compareAtPrice = 0;
                                // Find the matching variant
                                for (var v = 0; v < product.variants.length; v++) {
                                    if (product.variants[v].id === variantId) {
                                        compareAtPrice = product.variants[v].compare_at_price;
                                        break;
                                    }
                                }
                                // If compare_at_price exists and is greater than current price, inject it
                                if (compareAtPrice && compareAtPrice > price) {
                                    var compareHtml = '<span class="compare-price">' + Shopify.formatMoney(compareAtPrice, window.money_format) + '</span>';
                                    t('#cart-item-' + cartItemId).find('.cart-collateral .price').before(compareHtml);
                                }
                            });
                        })(itemHandle, itemVariantId, itemPrice, c);
                        /* ====== COMPARE PRICE LOGIC END ====== */
 
                        if (0 == l && o.html(""), d = (d = (d = (d = (d = (d = (d = (d = d.replace(/\{ID\}/g, e.items[l].id)).replace(/\{URL\}/g, e.items[l].url)).replace(/\{HANDLE\}/g, handleOnly).replace(/\{cart_url\}/g, cart_url).replace(/\{indexing\}/g, lineIndex).replace(/\{key\}/g, key).replace(/\{freeGiftTrue\}/g, propertesYesFind).replace(/\{COMPARE_PRICE_HTML\}/g, '')).replace(/\{TITLE\}/g, f.translateText(e.items[l].product_title))).replace(/\{VARIANT\}/g, e.items[l].variant_title || "")).replace(/\{QUANTITY\}/g, e.items[l].quantity)).replace(/\{IMAGE\}/g, Shopify.resizeImage(e.items[l].image, "160x"))).replace(/\{PRICE\}/g, Shopify.formatMoney(e.items[l].price, window.money_format)), o.append(d), r > s && s > 0 ? t('#dropdown-cart [data-product-id="' + n + '"]').find(".error-message-input").html('<i class="fa fa-exclamation-circle"></i>' + window.inventory_text.warning_quantity + ": " + s) : t('#dropdown-cart [data-product-id="' + n + '"]').find(".error-message-input").text(""), t.ajax({
                                url: "/products/" + e.items[l].handle + "?view=cart_edit",
                                success: function(e) {
                                    (p = t(e).find(".get_script_content").data("array_json").filter(function(t) {
                                        return parseInt(t.id) === c
                                    })).length && t('#dropdown-cart [data-product-id="' + c + '"]').find('[name="quantity"]').attr("data-line", p[0].value)
                                }
                            }), e.cart_level_discount_applications.length > 0 && t("[data-cart-discount-wrapper]").length) {
                            var u = e.cart_level_discount_applications,
                                _ = u[0].title,
                                g = u[0].total_allocated_amount;
                            t("[data-cart-discount-wrapper]").show(), t("[data-cart-discount-title]").text(_), t("[data-cart-discount-amount]").html(Shopify.formatMoney(g, window.money_format))
                        } else t("[data-cart-discount-wrapper]").hide()
                    }
                    t(".cart-sidebar-products").show(), f.removeItemDropdownCart(e), f.checkNeedToConvertCurrency() && (Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "#sidebar-cart span.money", "money_format"), Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "#dropdown-cart span.money", "money_format"))
                } else t(".cart-sidebar-products").hide(), t(".wrapper-cartCount").hide();
                f.initFreeShippingMessage(), f.editCart(), f.checkItemsInDropdownCart()
            },
            translateText: function(t) {
                if (!window.multi_lang || 0 > t.indexOf("|")) return t;
                if (window.multi_lang) {
                    var e = t.split("|");
                    return translator.isLang2() ? e[1] : e[0]
                }
            },
            checkNeedToConvertCurrency: function() {
                return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency || window.show_auto_currency
            },
            loadJsonProductcard: function() {
                if (window.innerWidth > 1024) t(document).off("mouseover", ".product-item[data-product-id]").on("mouseover", ".product-item[data-product-id]", function(e) {
                    e.preventDefault();
                    var a = t(this);
                    if (!a[0].hasAttribute("data-json-product")) {
                        if (a.hasClass("json-loading")) return;
                        a.addClass("json-loading");
                        var o = a.find(".product-title").attr("href");
                        t.ajax({
                            type: "GET",
                            url: o,
                            data: {
                                view: "get_json"
                            },
                            cache: !1,
                            dataType: "html",
                            success: function(t) {
                                var e = JSON.parse(t);
                                a.attr("data-json-product", JSON.stringify(e))
                            },
                            complete: function() {
                                a.removeClass("json-loading")
                            }
                        })
                    }
                });
                else {
                    var e = function(t, e) {
                        var a = t[0].getBoundingClientRect(),
                            o = window.innerHeight || document.documentElement.clientHeight;
                        return e = e || 0, a.bottom >= 0 - e / 1.5 && a.right >= 0 && a.top <= o + e && a.left <= (window.innerWidth || document.documentElement.clientWidth)
                    };
                    t(window).scroll(function() {
                        t(".product-item[data-product-id]").each(function(a, o) {
                            if (t(this), e(t(o), -100)) {
                                var i = t(this);
                                if (!i[0].hasAttribute("data-json-product")) {
                                    if (i.hasClass("json-loading")) return;
                                    i.addClass("json-loading");
                                    var n = i.find(".product-title").attr("href");
                                    t.ajax({
                                        type: "GET",
                                        url: n,
                                        data: {
                                            view: "get_json"
                                        },
                                        cache: !1,
                                        dataType: "html",
                                        success: function(t) {
                                            var e = JSON.parse(t);
                                            i.attr("data-json-product", JSON.stringify(e))
                                        },
                                        complete: function() {
                                            i.removeClass("json-loading")
                                        }
                                    })
                                }
                            }
                        })
                    })
                }
            },
            changeSwatchQs: function() {
                t(".selector-wrapper :radio").on("change", function(e) {
                    var a, o = t(this),
                        i = t(this).parents(".product-item"),
                        n = t(this).parents(".action"),
                        s = i.data("json-product").variants,
                        r = i.find(".option-color").data("option-position"),
                        l = o.closest("[data-option-index]").data("option-index"),
                        d = n.find(".swatch-element"),
                        c = o.val(),
                        p = n.find("[name=id]"),
                        u = n.find(".selector-wrapper-1").find("input:checked").val(),
                        _ = n.find(".selector-wrapper-2").find("input:checked").val(),
                        g = n.find(".selector-wrapper-3").find("input:checked").val();
                    switch (d.removeClass("soldout"), d.find(":radio").prop("disabled", !1), l) {
                        case 0:
                            var h = s.find(function(t) {
                                return 1 == r ? t.option2 == c && t.option1 == _ : 2 == r ? t.option3 == c && t.option1 == _ : t.option1 == c && t.option2 == _
                            });
                            if (void 0 != h) a = h;
                            else {
                                var v = s.find(function(t) {
                                    return 1 == r ? t.option2 == c : 2 == r ? t.option3 == c : t.option1 == c
                                });
                                a = v
                            }
                            break;
                        case 1:
                            var h = s.find(function(t) {
                                return 1 == r ? t.option2 == u && t.option1 == c && t.option3 == g : 2 == r ? t.option3 == u && t.option1 == c && t.option2 == g : t.option1 == u && t.option2 == c && t.option3 == g
                            });
                            if (void 0 != h) a = h;
                            else {
                                var v = s.find(function(t) {
                                    return 1 == r ? t.option2 == u && t.option1 == c : 2 == r ? t.option3 == u && t.option1 == c : t.option1 == u && t.option2 == c
                                });
                                a = v
                            }
                            break;
                        case 2:
                            var h = s.find(function(t) {
                                return 1 == r ? t.option2 == u && t.option1 == _ && t.option3 == c : 2 == r ? t.option3 == u && t.option1 == _ && t.option2 == c : t.option1 == u && t.option2 == _ && t.option3 == c
                            });
                            void 0 != h && (a = h)
                    }
                    if (void 0 != a) {
                        p.val(a.id);
                        var m = t(this).val();
                        a.compare_at_price > a.price ? i.find("[data-compare-price-grid]").html(Shopify.formatMoney(a.compare_at_price, window.money_format)) : i.find("[data-compare-price-grid]").html(""), i.find("[data-price-grid]").html(Shopify.formatMoney(a.price, window.money_format)), t(this).parents(".selector-wrapper").find(".form-label span").text(m), f.checkStatusSwatchQs(i, n)
                    }
                }), t(".product-card__variant--popup--content select.single-option-selector").on("change", function() {
                    var e, a = t(this),
                        o = t(this).parents(".product-item"),
                        i = t(this).parents(".action"),
                        n = o.data("json-product").variants;
                    o.find(".option-color").data("option-position");
                    var s = a.data("option");
                    o.find(".swatch-element");
                    var r = a.val(),
                        l = i.find("[name=id]"),
                        d = i.find('[data-option="option1"]').val(),
                        c = i.find('[data-option="option2"]').val();
                    switch (i.find('[data-option="option3"]').val(), s) {
                        case "option1":
                            var p = n.find(function(t) {
                                return t.option1 == r && t.option2 == c && t.available
                            });
                            e = void 0 != p ? p : n.find(function(t) {
                                return t.option1 == r && t.available
                            });
                            break;
                        case "option2":
                            var p = n.find(function(t) {
                                return t.option1 == d && t.option2 == r && t.available
                            });
                            void 0 != p && (e = p);
                            break;
                        case "option3":
                            var p = n.find(function(t) {
                                return t.option1 == d && t.option2 == c && t.option3 == r && t.available
                            });
                            void 0 != p && (e = p)
                    }
                    void 0 != e && l.val(e.id);
                    var u = t(this).val();
                    t(this).parents(".selector-wrapper").find(".form-label span").text(u), f.checkStatusSwatchQs(o, i)
                })
            },
            checkStatusSwatchQs: function(e, a) {
                if (window.use_color_swatch) {
                    var o = e.data("json-product"),
                        i = o.variants,
                        n = e.find("[data-option-index]"),
                        s = e.find(".option-color").data("option-position");
                    void 0 == a && (a = e);
                    var r = a.find('[data-option-index="0"]').find("input:checked").val(),
                        l = a.find('[data-option-index="1"]').find("input:checked").val();
                    a.find('[data-option-index="2"]').find("input:checked").val(), n.each(function() {
                        var e = t(this).data("option-index"),
                            o = t(this).find(".swatch-element");
                        switch (e) {
                            case 0:
                                o.each(function() {
                                    var e = t(this).data("value"),
                                        o = i.find(function(t) {
                                            return 1 == s ? t.option2 == e && t.available : 2 == s ? t.option3 == e && t.available : t.option1 == e && t.available
                                        }),
                                        n = i.find(function(t) {
                                            return 1 == s ? t.option2 == e : 2 == s ? t.option3 == e : t.option1 == e
                                        });
                                    void 0 == o ? void 0 == n ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).removeClass("available"), t(this).find(":radio").prop("checked", !1)) : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).removeClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").addClass("unavailable").attr("disable")) : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).addClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"))
                                });
                                break;
                            case 1:
                                o.each(function() {
                                    var e = t(this).data("value"),
                                        o = i.find(function(t) {
                                            return 1 == s ? t.option2 == r && t.option1 == e && t.available : 2 == s ? t.option3 == r && t.option1 == e && t.available : t.option1 == r && t.option2 == e && t.available
                                        }),
                                        n = i.find(function(t) {
                                            return 1 == s ? t.option2 == r && t.option1 == e : 2 == s ? t.option3 == r && t.option1 == e : t.option1 == r && t.option2 == e
                                        });
                                    void 0 == o ? void 0 == n ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).removeClass("available"), t(this).find(":radio").prop("checked", !1)) : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).removeClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").addClass("unavailable").attr("disable")) : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).addClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"))
                                });
                                break;
                            case 2:
                                o.each(function() {
                                    var e = t(this).data("value"),
                                        o = i.find(function(t) {
                                            return 1 == s ? t.option2 == r && t.option1 == l && t.option3 == e && t.available : 2 == s ? t.option3 == r && t.option1 == l && t.option2 == e && t.available : t.option1 == r && t.option2 == l && t.option3 == e && t.available
                                        }),
                                        n = i.find(function(t) {
                                            return 1 == s ? t.option2 == r && t.option1 == l && t.option3 == e : 2 == s ? t.option3 == r && t.option1 == l && t.option2 == e : t.option1 == r && t.option2 == l && t.option3 == e
                                        });
                                    void 0 == o ? void 0 == n ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).removeClass("available"), t(this).find(":radio").prop("checked", !1)) : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).removeClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").addClass("unavailable").attr("disable")) : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).addClass("available"), t(this).find(":radio").prop("disabled", !1), a.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"))
                                })
                        }
                    }), a.find(".swatch-element.soldout").find("input:checked").length ? a.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", !0) : a.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled"), a.find(".selector-wrapper:not(.option-color)").each(function() {
                        t(this).find(".swatch-element").find("input:checked").length < 1 && (t(this).find(".swatch-element.available").length ? t(this).find(".swatch-element.available").eq("0").find("label").trigger("click") : t(this).find(".swatch-element.soldout").eq("0").find("label").trigger("click"))
                    })
                } else {
                    var o = e.data("json-product"),
                        i = o.variants,
                        n = e.find(".product-card__variant--popup--content [data-option]"),
                        s = e.find(".option-color").data("option-position"),
                        r = a.find('.product-card__variant--popup--content [data-option="option1"]').val(),
                        l = a.find('.product-card__variant--popup--content [data-option="option2"]').val();
                    a.find('.product-card__variant--popup--content [data-option="option3"]').val(), n.each(function() {
                        var e = t(this).data("option-index"),
                            a = t(this).find("option");
                        switch (e) {
                            case 0:
                                a.each(function() {
                                    var e = t(this).val();
                                    void 0 == i.find(function(t) {
                                        return t.option1 == e && t.available
                                    }) ? void 0 == i.find(function(t) {
                                        return t.option1 == e
                                    }) ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled")) : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled")) : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"))
                                });
                                break;
                            case 1:
                                a.each(function() {
                                    var e = t(this).val();
                                    void 0 == i.find(function(t) {
                                        return t.option1 == r && t.option2 == e && t.available
                                    }) ? void 0 == i.find(function(t) {
                                        return t.option1 == r && t.option2 == e
                                    }) ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled")) : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled")) : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"))
                                });
                                break;
                            case 2:
                                a.each(function() {
                                    var e = t(this).val();
                                    void 0 == i.find(function(t) {
                                        return t.option1 == r && t.option2 == l && t.option3 == e && t.available
                                    }) ? void 0 == i.find(function(t) {
                                        return t.option1 == r && t.option2 == l && t.option3 == e
                                    }) ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled")) : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled")) : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"))
                                })
                        }
                    }), a.find(".product-card__variant--popup--content .single-option-selector").find("option.soldOut:selected").length ? a.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", !0) : a.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled")
                }
            },
            initQuickshop: function() {
                i.off("click.quickshop").on("click.quickshop", "[data-init-quickshop]", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.parents(".product-item"),
                        i = a.parents(".action");
                    o.find(".option-color"), a.parents(".action").addClass("show-popup-qs"), f.changeSwatchQs(), o.data("json-product"), f.checkStatusSwatchQs(o, i), a.parents(".action").find(".selector-wrapper:not(.option-color)").each(function() {
                        t(this).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find("label").trigger("click")
                    }), f.stickySidebar()
                }), i.off("click.cancelquickshop").on("click.cancelquickshop", "[data-cancel-swatch-qs]", function() {
                    t(this).parents(".action").removeClass("show-popup-qs")
                })
            },
            initColorSwatchGrid: function() {
                i.off("click.toggleClass").on("click.toggleClass", ".item-swatch li label", function() {
                    t(this).parents(".inner-top").find(".action").removeClass("show-popup-qs");
                    var e = t(this),
                        a = e.attr("data-title").replace(/^\s+|\s+$/g, ""),
                        o = e.closest(".grid-item"),
                        i = o.closest(".sidebar-widget-product");
                    e.parents(".item-swatch").find("li label").removeClass("active"), e.addClass("active");
                    var n = t(this).parents(".product-item").data("json-product"),
                        s = [],
                        r = t(this).data("id-product"),
                        l = o.find("a").attr("href");
                    if (o.find("a:not(.btn-cancel):not(.number-showmore)").attr("href", l.split("?variant=")[0] + "?variant=" + r), "layout_style_surfup" == window.layout_style ? o.find(".product-title").hasClass("change-text") ? o.find(".product-title").find("[data-change-title]").text(a) : o.find(".product-title").addClass("change-text").append("<span data-change-title>" + a + "</span>") : o.find(".product-title").hasClass("change-text") ? o.find(".product-title").find("[data-change-title]").text(" - " + a) : o.find(".product-title").addClass("change-text").append("<span data-change-title> - " + a + "</span>"), void 0 != e.data("with-one-option")) {
                        var d = e.data("quantity");
                        o.find('[name="id"]').val(e.data("with-one-option")), d > 0 ? (o.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled"), o.find("[data-btn-addtocart]").text(window.inventory_text.add_to_cart)) : (o.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", "disabled"), o.find("[data-btn-addtocart]").text(window.inventory_text.sold_out));
                        var c = e.data("price"),
                            p = e.data("compare_at_price");
                        p > c ? o.find("[data-compare-price-grid]").html(Shopify.formatMoney(p, window.money_format)) : o.find("[data-compare-price-grid]").html(""), o.find("[data-price-grid]").html(Shopify.formatMoney(c, window.money_format))
                    } else void 0 != n && f.checkStatusSwatchQs(t(this).parents(".product-item")), t(".template-collection").length ? t(this).parents(".product-collection").hasClass("products-list") ? o.find(".product-details").find('[data-value="' + a + '"]').find("label").trigger("click") : o.find(".action:eq(0)").find('[data-value="' + a + '"]').find("label").trigger("click") : o.find('[data-value="' + a + '"]').find("label").trigger("click");
                    if (void 0 != n) var s = n.media.filter(function(t) {
                        return t.alt === a
                    });
                    if (s.length > 0 && "variant_grouped" == window.color_swatch_style) {
                        if (s.length > 1) var u = 2;
                        else var u = s.length;
                        for (var _ = 0; _ < u; _++) o.find('picture[data-index="' + _ + '"] > *').attr("srcset", s[_].src)
                    } else {
                        var g = e.data("img");
                        if (i.length && (g = g.replace("800x", "large")), g) return o.find(".product-grid-image > picture > *, .product-grid-image > img").attr({
                            srcset: g
                        }), !1
                    }
                }), i.off("click.showmore").on("click.showmore", ".item-swatch-more a", function() {
                    t(this).parents(".item-swatch").toggleClass("show--more"), t(this).parents(".item-swatch").hasClass("show--more") ? t(this).children().text("-") : t(this).children().text("+")
                })
            },
            showLoading: function() {
                t(".loading-modal").show()
                var mainDrawerUpdate = document.querySelector('#dropdown-cart');
                if (mainDrawerUpdate) {
                    mainDrawerUpdate.classList.add('stop-every-work');
                }
            },
            hideLoading: function() {
                t(".loading-modal").hide();
                var mainDrawerUpdate = document.querySelector('#dropdown-cart');
                if (mainDrawerUpdate) {
                    mainDrawerUpdate.classList.remove('stop-every-work');
                }
            },
            showModal: function(e) {
                t(e).fadeIn(500), f.ellaTimeout = setTimeout(function() {
                    t(e).fadeOut(500)
                }, 5e3)
            },
            translateBlock: function(t) {
                window.multi_lang && translator.isLang2() && translator.doTranslate(t)
            },
            closeLookbookModal: function() {
                t(".ajax-lookbook-modal").fadeOut(500)
            },
            addEventLookbookModal: function() {
                i.off("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]").on("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this).data("handle"),
                        o = t(this);
                    f.doAjaxAddLookbookModal(a, o), n.off("click.closeLookbookModal").on("click.closeLookbookModal", "[data-close-lookbook-modal], .ajax-lookbook-modal .overlay", function() {
                        return f.closeLookbookModal(), !1
                    })
                })
            },
            doAjaxAddLookbookModal: function(e, a) {
                var o, i, n = t(a).offset(),
                    s = n.top,
                    r = n.left,
                    l = a.innerWidth(),
                    d = t(".ajax-lookbook-modal").innerWidth();
                window.innerWidth > 767 ? (i = r > d + 31 ? "calc(" + r + "px - " + d + "px + 2px)" : "calc(" + r + "px + " + l + "px - 2px)", o = s - d / 2 + "px") : (i = 0, o = s - 30 + "px"), f.isAjaxLoading || t.ajax({
                    type: "get",
                    url: window.router + "/products/" + e + "?view=json",
                    success: function(e) {
                        t(".ajax-lookbook-modal").css({
                            left: i,
                            top: o
                        }), t(".ajax-lookbook-modal .lookbook-content").html(e), f.translateBlock(".lookbook-content"), t(".ajax-lookbook-modal").fadeIn(500)
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    }
                })
            },
            clickedActiveProductTabs: function() {
                t("[data-home-product-tabs]").each(function() {
                    var e = t(this),
                        a = e.find(".list-product-tabs").find("[data-product-tabTop]"),
                        o = e.find("[data-product-TabContent]"),
                        i = e.find(".list-product-tabs .tab-links.active"),
                        n = e.find(".product-tabs-content .tab-content.active");
                    f.doAjaxProductTabs(i.data("href"), n.find(".loading"), n.find(".products-grid"), e.attr("sectionid")), a.off("click").on("click", function(i) {
                        if (i.preventDefault(), i.stopPropagation(), !t(this).hasClass("active") && !t(this).hasClass("active")) {
                            var n = t(this),
                                s = t(n.data("target"));
                            a.removeClass("active"), o.removeClass("active"), s.find(".products-grid").hasClass("slick-initialized") || f.doAjaxProductTabs(n.data("href"), s.find(".loading"), s.find(".products-grid"), e.attr("sectionid")), n.addClass("active"), s.addClass("active")
                        }
                    })
                })
            },
            doAjaxProductTabs: function(e, a, o, i) {
                t("[data-home-product-tabs]"), t.ajax({
                    type: "get",
                    url: e,
                    data: {
                        constraint: "sectionId=" + i
                    },
                    beforeSend: function() {
                        a.text("Loading ... please wait ...")
                    },
                    success: function(i) {
                        a.hide(), "/collections/?view=json" == e ? a.text("Please link to collections").show() : (o.html(t(i).find(".grid-items").html()), o.hasClass("slick-initialized") || f.initProductTabsSlider(o.parent()), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), f.translateBlock("[data-home-product-tabs]"), f.initColorSwatchGrid(), f.initWishListIcons(), f.ellaTimeout = setTimeout(function() {
                            if (t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                        }, 1e3)), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    },
                    error: function(t, e) {
                        a.text("Sorry, there are no products in this collection").show()
                    }
                })
            },
            initProductTabsSlider: function(e) {
                e.each(function() {
                    var e = t(this),
                        a = e.find(".products-grid"),
                        o = a.data("row");
                    a.not(".slick-initialized") && a.find(".grid-item").length && a.slick({
                        slidesToShow: a.data("row"),
                        slidesToScroll: a.data("row"),
                        dots: !1,
                        infinite: !1,
                        speed: 1e3,
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                get slidesToShow() {
                                    if (e.hasClass("sections-has-banner")) return this.slidesToShow = 2;
                                    if (o >= 4) return this.slidesToShow = 4;
                                    return o = 3, this.slidesToShow = 3
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("sections-has-banner")) return this.slidesToScroll = 2;
                                    if (o >= 4) return this.slidesToScroll = 4;
                                    return o = 3, this.slidesToScroll = 3
                                }
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                dots: !0,
                                arrows: !1,
                                get slidesToShow() {
                                    if (e.hasClass("sections-has-banner")) return this.slidesToShow = 2;
                                    if (o >= 3) return this.slidesToShow = 3;
                                    this.slidesToShow = 2
                                },
                                get slidesToScroll() {
                                    if (e.hasClass("sections-has-banner")) return this.slidesToScroll = 2;
                                    if (o >= 3) return this.slidesToScroll = 3;
                                    return this.slidesToScroll = 2
                                }
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: !1,
                                dots: !0
                            }
                        }]
                    })
                })
            },
            initProductReview: function() {
                setInterval(function() {
                    if (!t(".spr-reviews").hasClass("slick-initialized") && t(".product-template-skin-1").length) {
                        if (t(".spr-reviews").find(".spr-review").length) {
                            var e = t(".spr-reviews");
                            e.slick({
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                get arrows() {
                                    if ("layout_style_fullwidth" == window.layout_style) return this.arrows = !0;
                                    return this.arrows = !1
                                },
                                get dots() {
                                    if ("layout_style_fullwidth" == window.layout_style) return this.dots = !1;
                                    return this.dots = !0
                                },
                                infinite: !0,
                                speed: 1e3,
                                get centerMode() {
                                    if ("layout_style_flower" == window.layout_style) return this.centerMode = !1;
                                    return this.centerMode = !0
                                },
                                centerPadding: "20%",
                                get nextArrow() {
                                    if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                    if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                    return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                                },
                                get prevArrow() {
                                    if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                    if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                    return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                                },
                                responsive: [{
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                }, {
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }, {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1,
                                        centerMode: !1
                                    }
                                }]
                            }), e.find(".spr-review").each(function() {
                                t(this).find(".spr-review-header-byline").appendTo(t(this).find(".spr-review-footer")), e.find(".spr-pagination").remove()
                            })
                        }
                    } else if (t(".product-template-surfup").length && 0 == t(".spr-review-header .spr-review-footer").length) {
                        var e = t(".spr-reviews");
                        e.find(".spr-review").each(function() {
                            t(this).find(".spr-review-footer").appendTo(t(this).find(".spr-review-header"))
                        })
                    }
                }, 1e3)
            },
            initProductVideo: function() {
                t("[data-load-video]").length && (t("[data-load-video]").on("click", function(e) {
                    if (e.preventDefault(), e.stopPropagation(), t(this).hide(), t(this).next(".fluid-width-video-wrapper").show(), t(this).next(".fluid-width-video-wrapper").find("video").length) t(this).next(".fluid-width-video-wrapper").find("video").get(0).play();
                    else {
                        var a, o;
                        a = t(this).next(".fluid-width-video-wrapper").find("iframe").get(0), o = {
                            event: "command",
                            func: "playVideo"
                        }, null != a && null != o && a.contentWindow.postMessage(JSON.stringify(o), "*")
                    }
                }), t(".custom-block-banner .fluid-width-video-wrapper").on("click", function(e) {
                    t(this).hasClass("autoplay") ? (t(this).find("video").get(0).play(), t(this).removeClass("autoplay")) : (t(this).find("video").get(0).pause(), t(this).addClass("autoplay"))
                }))
            },
            initCountdown: function() {
                t("[data-countdown]").each(function() {
                    var e = t(this),
                        a = e.data("countdown-value");
                    e.countdown(a, function(e) {
                        t(this).html(e.strftime('<div class="clock-item"><span class="num">%D</span><span>' + window.inventory_text.days + '</span></div><div class="clock-item"><span class="num">%H</span><span>' + window.inventory_text.hours + '</span></div><div class="clock-item"><span class="num">%M</span><span>' + window.inventory_text.mins + '</span></div><div class="clock-item"><span class="num">%S</span><span>' + window.inventory_text.secs + "</span></div>"))
                    })
                })
            },
            initCountdownNormal: function() {
                t("[data-countdown-normal]").each(function() {
                    var e = t(this),
                        a = e.data("countdown-value");
                    e.hasClass("countdown-suppermarket") ? "supermarket" == window.product_style ? e.countdown(a, function(e) {
                        t(this).html(e.strftime('<div class="clock-item"><span class="num">%D</span><span>:</span></div><div class="clock-item"><span class="num">%H</span><span>:</span></div><div class="clock-item"><span class="num">%M</span><span>:</span></div><div class="clock-item"><span class="num">%S</span></div>'))
                    }) : e.countdown(a, function(e) {
                        t(this).html(e.strftime('<div class="clock-item"><span class="num">%D</span><span>d</span></div><div class="clock-item"><span class="num">%H</span>&nbsp;:</div><div class="clock-item"><span class="num">%M</span>&nbsp;:</div><div class="clock-item"><span class="num">%S</span></div>'))
                    }) : "supermarket" == window.product_style ? e.countdown(a, function(e) {
                        t(this).html(e.strftime('<div class="clock-item"><span class="num">%D</span><span> days</span></div><div class="clock-item"><span class="num">%H</span>&nbsp;:</div><div class="clock-item"><span class="num">%M</span>&nbsp;:</div><div class="clock-item"><span class="num">%S</span></div>'))
                    }) : e.countdown(a, function(e) {
                        t(this).html(e.strftime('<div class="clock-item"><span class="num">%D</span><span>D</span>:</div><div class="clock-item"><span class="num">%H</span><span>H</span>:</div><div class="clock-item"><span class="num">%M</span><span>M</span>:</div><div class="clock-item"><span class="num">%S</span><span>S</span></div>'))
                    })
                })
            },
            initToggleSubMenuMobile: function() {
                var e = t(".main-menu.jas-mb-style");
                t(".site-nav").find("[data-toggle-menu-mb]").off("click.dropdownMenu").on("click.dropdownMenu", function(a) {
                    a.preventDefault(), a.stopPropagation();
                    var o = t(this).parent().next(".sub-menu-mobile");
                    t(".header-bottom .header-mb").is(":visible") && (o.hasClass("sub-menu-open") ? o.removeClass("sub-menu-open") : (o.addClass("sub-menu-open").css({
                        overflow: ""
                    }), e.animate({
                        scrollTop: 0
                    }, 0), e.css({
                        overflow: "hidden"
                    })))
                }), f.linkClickToggleSubMenuMobile(e)
            },
            linkClickToggleSubMenuMobile: function(e) {
                var a = t(".site-nav .dropdown"),
                    o = a.find("[data-toggle-menu-mb]"),
                    n = t(".sub-menu-mobile .menu-mb-title");
                o.length && (i.off("click.current").on("click.current", ".site-nav .dropdown", function(a) {
                    a.stopPropagation(), t(".header-bottom .header-mb").is(":visible") && (t(this).children(".sub-menu-mobile").addClass("sub-menu-open").css({
                        overflow: ""
                    }), e.animate({
                        scrollTop: 0
                    }, 0), window.innerWidth < 1200 && e.css({
                        overflow: "hidden"
                    }))
                }), a.find(".menu__moblie").on("click", function(t) {
                    t.stopPropagation()
                }), n.off("click.closeMenu").on("click.closeMenu", function(a) {
                    a.preventDefault(), a.stopPropagation(), t(this).parent().hasClass("bg") ? t(this).parent().parent().removeClass("sub-menu-open") : t(this).parent().removeClass("sub-menu-open"), t(this).closest(".menu-lv-2").length || e.css({
                        overflow: ""
                    })
                }))
            },
            openEmailModalWindow: function(t) {
                t.fadeIn(1e3)
            },
            closeEmailModalWindow: function(e, a) {
                e.fadeOut(1e3), (e.find('input[name="dismiss"]').prop("checked") || !e.find('input[name="dismiss"]').length) && t.cookie("emailSubcribeModal", "closed", {
                    expires: a,
                    path: "/"
                })
            },
            initNewsLetterPopup: function() {
                if (window.newsletter_popup) {
                    var e = t("[data-newsletter]"),
                        a = e.find(".close-window"),
                        o = e.data("delay"),
                        i = e.data("expire"),
                        n = e.find(".halo-modal-content");
                    "closed" != t.cookie("emailSubcribeModal") && !1 == window.hidden_newsletter && (f.ellaTimeout = setTimeout(function() {
                        f.openEmailModalWindow(e)
                    }, o)), t("[data-toolbar-newsletter]").length && t("[data-modal-newsletter]").on("click", function() {
                        f.openEmailModalWindow(e)
                    }), a.click(function(t) {
                        t.preventDefault(), f.closeEmailModalWindow(e, i)
                    }), e.on("click", function(t) {
                        n.is(t.target) || n.has(t.target).length || f.closeEmailModalWindow(e, i)
                    }), t("#mc_embed_signup form").submit(function() {
                        "" != t("#mc_embed_signup .email").val() && f.closeEmailModalWindow(e, i)
                    })
                }
            },
            initSidebarProductSlider: function() {
                t("[data-sidebar-product]").each(function() {
                    var e = t(this).find(".products-grid");
                    e.not(".slick-initialized") && e.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: !1,
                        speed: 800,
                        get dots() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.dots = !0;
                            return this.dots = !1
                        },
                        get arrows() {
                            if ("layout_style_suppermarket" == window.layout_style) return this.arrows = !1;
                            return this.arrows = !0
                        },
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        }
                    })
                })
            },
            initOpenSidebar: function() {
                var e = ".sidebar-label";
                t(e).length && i.off("click.openSidebar").on("click.openSidebar", e, function() {
                    s.addClass("sidebar-open")
                })
            },
            closeSidebar: function() {
                f.closeTranslate(".sidebar .close-sidebar", "sidebar-open")
            },
            initSidebar: function() {
                this.initSidebarProductSlider(), this.initOpenSidebar(), this.closeSidebar(), this.initDropdownSubCategoriesAtSidebar(), this.initToggleWidgetTitleSidebarFilter()
            },
            initDropdownSubCategoriesAtSidebar: function() {
                i.off("click.toggleSubCategories").on("click.toggleSubCategories", ".sidebar-links li.dropdown", function(e) {
                    e.stopPropagation();
                    var a = t(this),
                        o = a.find("> .dropdown-cat");
                    a.hasClass("open") ? (a.removeClass("open"), o.slideUp()) : (a.addClass("open"), o.slideDown())
                }), i.off("click.linktoCollection").on("click.linktoCollection", ".sidebar-links li.dropdown a", function(t) {
                    t.stopPropagation()
                })
            },
            historyAdapter: function() {
                t('[data-section-type="collection-template"]').length && History.Adapter.bind(window, "statechange", function() {
                    if (History.getState(), !f.isSidebarAjaxClick) {
                        f.queryParams();
                        var t = f.ajaxCreateUrl();
                        f.doAjaxToolbarGetContent(t), f.doAjaxSidebarGetContent(t)
                    }
                    f.isSidebarAjaxClick = !1
                })
            },
            queryParams: function() {
                if (Shopify.queryParams = {}, location.search.length)
                    for (var t, e = 0, a = location.search.substr(1).split("&"); e < a.length; e++)(t = a[e].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]))
            },
            filterAjaxClick: function(t) {
                delete Shopify.queryParams.page;
                var e = f.ajaxCreateUrl(t);
                f.isSidebarAjaxClick = !0, History.pushState({
                    param: Shopify.queryParams
                }, e, e)
            },
            ajaxCreateUrl: function(e) {
                var a = t.param(Shopify.queryParams).replace(/%2B/g, "+");
                return e ? "" != a ? e + "?" + a : e : location.pathname + "?" + a
            },
            filterToolbar: function() {
                this.queryParams(), this.setTextForLimitedFilter(), this.ajaxFilterSortby(), this.ajaxFilterLimit(), this.addEventViewModeLayout()
            },
            setTextForSortbyFilter: function() {
                var e = t("[data-sortby]"),
                    a = e.find(".label-tab"),
                    o = a.find(".label-text"),
                    i = a.next().find("li.active").text();
                if (o.text(i), Shopify.queryParams.sort_by) {
                    var n = Shopify.queryParams.sort_by,
                        s = e.find('span[data-href="' + n + '"]'),
                        r = s.text();
                    o.text(r), a.next().find("li").removeClass("active"), s.parent().addClass("active")
                }
            },
            setTextForLimitedFilter: function() {
                var e = t("[data-limited-view]"),
                    a = e.find(".label-tab"),
                    o = a.find(".label-text"),
                    i = a.next().find("li.active").text();
                if (o.text(i), e.length) {
                    var n = e.find("li.active span").data("value"),
                        s = e.find('span[data-value="' + n + '"]'),
                        r = s.text();
                    o.text(r), a.next().find("li").removeClass("active"), s.parent().addClass("active")
                }
            },
            ajaxFilterSortby: function() {
                var e = "[data-sortby] li span",
                    a = t(e);
                i.off("click.sortBy", e).on("click.sortBy", e, function(e) {
                    if (e.preventDefault(), e.stopPropagation(), !t(this).parent().hasClass("active")) {
                        Shopify.queryParams.sort_by = t(this).attr("data-href"), f.filterAjaxClick();
                        var o = f.ajaxCreateUrl();
                        f.doAjaxToolbarGetContent(o)
                    }
                    a.closest(".dropdown-menu").prev().trigger("click")
                })
            },
            ajaxFilterLimit: function() {
                var e = "[data-limited-view] li span",
                    a = t(e);
                i.off("click.sortBy", e).on("click.sortBy", e, function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var o = t(this);
                    if (!o.parent().hasClass("active")) {
                        var i = "" + o.data("value");
                        t("[data-limited-view] .label-tab .label-text").text(i), f.doAjaxLimitGetContent(i)
                    }
                    a.closest(".dropdown-menu").prev().trigger("click")
                })
            },
            doAjaxLimitGetContent: function(e) {
                f.isAjaxLoading || t.ajax({
                    type: "Post",
                    url: "/cart.js",
                    data: {
                        "attributes[pagination]": e
                    },
                    success: function(t) {
                        window.location.reload()
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    dataType: "json"
                })
            },
            doAjaxToolbarGetContent: function(e) {
                f.isAjaxLoading || t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        f.ajaxMapData(e), f.initColorSwatchGrid(), f.setTextForSortbyFilter(), f.initSidebarProductSlider(), f.initCountdownNormal(), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading()
                    }
                })
            },
            filterSidebar: function() {
                this.queryParams(), this.ajaxFilterTags(), this.ajaxFilterClearTags(), this.ajaxFilterClearAll()
            },
            ajaxFilterTags: function() {
                i.off("click.filterTags").on("click.filterTags", ".sidebar-tags .list-tags a, .sidebar-tags .list-tags label, .refined .selected-tag", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = [];
                    if (Shopify.queryParams.constraint && (a = Shopify.queryParams.constraint.split("+")), !window.enable_sidebar_multiple_choice && !t(this).prev().is(":checked")) {
                        var o = t(this).closest(".sidebar-tags, .refined-widgets").find("input:checked");
                        if (o.length) {
                            var i = o.val();
                            if (i) {
                                var n = a.indexOf(i);
                                n >= 0 && a.splice(n, 1)
                            }
                        }
                    }
                    var i = t(this).prev().val();
                    if (i) {
                        var n = a.indexOf(i);
                        n >= 0 ? a.splice(n, 1) : a.push(i)
                    }
                    a.length ? Shopify.queryParams.constraint = a.join("+") : delete Shopify.queryParams.constraint, f.filterAjaxClick();
                    var s = f.ajaxCreateUrl();
                    f.doAjaxSidebarGetContent(s)
                })
            },
            ajaxFilterClearTags: function() {
                t(".sidebar-tags").each(function() {
                    var e = t(this);
                    e.find("input:checked").length && e.find(".clear").show().click(function(a) {
                        a.preventDefault(), a.stopPropagation();
                        var o = [];
                        Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")), e.find("input:checked").each(function() {
                            var e = t(this).val();
                            if (e) {
                                var a = o.indexOf(e);
                                a >= 0 && o.splice(a, 1)
                            }
                        }), o.length ? Shopify.queryParams.constraint = o.join("+") : delete Shopify.queryParams.constraint, f.filterAjaxClick();
                        var i = f.ajaxCreateUrl();
                        f.doAjaxSidebarGetContent(i)
                    })
                })
            },
            ajaxFilterClearAll: function() {
                var e = ".refined-widgets a.clear-all";
                t(e), i.off("click.clearAllTags", e).on("click.clearAllTags", e, function(t) {
                    t.preventDefault(), t.stopPropagation(), delete Shopify.queryParams.constraint, f.filterAjaxClick();
                    var e = f.ajaxCreateUrl();
                    f.doAjaxSidebarGetContent(e)
                })
            },
            doAjaxSidebarGetContent: function(e) {
                f.isAjaxLoading || t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        f.ajaxMapData(e), f.initColorSwatchGrid(), f.ajaxFilterClearTags(), f.initMasonry(), f.initSidebarProductSlider(), f.initCountdownNormal(), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading()
                    }
                })
            },
            ajaxMapData: function(e) {
                var a = t(".collection-template"),
                    o = a.find(".breadcrumb"),
                    i = a.find(".column-left .breadcrumb"),
                    n = a.find(".sidebar"),
                    s = a.find(".collection-header"),
                    r = a.find(".product-collection"),
                    l = a.find(".padding"),
                    d = a.find(".append--toolbar"),
                    c = a.find(".refined-widgets--surfup"),
                    p = t(e).find(".collection-template"),
                    u = p.find(".breadcrumb"),
                    _ = p.find(".column-left .breadcrumb"),
                    g = p.find(".sidebar"),
                    h = p.find(".collection-header"),
                    v = p.find(".product-collection"),
                    m = p.find(".padding"),
                    y = p.find(".refined-widgets--surfup");
                if ("supermarket" == window.category_style ? i.replaceWith(_) : o.replaceWith(u), n.replaceWith(g), s.replaceWith(h), r.replaceWith(v), c.replaceWith(y), l.length > 0 ? l.replaceWith(m) : a.find(".col-main").length ? a.find(".col-main").append(m) : a.find(".col-no-sidebar").append(m), d.length > 0 && "" != d.html() && t(".sidebar .append--toolbar").replaceWith(d), f.translateBlock(".collection-template"), f.hide_filter(), f.initWishListIcons(), f.subCollectionSlider(), t("[data-view-as]").length && f.viewModeLayout(), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
            },
            initToggleWidgetTitleSidebarFilter: function() {
                var e = ".sidebar-label-desktop";
                i.off("click.toggleWidgetContent").on("click.toggleWidgetContent", "[data-has-collapse] .widget-title", function() {
                    t(this).toggleClass("open"), t(this).next().slideToggle()
                });
                var a = "[data-has-collapse-no-sidebar] .widget-title",
                    o = t(".toolbar");
                if (1200 > r.innerWidth()) {
                    i.off("click.toggleWidgetContent2").on("click.toggleWidgetContent2", a, function() {
                        t(this).toggleClass("open"), t(this).next().slideToggle()
                    }), 992 > r.innerWidth() ? t(".filters-toolbar__sortby").insertAfter(".column-left .sidebar-label") : t(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
                    var n = o.outerHeight() + 30,
                        s = o.offset().top;
                    t(window).scroll(function() {
                        var e = t(".sticky-wrapper.is-sticky").outerHeight();
                        t(this).scrollTop() > s ? (t('[data-section-type="collection-template"]').css("padding-top", n), o.addClass("toolbar-fix"), o.css("top", e),o.css("--top", e)) : (t('[data-section-type="collection-template"]').css("padding-top", 0), o.removeClass("toolbar-fix"), o.css("top", 0))
                    })
                } else t(".filters-toolbar__sortby").appendTo(".toolbar .column-right"), t('[data-section-type="collection-template"]').css("padding-top", 0), o.removeClass("toolbar-fix"), o.css("top", 0), t(".collection-template-skin-1").length && (t(".toolbar").appendTo(".appendTo-toolbar .container"), i.off("click.toggleSidebar").on("click.toggleSidebar", e, function() {
                    t(this).parents(".halo-collection-content").toggleClass("remove-sidebar")
                })), t(".toolbar").length && !t(".toolbar").hasClass("different-toolbar") && t(".toolbar").appendTo(".append--toolbar");
                r.resize(function() {
                    1200 > r.innerWidth() ? (i.off("click.toggleWidgetContent2").on("click.toggleWidgetContent2", a, function() {
                        t(this).toggleClass("open"), t(this).next().slideToggle()
                    }), 992 > r.innerWidth() ? t(".filters-toolbar__sortby").insertAfter(".column-left .sidebar-label") : t(".filters-toolbar__sortby").appendTo(".toolbar .column-right")) : (t(".filters-toolbar__sortby").appendTo(".toolbar .column-right"), t('[data-section-type="collection-template"]').css("padding-top", 0), o.removeClass("toolbar-fix"), o.css("top", 0), t(window).scroll(function() {
                        o.removeClass("toolbar-fix")
                    }), t(".collection-template-skin-1").length && (t(".toolbar").appendTo(".appendTo-toolbar .container"), i.off("click.toggleSidebar").on("click.toggleSidebar", e, function() {
                        t(this).parents(".halo-collection-content").toggleClass("remove-sidebar")
                    })), t(".toolbar").length && !t(".toolbar").hasClass("different-toolbar") && t(".toolbar").appendTo(".append--toolbar"))
                }), i.off("click.viewMoreFilter").on("click.viewMoreFilter", "[data-list-filter]", function() {
                    var e = t(this).parents(".list-tags").find(".last");
                    t(this).parents(".list-tags").hasClass("show-all") ? (e.hide(), t(this).text(window.inventory_text.view_more)) : (e.show(), t(this).text(window.inventory_text.view_less)), t(this).parents(".list-tags").toggleClass("show-all")
                })
            },
            initInfiniteScrolling: function() {
                var e = t(".infinite-scrolling"),
                    a = ".infinite-scrolling a";
                e.length && (i.off("click.initInfiniteScrolling", a).on("click.initInfiniteScrolling", a, function(e) {
                    if (e.preventDefault(), e.stopPropagation(), !t(this).hasClass("disabled")) {
                        var a = t(this).data("href");
                        f.doAjaxInfiniteScrollingGetContent(a)
                    }
                }), window.infinity_scroll_feature && t(window).scroll(function() {
                    if (!f.isAjaxLoading) {
                        var e = t('[data-section-type="collection-template"]');
                        e.length || (e = t("[data-search-page]"));
                        var o, i = e.offset().top + e.outerHeight() - t(window).height();
                        if (t(this).scrollTop() > i && t(this).scrollTop() < i + 200) {
                            var n = t(a);
                            if (n.length && !n.hasClass("disabled")) {
                                var s = n.data("href");
                                f.doAjaxInfiniteScrollingGetContent(s)
                            }
                        }
                    }
                }))
            },
            doAjaxInfiniteScrollingGetContent: function(e) {
                f.isAjaxLoading || t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        f.ajaxInfiniteScrollingMapData(e), f.initColorSwatchGrid(), t("[data-view-as]").length && f.viewModeLayout(), f.initCountdownNormal(), f.stickySidebar(), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading();
                        var e = 0,
                            a = t(".product-collection .grid-item .product-label").data("label-new-number");
                        t(".product-collection .grid-item").each(function(o) {
                            t(this).find(".new-label").length && e++, e > a && (t(this).find(".new-label").hide(), t(this).find(".new-label+br").hide())
                        });
                      globoswatch?.init();
                    }
                })
            },
            ajaxInfiniteScrollingMapData: function(e) {
                var a = t(".collection-template"),
                    o = a.find(".product-collection"),
                    i = a.find(".padding"),
                    n = t(e).find(".collection-template"),
                    s = n.find(".product-collection"),
                    r = n.find(".padding"),
                    l = s.children(".grid-item").not(".banner-img");
                if (t(".infinite-scrolling a"), i.replaceWith(r), s.length && (o.append(l), t(".collection-template .product-collection[data-layout]").length && (f.ellaTimeout = setTimeout(function() {
                        o.isotope("appended", l).isotope("layout")
                    }, 700)), f.translateBlock(".product-collection"), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length)) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
            },
            addEventViewModeLayout: function() {
                t("#shopify-section-collection-template-suppermarket").length || f.setActiveViewModeMediaQuery(), i.on("click", ".view-mode .icon-mode", function(e) {
                    e.preventDefault();
                    var a = t(this),
                        o = (a.data("col"), a.closest("[data-view-as]"));
                    !a.hasClass("active") && (o.find(".icon-mode").removeClass("active"), a.addClass("active"), f.viewModeLayout(), f.initMasonry(), window.innerWidth > 767 && t(".product-collection").find("img").removeClass("lazyautosizes ls-is-cached lazyloaded").addClass("lazyload"))
                })
            },
            viewModeLayout: function() {
                var e = t("[data-view-as]").find(".icon-mode.active").data("col"),
                    a = t(".collection-template .product-collection"),
                    o = a.find(".grid-item"),
                    i = "col-12 col-6 col-md-4 col-lg-3 col5",
                    n = "grid-2 grid-3 grid-4 grid-5 products-grid products-list";
                if (1 === e) o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-list") : a.removeClass("products-grid").addClass("products-list"), o.removeClass(i).addClass("col-12");
                else switch (e) {
                    case 2:
                        o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6");
                        break;
                    case 3:
                        o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4");
                        break;
                    case 4:
                        o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4 col-lg-3");
                        break;
                    case 5:
                        o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4 col-lg-3 col5")
                }
                f.initMasonry()
            },
            setActiveViewModeMediaQuery: function() {
                var e = t("[data-view-as]"),
                    a = e.find(".icon-mode.active"),
                    o = a.data("col"),
                    i = window.innerWidth;
                i < 768 ? (3 === o || 4 == o || 5 == o) && (a.removeClass("active"), t('[data-col="2"]').addClass("active")) : i < 992 && i >= 768 ? (4 == o || 5 == o) && (a.removeClass("active"), t('[data-col="3"]').addClass("active")) : i < 1200 && i >= 992 && 5 == o && (a.removeClass("active"), t('[data-col="4"]').addClass("active")), e.length && f.viewModeLayout()
            },
            initPaginationPage: function() {
                var e = ".pagination-page a";
                i.off("click", e).on("click", e, function(e) {
                    if (Shopify.queryParams) {
                        e.preventDefault();
                        var a = t(this).attr("href").match(/page=\d+/g);
                        if (a && (Shopify.queryParams.page = parseInt(a[0].match(/\d+/g)), Shopify.queryParams.page)) {
                            var o = f.ajaxCreateUrl();
                            f.isSidebarAjaxClick = !0, History.pushState({
                                param: Shopify.queryParams
                            }, o, o), f.doAjaxToolbarGetContent(o);
                            var i = t('[data-section-type="collection-template"]');
                            i.length || (i = t("[data-search-page]"));
                            var n = i.offset().top;
                            t("body,html").animate({
                                scrollTop: n
                            }, 600)
                        }
                    }
                })
            },
            changeSwatchEditCart: function() {
                t("[data-template-cart-edit] .swatch :radio").on("change", function(e) {
                    var a, o = t(this),
                        i = t(this).parents(".product-edit"),
                        n = i.data("product-handle");
                    t(this).data("image");
                    var s = i.data("cart-edit-id"),
                        r = window.productVariants[s],
                        l = o.closest("[data-option-index]").data("option-index"),
                        d = i.find(".swatch-element"),
                        c = o.val(),
                        p = i.find("[name=id]"),
                        u = i.find('[data-option-index="0"]').find("input:checked").val(),
                        _ = i.find('[data-option-index="1"]').find("input:checked").val();
                    switch (i.find('[data-option-index="2"]').find("input:checked").val(), d.removeClass("soldout"), d.find(":radio").prop("disabled", !1), l) {
                        case 0:
                            var g = r.find(function(t) {
                                return t.option1 == c && t.option2 == _ && t.available
                            });
                            a = void 0 != g ? g : r.find(function(t) {
                                return t.option1 == c && t.available
                            });
                            break;
                        case 1:
                            var g = r.find(function(t) {
                                return t.option1 == u && t.option2 == c && t.available
                            });
                            void 0 != g && (a = g);
                            break;
                        case 2:
                            var g = r.find(function(t) {
                                return t.option1 == u && t.option2 == _ && t.option3 == c && t.available
                            });
                            void 0 != g ? a = g : console.log("Bundle Error: variant was soldout, on option selection #3")
                    }
                    p.val(a.id), i.find(".option").text(a.public_title), i.find(".price").html(Shopify.formatMoney(a.price, window.money_format)), a.compare_at_price > a.price ? (i.find(".prices").addClass("special-price"), i.find(".compare-price").html(Shopify.formatMoney(a.compare_at_price, window.money_format)).show()) : (i.find(".compare-price").hide(), i.find(".prices").removeClass("special-price")), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), f.disableSoldoutSwatchEdit(i), a.featured_image && i.find("#product-featured-image").attr("src", a.featured_image.src);
                    var h = t(this).val();
                    t(this).parents(".swatch").find("[data-header-option]").text(h), t.ajax({
                        url: "/products/" + n + "?view=cart_edit",
                        success: function(e) {
                            var o = t(e).find(".get_script_content").data("array_json").filter(function(t) {
                                return parseInt(t.id) === a.id
                            });
                            i.find('[name="quantity"]').attr("data-line", o[0].value)
                        }
                    }), t(".error-message-input").text("")
                }), t("[data-template-cart-edit] .single-option-selector").on("change", function() {
                    var e, a = t(this),
                        o = t(this).parents(".product-edit"),
                        i = o.data("product-handle"),
                        n = o.data("cart-edit-id"),
                        s = window.productVariants[n],
                        r = a.data("option"),
                        l = a.val(),
                        d = o.find("[name=id]"),
                        c = o.find('[data-option="option1"]').val(),
                        p = o.find('[data-option="option2"]').val();
                    switch (o.find('[data-option="option3"]').val(), r) {
                        case "option1":
                            var u = s.find(function(t) {
                                return t.option1 == l && t.option2 == p && t.available
                            });
                            e = void 0 != u ? u : s.find(function(t) {
                                return t.option1 == l && t.available
                            });
                            break;
                        case "option2":
                            var u = s.find(function(t) {
                                return t.option1 == c && t.option2 == l && t.available
                            });
                            void 0 != u && (e = u);
                            break;
                        case "option3":
                            var u = s.find(function(t) {
                                return t.option1 == c && t.option2 == p && t.option3 == l && t.available
                            });
                            void 0 != u && (e = u)
                    }
                    d.val(e.id), o.find(".price").html(Shopify.formatMoney(e.price, window.money_format)), e.compare_at_price > e.price ? (o.find(".prices").addClass("special-price"), o.find(".compare-price").html(Shopify.formatMoney(e.compare_at_price, window.money_format)).show()) : (o.find(".compare-price").hide(), o.find(".prices").removeClass("special-price")), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), o.find(".option").text(e.public_title), e.featured_image && o.find("#product-featured-image").attr("src", e.featured_image.src), t.ajax({
                        url: "/products/" + i + "?view=cart_edit",
                        success: function(a) {
                            var i = t(a).find(".get_script_content").data("array_json").filter(function(t) {
                                return parseInt(t.id) === e.id
                            });
                            o.find('[name="quantity"]').attr("data-line", i[0].value)
                        }
                    }), t(".error-message-input").text("")
                })
            },
            editCart: function() {
                f.isAjaxLoading || i.off("click.editcart").on("click.editcart", "[data-cart-edit]", function(e) {
                    var a = t(this).data("url"),
                        o = t(this).data("id"),
                        i = t(this).data("quantity");
                    t.ajax({
                        type: "get",
                        url: a,
                        cache: !1,
                        dataType: "html",
                        beforeSend: function() {
                            f.showLoading(), s.css({
                                overflow: "hidden"
                            })
                        },
                        success: function(e) {
                            var a = t("[data-cart-edit-modal]");
                            a.find(".halo-modal-body").html(e), t("#product-edit").find('input[name="quantity"]').val(i), setTimeout(function() {
                                f.translateBlock("[data-template-cart-edit]"), f.updateCartEdit(o), f.addMoreCart(), f.closeSuccessModal(), f.changeSwatchEditCart(), f.disableSoldoutSwatchEdit(t("#product-edit"))
                            }, 500), t(".product-edit .swatch").each(function() {
                                var e = t(this).find("input:checked").val();
                                t(this).find("[data-header-option]").text(e)
                            }), f.hideLoading(), a.fadeIn(600)
                        },
                        error: function(t, e) {
                            f.hideLoading()
                        }
                    })
                })
            },
            addMoreCart: function() {
                var e = t("[data-addmore]"),
                    a = "[data-remove-cart]";
                t(e).off("click").on("click", function(e) {
                    e.preventDefault(), e.stopPropagation(), t(".error-message-input").text("");
                    var a = t(".product-edit:eq(1)").clone(),
                        o = t(".product-edit").length;
                    a[0].id = "product-edit-" + o, t(a).find(".swatch-element").each(function() {
                        var e = t(this).find('[name="option-0"]').attr("id"),
                            a = t(this).find('[name="option-1"]').attr("id"),
                            i = t(this).find('[name="option-2"]').attr("id");
                        t(this).find('[name="option-0"]').attr("name", "list-" + o + "-option-0").attr("id", "list-" + o + "-" + e), t(this).find('[name="option-1"]').attr("name", "list-" + o + "-option-1").attr("id", "list-" + o + "-" + a), t(this).find('[name="option-2"]').attr("name", "list-" + o + "-option-2").attr("id", "list-" + o + "-" + i), t(this).find('[data-label="swatch-edit-cart-0"]').attr("for", "list-" + o + "-" + e), t(this).find('[data-label="swatch-edit-cart-1"]').attr("for", "list-" + o + "-" + a), t(this).find('[data-label="swatch-edit-cart-2"]').attr("for", "list-" + o + "-" + i)
                    }), t(a).insertBefore("[data-template-cart-edit] form .cart-meta--action"), t("#product-edit-" + o).find('input[name="quantity"]').val(1), t("#product-edit-" + o + " .swatch").each(function() {
                        var e = t(this).find("input:checked").val();
                        t(this).find("[data-header-option]").text(e)
                    }), f.changeSwatchEditCart(), !1 == window.use_color_swatch && Shopify.linkOptionSelectors(window._json, "#product-edit-" + o, !0)
                }), i.off("click.removeItemCart", a).on("click.removeItemCart", a, function(e) {
                    t(this).parents(".product-edit").remove()
                })
            },
            updateCartEdit: function(e) {
                var a = t("[data-update-cart-edit]");
                t(a).off("click").on("click", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this);
                    if ("disabled" !== a.attr("disabled")) {
                        var o = a.closest("[data-template-cart-edit]").find("form").find(".product-edit"),
                            n = [],
                            s = !1;
                        o.not(".first").each(function() {
                            t(this).find('[name="id"]').val();
                            var e = parseInt(t(this).find('input[name="quantity"]').val()),
                                a = parseInt(t(this).find('input[name="quantity"]').data("line"));
                            e > a && a > 0 ? (s = !0, t(this).find(".error-message-input").html('<i class="fa fa-exclamation-circle"></i>' + window.inventory_text.warning_quantity + ": " + a)) : t(this).find(".error-message-input").text("")
                        }), !1 == s && (o.each(function() {
                            var e, a = t(this).find('[name="id"]').val(),
                                o = parseInt(t(this).find('input[name="quantity"]').val()),
                                i = parseInt(t(this).find('input[name="quantity"]').data("line")),
                                s = "";
                            s = o < 1 ? window.router + "/cart/change.js" : window.router + "/cart/add.js", i < o && i > 0 && (o = i), n.push((e = {
                                type: "post",
                                url: s,
                                data: "quantity=" + o + "&id=" + a,
                                dataType: "json",
                                async: !1
                            }, t.ajax(e)))
                        }), n.length && t.when.apply(this, n).done(function(e) {
                            f.updateDropdownCart(), i.hasClass("template-cart") && f.loadAjaxCart(), t("[data-cart-edit-modal] .close-modal").trigger("click")
                        }), f.getPopupShoppingCart(!1, void 0))
                    }
                })
            },
            disableSoldoutSwatchEdit: function(e) {
                var a = e.data("cart-edit-id"),
                    o = window.productVariants[a],
                    i = e.find("[data-option-index]"),
                    n = e.find('[data-option-index="0"]').find("input:checked").val(),
                    s = e.find('[data-option-index="1"]').find("input:checked").val();
                e.find('[data-option-index="2"]').find("input:checked").val(), i.each(function() {
                    var e = t(this).data("option-index"),
                        a = t(this).find(".swatch-element");
                    switch (e) {
                        case 0:
                            a.each(function() {
                                var e = t(this).data("value");
                                void 0 == o.find(function(t) {
                                    return t.option1 == e && t.available
                                }) ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0)) : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1))
                            });
                            break;
                        case 1:
                            a.each(function() {
                                var e = t(this).data("value");
                                void 0 == o.find(function(t) {
                                    return t.option1 == n && t.option2 == e && t.available
                                }) ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0)) : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1))
                            });
                            break;
                        case 2:
                            a.each(function() {
                                var e = t(this).data("value");
                                void 0 == o.find(function(t) {
                                    return t.option1 == n && t.option2 == s && t.option3 == e && t.available
                                }) ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0)) : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1))
                            })
                    }
                }), e.find('[data-option-index="1"]').find("input:checked").parents(".swatch-element").hasClass("soldout") && (e.find('[data-option-index="1"]').find(".available:not(.soldout)").eq("0").find("label").trigger("click"), e.find('[data-option-index="1"]').find(".available:not(.soldout)").eq("0").find("input").prop("checked", !0))
            },
            changeQuantityAddToCart: function() {
                var e = "[data-minus-quantity], [data-plus-quantity]",
                    a = (t(e), t(".update-cart--template"));
                n.on("click", e, function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.siblings('input[name="quantity"]').length > 0 ? a.siblings('input[name="quantity"]') : a.siblings('input[name="group_quantity"]');
                    a.closest("[data-item-id]").data("item-id"), o.length < 1 && (o = a.siblings('input[name="updates[]"]'));
                    var i = parseInt(o.val());
                    switch (!0) {
                        case a.hasClass("plus"):
                            i += 1;
                            break;
                        case a.hasClass("minus") && i > 0:
                            i -= 1
                    }
                    o.val(i), a.parent().find('[type="number"]').trigger("change")
                }), a.on("change", function() {
                    var e = t(this),
                        a = e.parents(".cart-product-item"),
                        o = e.data("line"),
                        i = e.val(),
                        n = t(a).data("item-id"),
                        s = a.find(".price");
                    o < i ? e.parent().css("border-color", "red") : (e.parent().css("border-color", "#cdcdcd"), f.doAjaxUpdateCart(n, i, o, s, a))
                }), t(".cart-form .remove ").on("click", function(e) {
                    e.preventDefault();
                    var a = t(this).parents(".cart-product-item"),
                        o = t(a).data("item-id");
                    Shopify.removeItem(o, function(e) {
                        f.doUpdateDropdownCart(e), f.initFreeShippingMessage(), t(a).remove(), t(".total .price").html(Shopify.formatMoney(e.total_price, window.money_format)), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t("#gift-wrapping").length && o == t("#gift-wrapping").data("gift-id") && t("#is-a-gift").show(), t(".cart_items ul li").children().length > 0 ? (t(".no-item-cart").hide(), t(".wrapper-cart-template").show()) : (t(".wrapper-cart-template").hide(), t(".no-item-cart").show())
                    })
                })
            },
            initFreeShippingMessage: function() {
                jQuery.getJSON("/cart.js", function(t) {
                    f.FreeShippingMessage(t)
                })
            },
            FreeShippingMessage: function(e) {
                var a = 0,
                    o = window.free_shipping_text.free_shipping_message_1,
                    i = window.free_shipping_text.free_shipping_message_2,
                    n = window.free_shipping_text.free_shipping_message_3,
                    s = window.free_shipping_text.free_shipping_message_4,
                    r = 0,
                    l = window.free_shipping_text.free_shipping_1,
                    d = window.free_shipping_color1,
                    c = window.free_shipping_color2,
                    p = window.free_shipping_color3,
                    u = parseInt(window.free_shipping_price) * ((window.Shopify && Shopify.currency && Shopify.currency.rate) ? parseFloat(Shopify.currency.rate) : 1);                window.multi_lang && translator.isLang2() && (o = window.lang2.cart.general.free_shipping_message_1, i = window.lang2.cart.general.free_shipping_message_2, n = window.lang2.cart.general.free_shipping_message_3, l = window.lang2.cart.general.free_shipping_1);
                var _ = parseInt(e.total_price) / 100,
                    g = Math.round(100 * _ / u);
                _ >= u ? a = 1 : (r = parseInt(u - _), o = i + " " + Shopify.formatMoney(100 * r, window.money_format) + " " + n + "<b>  " + s + " </b>", l = window.free_shipping_text.free_shipping_2), g >= 100 && (g = 100), 0 == g && f.checkItemsInDropdownCart();
                var h = p;
                g <= 30 ? h = d : g <= 70 && (h = c);
                let widthValue = g + '%';
                $('.progress-bar-mixed').css('--free-shipping-width', widthValue);
                if (g === 100) {
                $(document).find('.progress-bar-mixed').addClass('shipping-free');
                } else {
                $(document).find('.progress-bar-mixed').removeClass('shipping-free');
                }
                var v = '<div class="progress_shipping" role="progressbar" style="height: 15px; margin-top: 10px; margin-bottom: 10px;background-color: #e1dfd6;-webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);box-shadow: inset 0 1px 2px rgba(0,0,0,.1);">            <div class="progress-meter" style="position: relative;display: block;height: 100%;background-color: ' + h + ";text-align: center; line-height: 15px;color: #ffffff;width: " + g + '%; -webkit-animation: 2s linear 0s normal none infinite running progress-bar-stripes;animation: 2s linear 0s normal none infinite running progress-bar-stripes;background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,rgba(0,0,0,0) 25%,rgba(0,0,0,0) 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,rgba(0,0,0,0) 75%,rgba(0,0,0,0));background-image:linear-gradient(45deg, rgb(255 255 255) 25%, rgba(0, 0, 0, 0) 25%, rgb(0 0 0 / 0%) 50%, rgb(255 255 255) 50%, rgb(255 255 255 / 0%) 75%, rgb(0 0 0) 75%, rgb(0 0 0)); background-size: 40px 40px; transition: 0.9s linear; transition-property: width, background-color;">' + g + "%</div>            </div>";
                t(".free_shipping_progress").html(v), t(".free_shipping_massage1").html(o), t("#dropdown-cart .summary .free_shipping .text").html(l), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format")
            },
            doAjaxUpdateCart: function(e, a, o, i, n) {
                t(o).data("line");
                var s = parseFloat(i.data("price")) * a;
                parseFloat(i.data("price")), t.ajax({
                    type: "post",
                    url: "/cart/change.js",
                    data: "quantity=" + a + "&id=" + e,
                    dataType: "json",
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        if (0 == a && n.remove(), e.item_count < 1 && (t(".wrapper-cart-template").hide(), t(".no-item-cart").show()), i.html(Shopify.formatMoney(s, window.money_format)), t(".total .price").html(Shopify.formatMoney(e.total_price, window.money_format)), f.updateDropdownCart(), f.initFreeShippingMessage(), f.hideLoading(), e.cart_level_discount_applications.length > 0 && t("[data-cart-discount-wrapper]").length) {
                            var o = e.cart_level_discount_applications,
                                r = o[0].title,
                                l = o[0].total_allocated_amount;
                            console.log(l), t("[data-cart-discount-wrapper]").show(), t("[data-cart-discount-title]").text(r), t("[data-cart-discount-amount]").html(Shopify.formatMoney(l, window.money_format))
                        } else t("[data-cart-discount-wrapper]").hide()
                    },
                    error: function(t) {
                        f.hideLoading()
                    }
                })
            },
            toggleVariantsForExpressOrder: function() {
                n.on("click", "[data-toggle-variant]", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.data("target");
                    a.hasClass("show-options-btn") ? (a.text(window.inventory_text.hide_options), t(o).slideDown(700, function() {
                        a.addClass("hide-options-btn").removeClass("show-options-btn")
                    })) : (a.text(window.inventory_text.show_options), t(o).slideUp(700, function() {
                        a.addClass("show-options-btn").removeClass("hide-options-btn")
                    }))
                })
            },
            initExpressOrderAddToCart: function() {
                var e = "[data-express-addtocart]";
                n.off("click.addToCartExpress", e).on("click.addToCartExpress", e, function(e) {
                    e.preventDefault();
                    var a = t(this);
                    if ("disabled" != a.attr("disabled")) {
                        var o = a.closest(".product-item");
                        0 == o.length && (o = a.closest(".col-options"));
                        var i = o.find("form"),
                            n = i.find("select[name=id]").val();
                        n || (n = i.find("input[name=id]").val());
                        var s = o.find("input[name=quantity]");
                        0 == s.length && (s = o.siblings(".col-qtt").find("input[name=quantity]"));
                        var r = s.val();
                        r || (r = 1), 0 !== parseInt(r) ? "none" == window.ajax_cart ? i.submit() : (f.expressAjaxAddToCart(n, r, a, i), i.next(".feedback-text").show()) : i.next(".feedback-text").text("Quantity cannot be blank").show()
                    }
                    return !1
                })
            },
            expressAjaxAddToCart: function(e, a, o, i) {
                t.ajax({
                    type: "post",
                    url: "/cart/add.js",
                    data: "quantity=" + a + "&id=" + e,
                    dataType: "json",
                    beforeSend: function() {
                        window.setTimeout(function() {
                            o.text(window.inventory_text.adding + "...")
                        }, 100)
                    },
                    success: function(t) {
                        window.setTimeout(function() {
                            o.text(window.inventory_text.thank_you)
                        }, 600), window.setTimeout(function() {
                            o.text(window.inventory_text.add_more + "...")
                        }, 1e3), f.updateDropdownCart(), o.addClass("add_more"), i.next(".feedback-text").text(window.inventory_text.cart_feedback)
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal"), window.setTimeout(function() {
                            o.text(window.inventory_text.add_to_cart)
                        }, 400)
                    }
                })
            },
            initAddToCart: function() {
                var e = "[data-btn-addToCart]";
                n.off("click.addToCart", e).on("click.addToCart", e, function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = t(a.data("form-id")).serialize();
                    if ("disabled" !== a.attr("disabled")) {
                        var i = a.closest(".product-item");
                        if (i.length < 1) {
                            var n = a.closest('[data-section-type="product"]');
                            n.length || (n = a.closest(".quickview-tpl")), i = n.find(".product-shop")
                        }
                        var s = a.closest("form"),
                            r = i.find(".product-grid-image").data("collections-related") || n.data("collections-related");
                        switch (window.ajax_cart) {
                            case "none":
                                s.submit();
                                break;
                            case "normal":
                                var l = i.find(".product-title").html(),
                                    d = i.find(".product-grid-image img").attr("data-srcset");
                                d || (d = i.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") || i.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")), f.doAjaxAddToCartNormal(o, l, d), t("[data-compare-modal]").hide();
                                break;
                            case "cart-drawer":
                                var l = i.find(".product-title").html(),
                                d = i.find(".product-grid-image img").attr("data-srcset");
                                d || (d = i.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") || i.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")), f.doAjaxAddToCartDrawer(o, l, d), t("[data-compare-modal]").hide();
                                break;
                            case "upsell":
                                f.doAjaxAddToCart(o, r), t("[data-compare-modal]").hide()
                        }
                    }
                    return !1
                }), f.closeSuccessModal()
            },
            initGroupedAddToCart: function() {
                var e = "[data-grouped-addToCart]";
                f.changeVariantSelectOption(), n.off("click.GroupedAddToCart", e).on("click.GroupedAddToCart", e, function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = t(a.data("form-id")).serialize();
                    if ("disabled" !== a.attr("disabled")) {
                        var i = a.closest('[data-section-type="product"]'),
                            n = i.find(".product-shop"),
                            s = n.find('form[action="/cart/add"]'),
                            r = i.data("collections-related"),
                            l = s.find(".grouped-product");
                        Shopify.queue = [], l.each(function() {
                            variantId = t(this).find("input[type=hidden]").attr("value"), (quantity = parseInt(t(this).find("input[name=group_quantity]").val())) > 0 && "" !== variantId && Shopify.queue.push({
                                variantId: variantId,
                                quantity: parseInt(quantity, 10) || 0
                            })
                        }), Shopify.moveAlong = function() {
                            if (Shopify.queue.length) {
                                var t = Shopify.queue.shift();
                                Shopify.addItem(t.variantId, t.quantity, Shopify.moveAlong)
                            } else {
                                switch (window.ajax_cart) {
                                    case "none":
                                        s.submit();
                                        break;
                                    case "normal":
                                        var e = n.find(".product-title").html(),
                                            a = n.find(".product-grid-image img").attr("src");
                                        // a || (a = n.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") || n.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")), f.doAjaxAddToCartNormal(o, e, a);
                                        a || (a = n.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") || n.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src") || n.siblings(".product-photos").find(".thumb img:first").attr("src")), f.doAjaxAddToCartNormal(o, e, a);
                                        setTimeout(function() {
                                            checkGift()
                                        }, 3e3)
                                        break;
                                    case "cart-drawer":
                                        var e = n.find(".product-title").html(),
                                            a = n.find(".product-grid-image img").attr("src");
                                        a || (a = n.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") || n.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")), f.doAjaxAddToCartDrawer(o, e, a);
                                        break;
                                    case "upsell":
                                        f.doAjaxAddToCart(o, r)
                                }
                                return !1
                            }
                        }, Shopify.moveAlong()
                    }
                }), f.closeSuccessModal()
            },
            changeVariantSelectOption: function() {
                n.on("change", "[data-select-change-variant]", function() {
                    var e = t(this).val(),
                        a = t(this).find("option:selected").data("img"),
                        o = t(this).find("option:selected").data("price"),
                        i = t(this).closest(".grouped-product");
                    i.find("input[type=hidden]").val(e), i.find(".product-img img").attr({
                        src: a
                    }), i.find("[data-price-change]").html(Shopify.formatMoney(o, window.money_format)), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), ".grouped-product span.money", "money_format")
                })
            },
            closeSuccessModal: function() {
                var e = t("[data-ajax-cart-success], [data-quickview-modal], [data-compare-modal], [data-compare-message-modal]"),
                    a = t("[data-cart-edit-modal]"),
                    o = e.find(".close-modal, .continue-shopping"),
                    i = e.find(".halo-modal-content"),
                    n = a.find(".close-modal"),
                    r = a.find(".halo-modal-content");
                o.click(function(a) {
                    var o, i;
                    a.preventDefault(), e.fadeOut(500, function() {
                        s.removeClass("halo-modal-open"), s.css({
                            overflow: ""
                        })
                    }), t("[data-more-view-product-qv] .product-img-box .slider-for").find(".slick-current").find("iframe").length && (o = t(".slider-for").find(".slick-current").find("iframe").get(0), i = {
                        event: "command",
                        func: "pauseVideo"
                    }, null != o && null != i && o.contentWindow.postMessage(JSON.stringify(i), "*")), t("[data-more-view-product-qv] .product-img-box .slider-for").find(".slick-current").find("video").length && t(".slider-for").find(".slick-current").find("video").get(0).pause()
                }), e.on("click", function(a) {
                    if (!i.is(a.target) && !i.has(a.target).length) {
                        var o, n;
                        e.fadeOut(500, function() {
                            s.removeClass("halo-modal-open"), s.css({
                                overflow: ""
                            })
                        }), t("[data-more-view-product-qv] .product-img-box .slider-for").find(".slick-current").find("iframe").length && (o = t(".slider-for").find(".slick-current").find("iframe").get(0), n = {
                            event: "command",
                            func: "pauseVideo"
                        }, null != o && null != n && o.contentWindow.postMessage(JSON.stringify(n), "*")), t("[data-more-view-product-qv] .product-img-box .slider-for").find(".slick-current").find("video").length && t(".slider-for").find(".slick-current").find("video").get(0).pause()
                    }
                }), n.on("click", function(t) {
                    t.preventDefault(), a.fadeOut(500, function() {
                        s.removeClass("halo-modal-open"), s.css({
                            overflow: ""
                        })
                    })
                }), a.on("click", function(t) {
                    r.is(t.target) || r.has(t.target).length || a.fadeOut(500, function() {
                        s.removeClass("halo-modal-open"), s.css({
                            overflow: ""
                        })
                    })
                })
            },
            doAjaxAddToCartNormal: function(e, a, o) {
                t.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: e,
                    dataType: "json",
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function() {
                        var e = t("[data-ajax-cart-success]"),
                            i = e.find(".cart-modal-content");
                        i.find(".ajax-product-title").html(f.translateText(a)), i.find(".ajax-product-image").attr("src", o), i.find(".message-added-cart").show(), e.fadeIn(600, function() {
                            t("[data-quickview-modal]").is(":visible") && t("[data-quickview-modal]").hide(), f.closeLookbookModal()
                        }), f.updateDropdownCart(), t(".template-cart").length && f.loadAjaxCart()
                    },
                    error: function(e) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading(),
                        setTimeout(function() {
                            checkGift()
                        }, 3e3)
                    }
                })
            },
            doAjaxAddToCartDrawer: function(e, a, o) {
                t.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: e,
                    dataType: "json",
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function() {
                        // var e = t("[data-ajax-cart-success]"),
                        //     i = e.find(".cart-modal-content");
                        // i.find(".ajax-product-title").html(f.translateText(a)), i.find(".ajax-product-image").attr("src", o), i.find(".message-added-cart").show(), e.fadeIn(600, function() {
                        //     t("[data-quickview-modal]").is(":visible") && t("[data-quickview-modal]").hide(), f.closeLookbookModal()
                        // }), 
                        var cart_drawer = document.querySelector('.wrapper-top-cart');
                        var htmlData = document.querySelector('html');
                        if (htmlData) {
                            htmlData.classList.add('cart-show');
                        }
                        if (cart_drawer) {
                            cart_drawer.classList.add('is-open');
                        }
                        f.updateDropdownCart(), t(".template-cart").length && f.loadAjaxCart()
                    },
                    error: function(e) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading(),
                        setTimeout(function() {
                            checkGift()
                        }, 3e3)
                    }
                })
            },
            doAjaxAddToCart: function(e, a, o) {
                t.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: e,
                    dataType: "json",
                    async: !1,
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        if (o) {
                            var i = "FBT-BUNDLE-" + meta.product.id;
                            f.apply_discount(i), window.location.href = "/cart", f.showloading()
                        } else f.getPopupShoppingCart(!0, a);
                        t(".template-cart").length && f.loadAjaxCart()
                    },
                    error: function(e) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading()
                    }
                })
            },
            getPopupShoppingCart: function(e, a) {
                var o = t("[data-ajax-cart-success]"),
                    i = o.find(".cart-popup-content"),
                    n = o.find(".cart-popup-coll-related");
                t.get(window.router + "/cart?view=json", function(o) {
                    if (i.html(o), void 0 != a) {
                        var s = a.split("/collections")[0];
                        e && (a != s + "/collections/?view=related" ? n.load("" + a) : n.load(s + "/collections/all?view=related"), t(document).ajaxComplete(function(e, o, i) {
                            if ("/collections/all?view=related" === i.url || i.url === "" + a) try {
                                f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "[data-ajax-cart-success] span.money", "money_format")
                            } catch (n) {
                                console.log(n)
                            }
                        }))
                    }
                }).always(function() {
                    f.updateDropdownCart(), f.ellaTimeout = setTimeout(function() {
                        if (f.translateBlock("[data-ajax-cart-success]"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                    }, 1e3), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "[data-ajax-cart-success] span.money", "money_format"), e && o.fadeIn(600, function() {
                        t("[data-quickview-modal]").is(":visible") && t("[data-quickview-modal]").hide(), f.closeLookbookModal()
                    })
                })
            },
            loadAjaxCart: function() {
                t.get(window.router + "/cart", function(e) {
                    var a = t(".cart-template"),
                        o = a.find(".cart-list"),
                        i = a.find("[data-cart-discount-wrapper]"),
                        n = a.find(".groued-info .total"),
                        s = a.find(".grouped-bottom .total"),
                        r = a.find("#is-a-gift"),
                        l = t(e).find(".cart-template"),
                        d = l.find(".cart-list"),
                        c = l.find("[data-cart-discount-wrapper]"),
                        p = l.find(".groued-info .total"),
                        u = l.find(".grouped-bottom .total"),
                        _ = l.find("#is-a-gift");
                    o.replaceWith(d), i.replaceWith(c), n.replaceWith(p), s.replaceWith(u), r.replaceWith(_)
                }).always(function() {
                    f.changeQuantityAddToCart(), f.initFreeShippingMessage(), f._giftCard(), f.ellaTimeout = setTimeout(function() {
                        if (t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                    }, 1e3), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "[data-ajax-cart-success] span.money", "money_format")
                })
            },
            doAjaxUpdatePopupCart: function(e, a) {
                t.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: {
                        id: a,
                        quantity: e
                    },
                    dataType: "json",
                    beforeSend: function() {
                        f.showLoading()
                    },
                    success: function(e) {
                        if (f.getPopupShoppingCart(!1), f.checkBundleProducts(), e.cart_level_discount_applications.length > 0 && t("[data-cart-discount-wrapper]").length) {
                            var a = e.cart_level_discount_applications,
                                o = a[0].title,
                                i = a[0].total_allocated_amount;
                            t("[data-cart-discount-wrapper]").show(), t("[data-cart-discount-title]").text(o), t("[data-cart-discount-amount]").html(Shopify.formatMoney(i, window.money_format))
                        } else t("[data-cart-discount-wrapper]").hide()
                    },
                    error: function(e) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.showModal(".ajax-error-modal")
                    },
                    complete: function() {
                        f.hideLoading()
                    }
                })
            },
            // initChangeQuantityButtonEvent: function() {
            //     var e = "[data-minus-quantity-cart], [data-plus-quantity-cart]";
            //     t(e), n.off("click.updateCart").on("click.updateCart", e, function(e) {
            //         e.preventDefault(), e.stopPropagation();
            //         var a = t(this),
            //             o = a.closest("[data-product-id]").data("product-id"),
            //             i = parseInt(a.siblings('input[name="quantity"]').val());
            //         a.hasClass("plus") ? i += 1 : i -= 1, f.doAjaxUpdatePopupCart(i, o)
            //     })
            // },
            initChangeQuantityButtonEvent: function() {
                var e = "[data-minus-quantity-cart], [data-plus-quantity-cart]";
                t(e);
                n.off("click.updateCart").on("click.updateCart", e, function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var a = t(this),
                        o = a.closest("[data-product-id]").data("product-id"),
                        inputField = a.siblings('input[name="quantity"]'),
                        i = parseInt(inputField.val());

                    // Increment or decrement
                    if (a.hasClass("plus")) {
                        i += 1;
                    } else {
                        i -= 1;
                    }

                    // Minimum quantity check (optional)
                    if (i < 1) i = 1;

                    // Update the input field with the new value
                    inputField.val(i);

                    // Call the ajax update function
                    f.doAjaxUpdatePopupCart(i, o);
                });
            },

            initQuantityInputChangeEvent: function() {
                n.on("change", "[data-quantity-input]", function() {
                    var e = t(this).closest("[data-product-id]").data("product-id"),
                        a = parseInt(t(this).val());
                    f.doAjaxUpdatePopupCart(a, e)
                })
            },
            removeCartItem: function() {
                n.on("click", ".cart-remove", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this).closest("[data-product-id]").data("product-id");
                    f.doAjaxUpdatePopupCart(0, a)
                })
            },
            initSoldOutProductShop: function() {
                var e = t(".product-shop [data-soldOut-product]");
                e.length && e.each(function() {
                    var e = t(this),
                        a = e.data("items").toString().split(","),
                        o = e.data("hours").toString().split(","),
                        i = Math.floor(Math.random() * a.length),
                        n = Math.floor(Math.random() * o.length);
                    e.find(".items-count").text(a[i]), e.find(".hours-num").text(o[n])
                })
            },
            initCustomerViewProductShop: function() {
                var e = t(".product-shop [data-customer-view]");
                e.length && e.each(function() {
                    var e = t(this),
                        a = e.data("customer-view").split(","),
                        o = Math.floor(Math.random() * a.length);
                    e.find("label").text(a[o])
                })
            },
            initProductMoreview: function(t) {
                if (window.innerWidth < 1200) {
                var e = t.find(".slider-for"),
                    a = t.find(".slider-nav"),
                    o = a.data("vertical");

                function i(t, e) {
                    null != t && null != e && t.contentWindow.postMessage(JSON.stringify(e), "*")
                }
                if (e.on("afterChange", function(t, a) {
                        if (e.find(".slick-current").find("iframe").length) {
                            var o = e.find("iframe").get(0);
                            console.log(o), i(o, {
                                event: "command",
                                func: "playVideo"
                            })
                        }
                        e.find(".slick-current").find("video").length && e.find(".slick-current").find("video").get(0).play()
                    }), e.on("beforeChange", function(t, a) {
                        e.find(".slick-current").find("iframe").length && i(e.find("iframe").get(0), {
                            event: "command",
                            func: "pauseVideo"
                        }), e.find(".slick-current").find("video").length && e.find(".slick-current").find("video").get(0).pause()
                    }), e.hasClass("slick-initialized") || a.hasClass("slick-initialized") || (e.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: !0,
                        asNavFor: a,
                        dots: true,
                        draggable: !1,
                        adaptiveHeight: !1,
                        get arrows() {
                            if ("skin_1" == window.product_style) return this.arrows = !0;
                            return this.arrows = !1
                        },
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                arrows: !0
                            }
                        }]
                    }), a.slick({
                        infinite: !0,
                        slidesToShow: a.data("rows"),
                        vertical: o,
                        slidesToScroll: 1,
                        asNavFor: e,
                        focusOnSelect: !0,
                        get nextArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                        },
                        get prevArrow() {
                            if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                            if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                        },
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                vertical: !1,
                                get dots() {
                                    if (!0 == o) return !1
                                }
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                vertical: !1,
                                get dots() {
                                    if (!0 == o) return !1
                                }
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                vertical: !1,
                                get dots() {
                                    if (!0 == o) return !1
                                }
                            }
                        }, {
                            breakpoint: 360,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                vertical: !1,
                                get dots() {
                                    if (!0 == o) return !1
                                }
                            }
                        }]
                    })), "variant_grouped" === window.color_swatch_style && window.use_color_swatch) {
                    var n = t.closest("[data-more-view-product]").siblings(".product-shop").find(".swatch").find(".swatch-element.color").find(":radio:checked");
                    if (n.length) {
                        var s = n.data("filter");
                        void 0 !== s && (a.slick("slickUnfilter"), e.slick("slickUnfilter"), a.find(s).length && e.find(s).length && (a.slick("slickFilter", s).slick("refresh"), e.slick("slickFilter", s).slick("refresh")))
                    }
                }
            }
            },
            changeSwatch: function(e) {
                n.on("change", e, function() {
                    var a = t(this).data("filter"),
                        o = t(this).closest(".swatch").attr("data-option-index"),
                        i = t(this).val();
                    if (t(this).closest("form").find(".single-option-selector").eq(o).val(i).trigger("change"), void 0 == a && t("input[data-filter]").is(":checked") && (a = t("input[data-filter]:checked").data("filter")), "variant_grouped" === window.color_swatch_style && window.use_color_swatch && void 0 !== a) {
                        var n = t(e).closest(".product-shop");
                        if (n.closest(".product-slider").length) {
                            var s = n.closest(".product-slider").find("[data-moreview-product-slider]"),
                                r = s.find(".slider-for");
                            r.slick("slickUnfilter"), r.find(a).length && r.slick("slickFilter", a).slick("refresh"), f.initZoom()
                        } else {
                            var s = n.prev("[data-more-view-product]");
                            if (s.length) {
                                var l = s.find(".slider-nav"),
                                    r = s.find(".slider-for");
                                l.slick("slickUnfilter"), r.slick("slickUnfilter"), l.find(a).length && r.find(a).length && (l.slick("slickFilter", a).slick("refresh"), r.slick("slickFilter", a).slick("refresh"))
                            }
                            f.initZoom()
                        }
                    }
                })
            },
            productPageInitProductTabs: function() {
                var e = t(".tabs__product-page"),
                    a = e.find("[data-tapTop]"),
                    o = e.find("[data-TabContent]");
                (t(".product-template-skin-1").length || t(".product-template-supermarket").length) && (e = t(".product-review")), a.off("click").on("click", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var i = t(this),
                        n = t(i.data("target")),
                        s = i.closest(".list-tabs");
                    s.length ? t(this).hasClass("active") || (a.removeClass("active"), o.removeClass("active"), i.addClass("active"), s.next().find(i.data("target")).addClass("active")) : t(".product-template-full-width").length ? t(this).hasClass("active") ? (i.removeClass("active"), n.hide(0, function() {
                        t(document.body).trigger("sticky_kit:recalc")
                    })) : (i.addClass("active"), n.show(0, function() {
                        t(document.body).trigger("sticky_kit:recalc")
                    })) : t(".has-sticky-product-img").length ? t(this).hasClass("active") ? (i.removeClass("active"), n.hide()) : (i.addClass("active"), n.show()) : t(this).hasClass("active") ? (i.removeClass("active"), n.slideUp()) : (i.addClass("active"), n.slideDown())
                }), n.on("click.triggerTabsReviews", ".product-shop .spr-badge", function() {
                    if (e.length && (t("html,body").animate({
                            scrollTop: e.offset().top
                        }, 400), !t(".product-template-skin-1").length || !t(".product-template-supermarket").length)) {
                        var a = e.find('[data-target="#collapse-tab2"]');
                        a.hasClass("active") || a.trigger("click")
                    }
                }), t(".product-template-full-width").length && n.on("click", ".product-template-full-width .spr-summary-actions-newreview", function() {
                    t(document.body).trigger("sticky_kit:recalc")
                })
            },
            initStickyForProductFullWidth: function() {
                var e, a = t(".product-template-full-width"),
                    o = r.innerWidth(),
                    i = a.find("[data-sticky-1]"),
                    n = a.find("[data-sticky-2]"),
                    s = a.find("[data-sticky-3]"),
                    l = function() {
                        i.trigger("sticky_kit:detach"), s.trigger("sticky_kit:detach"), n.trigger("sticky_kit:detach")
                    },
                    d = function() {
                        i.stick_in_parent({
                            offset_top: 70,
                            inner_scrolling: !1
                        }), s.stick_in_parent({
                            offset_top: 68
                        }), n.stick_in_parent({
                            offset_top: 50
                        }).on("sticky_kit:bottom", function() {
                            n.addClass("sticky-on-bottom")
                        }).on("sticky_kit:unbottom", function() {
                            n.removeClass("sticky-on-bottom")
                        })
                    };
                a.length && (o >= 1200 && d(), r.off("resize.sticky").on("resize.sticky", function() {
                    clearTimeout(e), e = setTimeout(function() {
                        var t = r.innerWidth();
                        t < 1200 && o >= 1200 ? l() : t >= 1200 && o < 1200 && d(), o = t
                    }, 0)
                }))
            },
            initQuickView: function() {
                i.off("click.initQuickView", ".quickview-button").on("click.initQuickView", ".quickview-button", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this).attr("id");
                    f.doAjaxShowQuickView(a), f.closeSuccessModal()
                })
            },
            doAjaxShowQuickView: function(e) {
                f.isAjaxLoading || t.ajax({
                    type: "get",
                    url: window.router + "/products/" + e + "?view=quickview",
                    beforeSend: function() {
                        f.showLoading(), s.css({
                            overflow: "hidden"
                        })
                    },
                    success: function(a) {
                        var o = t("[data-quickview-modal]");
                        o.find(".halo-modal-body").html(a), setTimeout(function() {
                            if (f.translateBlock("[data-quickview-modal]"), f.initProductMoreview(t("[data-more-view-product-qv] .product-img-box")), f.initSoldOutProductShop(), f.initCustomerViewProductShop(), f.changeSwatch(".quickview-tpl .swatch :radio"), f.initCountdownNormal(), f.initZoom(), f.setAddedForWishlistIcon(e), t.getScript("https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-595b0ea2fb9c5869").done(function() {
                                    "undefined" != typeof addthis && (addthis.init(), addthis.layers.refresh())
                                }), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                        }, 500), f.hideLoading(), o.fadeIn(600, function() {
                            t("[data-ajax-cart-success]").is(":visible") && t("[data-ajax-cart-success]").hide()
                        })
                    },
                    error: function(e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), f.hideLoading(), f.showModal(".ajax-error-modal")
                    }
                })
            },
            initZoom: function() {
                var e = t(".product-img-box [data-zoom]");
                r.width() >= 1200 ? e.zoom() : e.trigger("zoom.destroy")
            },
            openSearchForm: function() {
                var e = "[data-search-mobile-toggle]";
                t(".wrapper-header").find(".search-form"), n.off("click.toggleSearch", e).on("click.toggleSearch", e, function(e) {
                    e.preventDefault(), e.stopPropagation(), s.addClass("search-open");
                    var a = t(this),
                        o = a.data("url"),
                        i = a.data("limit"),
                        n = a.data("limit");
                    t.ajax({
                        type: "get",
                        url: window.router + "/collections/" + o,
                        cache: !1,
                        data: {
                            view: "list_product",
                            constraint: "limit=" + i + "+grid=" + n + "+sectionId=search-form-product"
                        },
                        beforeSend: function() {
                            a.addClass("ajax-loaded")
                        },
                        success: function(e) {
                            "" != o && t(".search__products").find(".products-grid").html(e), t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo()
                        },
                        complete: function() {
                            if (f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                        }
                    })
                }), n.off("click.hideSearch").on("click.hideSearch", function(e) {
                    var a = t(".wrapper-header .search-form .search-bar"),
                        o = t(".wrapper-header .header-search__product"),
                        i = t(".wrapper-header .header-search__trending"),
                        n = t(".wrapper-overlay"),
                        r = t("[data-search-mobile-toggle]"),
                        l = t(".home-slideshow .slide-action");
                    a.is(e.target) || r.is(e.target) || l.has(e.target).length || a.has(e.target).length || o.has(e.target).length || i.has(e.target).length || n.has(e.target).length || (s.removeClass("search-open"), t(".quickSearchResultsWrap").hide(), t(".close-search-style-3").hide())
                }), t(".header_mobile_3 .header-mb-right .search-form .search-bar .header-search__input").off("click.hideCloseSearch").on("click.hideCloseSearch", function(e) {
                    t(".close-search-style-3").show()
                }), t(".close-search-style-3").off("click.hideQuickSearchStyle3").on("click.hideQuickSearchStyle3", function(e) {
                    t(".quickSearchResultsWrap").hide(), t(".close-search-style-3").hide()
                })
            },
            stickyFixedTopMenu: function() {
                window.fixtop_menu && (window.innerWidth >= 1200 ? (t("[data-sticky-mb]").unstick(), setTimeout(function() {
                    t(".site-header").css("height", ""), t("[data-sticky-pc]").sticky({
                        zIndex: 4
                    }), t("[data-sticky-pc]").on("sticky-start", function() {
                        i.addClass("has_sticky")
                    }), t("[data-sticky-pc]").on("sticky-end", function() {
                        i.removeClass("has_sticky")
                    })
                }, 100)) : (t("[data-sticky-pc]").unstick(), setTimeout(function() {
                    t(".site-header").css("height", ""), t("[data-sticky-mb]").sticky({
                        zIndex: 4
                    })
                }, 100)))
            },
            handleScrollDown: function() {
                var e = "[data-scroll-down]";
                t(e).each(function() {
                    var a = t(this),
                        o = a.closest(".shopify-section").next(".shopify-section").attr("id");
                    a.attr("href", "#" + o), n.off("click.handleScrollDown", e).on("click.handleScrollDown", e, function(e) {
                        e.preventDefault();
                        var a = t(this.getAttribute("href"));
                        a.length && t("html, body").stop().animate({
                            scrollTop: a.offset().top
                        }, 500)
                    })
                })
            },
            initStickyAddToCart: function() {
                var e = t("[data-sticky-add-to-cart]"),
                    a = e.find(".pr-active"),
                    o = e.find(".pr-swatch");
                if (e.length) {
                    var s, r, l, d, c = t("#add-to-cart-form .groups-btn").offset().top;
                    t(window).scroll(function() {
                        t(this).scrollTop() > c ? i.addClass("show_sticky") : i.removeClass("show_sticky")
                    }), a.off("click.showListVariant").on("click.showListVariant", function(t) {
                        t.preventDefault(), e.toggleClass("open-sticky")
                    }), n.off("click.hideVariantsOption").on("click.hideVariantsOption", function(t) {
                        a.is(t.target) || 0 !== a.has(t.target).length || e.removeClass("open-sticky")
                    }), o.off("click.activeVar").on("click.activeVar", function(i) {
                        var n = t(this),
                            s = n.text(),
                            r = n.data("value"),
                            l = n.data("img");
                        return o.removeClass("active"), n.addClass("active"), e.toggleClass("open-sticky"), e.find(".action input[type=hidden]").val(r), a.attr("data-value", r).text(s), t('#add-to-cart-form [data-value-sticky="' + r + '"]').each(function() {
                            var e = t(this).data("value");
                            t('[data-value="' + e + '"]').closest(".swatch").find("#" + e).click()
                        }), n.hasClass("sold-out") ? e.find(".sticky-add-to-cart").val(window.inventory_text.sold_out).addClass("disabled").attr("disabled", "disabled") : e.find(".sticky-add-to-cart").removeClass("disabled").removeAttr("disabled").val(window.inventory_text.add_to_cart), t(".pr-img img").attr({
                            src: l
                        }), !1
                    }), n.on("click", "[data-sticky-btn-addToCart]", function(e) {
                        return e.preventDefault(), t("#add-to-cart-form [data-btn-addToCart]").length ? t("#add-to-cart-form [data-btn-addToCart]").click() : t("#add-to-cart-form [data-grouped-addToCart]").length && t("#add-to-cart-form [data-grouped-addToCart]").click(), !1
                    }), s = t("#product-selectors option:selected").val(), l = (r = e.find('.pr-swatch[data-value="' + s + '"]')).html(), a.html(l), r.addClass("active"), d = r.data("img"), t(".pr-img img").attr({
                        src: d
                    }), t(".swatch .swatch-element").each(function(e) {
                        var a = t(this).find("input:radio").attr("id");
                        t('.swatch input.text[data-value="' + a + '"]').appendTo(t(this))
                    }), t(".selector-wrapper").change(function() {
                        var e = t("#product-selectors").val();
                        if (t(".sticky_form .pr-selectors li").each(function(a) {
                                t(this).find("a").data("value") == e ? t(this).find("a").addClass("active") : t(this).find("a").removeClass("active")
                            }), t("#product-selectors").change(function() {
                                var e = "";
                                t("#product-selectors option:selected").each(function() {
                                    e += t(this).data("imge")
                                }), t(".pr-img img").attr({
                                    src: e
                                })
                            }).trigger("change"), o.hasClass("active")) {
                            var i = t(".sticky_form .pr-swatch.active").html();
                            t(".sticky_form .action input[type=hidden]").val(e), a.html(i), a.attr("data-value", e)
                        }
                    })
                }
            },
            createWishListTplItem: function(e) {
                var a = t("[data-wishlist-container]");
                jQuery.getJSON(window.router + "/products/" + e + ".js", function(e) {
                    var o = "",
                        i = Shopify.formatMoney(e.price_min, window.money_format);
                    o += '<div class="grid-item" data-wishlist-added="wishlist-' + e.id + '">', o += '<div class="inner product-item" data-product-id="product-' + e.handle + '">', o += '<div class="column col-img"><div class="product-image">', o += '<a href="' + e.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">', e.featured_image && (o += '<img src="' + e.featured_image + '" alt="' + e.featured_image.alt + '">'), o += "</a></div></div>", o += '<div class="column col-prod">', o += '<a class="product-title" href="' + e.url + '" title="' + e.title + '">' + e.title + "</a>", o += '<div class="product-vendor">', o += '<a href="' + window.router + "/collections/vendors?q=" + e.vendor + '" title="' + e.vendor + '">' + e.vendor + "</a></div></div>", o += '<div class="column col-price text-center"><div class="price-box">' + i + "</div></div>", o += '<div class="column col-options text-center">', o += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + e.id + '" data-id="product-actions-' + e.id + '" enctype="multipart/form-data">', e.available ? (1 == e.variants.length && (o += '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' + e.id + '" type="submit">' + window.inventory_text.add_to_cart + '</button><input type="hidden" name="id" value="' + e.variants[0].id + '" />'), e.variants.length > 1 && (o += '<a class="btn" title="' + e.title + '" href="' + e.url + '">' + window.inventory_text.select_options + "</a>")) : o += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">' + window.inventory_text.unavailable + "</button>", o += "</form></div>", o += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="' + e.handle + '" data-icon-wishlist data-id="' + e.id + '"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>', o += "</div></div>", a.append(o);
                    var n = t(".wrapper-wishlist a.share").attr("href");
                    n += encodeURIComponent(e.title + "\nPrice: " + i.replace(/(<([^>]+)>)/ig, "") + "\nLink: " + window.location.protocol + "//" + window.location.hostname + e.url + "\n\n"), t(".wrapper-wishlist a.share").attr("href", n)
                })
            },
            initWishListPagging: function() {
                var e = JSON.parse(localStorage.getItem("items")),
                    a = t("#wishlist-paginate"),
                    o = '<li class="text disabled prev"><a href="#" title="' + window.inventory_text.previous + '"><i class="fa fa-angle-left" aria-hidden="true"></i><span>' + window.inventory_text.previous + "</span></a></li>",
                    i = t("[data-wishlist-container]");
                a.children().remove();
                var n = Math.ceil(e.length / 3);
                if (n <= 1) {
                    i.children().show();
                    return
                }
                for (var s = 0; s < n; s++) {
                    var r = s + 1;
                    0 === s ? o += '<li class="active"><a data-page="' + r + '" href="' + r + '" title="' + r + '">' + r + "</a></li>" : o += '<li><a data-page="' + r + '" href="' + r + '" title="' + r + '">' + r + "</a></li>"
                }
                o += '<li class="text next"><a href="#" title="' + window.inventory_text.next + '"><span>' + window.inventory_text.next + '</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>', a.append(o), i.children().each(function(e, a) {
                    e >= 0 && e < 3 ? t(a).show() : t(a).hide()
                }), a.off("click.wl-pagging").on("click.wl-pagging", "li a", function(e) {
                    e.preventDefault();
                    var o = t(this).parent().hasClass("prev"),
                        s = t(this).parent().hasClass("next"),
                        r = t(this).data("page");
                    if (o) {
                        var l = parseInt(t(this).parent().siblings(".active").children().data("page"));
                        r = l - 1
                    }
                    if (s) {
                        var l = parseInt(t(this).parent().siblings(".active").children().data("page"));
                        r = l + 1
                    }
                    i.children().each(function(e, a) {
                        e >= (r - 1) * 3 && e < 3 * r ? t(a).show() : t(a).hide()
                    }), 1 === r ? (a.find(".prev").addClass("disabled"), a.find(".next").removeClass("disabled")) : r === n ? (a.find(".next").addClass("disabled"), a.find(".prev").removeClass("disabled")) : (a.find(".prev").removeClass("disabled"), a.find(".next").removeClass("disabled")), t(this).parent().siblings(".active").removeClass("active"), a.find('[data-page="' + r + '"]').parent().addClass("active")
                })
            },
            initWishLists: function() {
                if ("undefined" != typeof Storage) {
                    var t = JSON.parse(localStorage.getItem("items"));
                    !(t.length <= 0) && (t.forEach(function(t) {
                        f.createWishListTplItem(t)
                    }), this.initWishListPagging(), this.translateBlock(".wishlist-page"))
                } else alert("Sorry! No web storage support..")
            },
            setAddedForWishlistIcon: function(e) {
                var a = t('[data-product-handle="' + e + '"]');
                _.indexOf(e) >= 0 ? (a.addClass("whislist-added"), t(".style_product_grid_3").length ? a.find(".wishlist-text").text(window.inventory_text.remove_wishlist_1) : a.find(".wishlist-text").text(window.inventory_text.remove_wishlist)) : (a.removeClass("whislist-added"), t(".style_product_grid_3").length ? a.find(".wishlist-text").text(window.inventory_text.add_wishlist_1) : a.find(".wishlist-text").text(window.inventory_text.add_wishlist))
            },
            doAddOrRemoveWishlish: function() {
                var e = "[data-icon-wishlist]";
                n.off("click.addOrRemoveWishlist", e).on("click.addOrRemoveWishlist", e, function(e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.data("id"),
                        i = a.data("product-handle"),
                        n = _.indexOf(i);
                    a.hasClass("whislist-added") ? (a.removeClass("whislist-added"), t(".style_product_grid_3").length ? a.find(".wishlist-text").text(window.inventory_text.add_wishlist_1) : a.find(".wishlist-text").text(window.inventory_text.add_wishlist), t('[data-wishlist-added="wishlist-' + o + '"]').length && t('[data-wishlist-added="wishlist-' + o + '"]').remove(), _.splice(n, 1), localStorage.setItem("items", JSON.stringify(_)), t("[data-wishlist-container]").length && f.initWishListPagging()) : (a.addClass("whislist-added"), t(".style_product_grid_3").length ? a.find(".wishlist-text").text(window.inventory_text.remove_wishlist_1) : a.find(".wishlist-text").text(window.inventory_text.remove_wishlist), t("[data-wishlist-container]").length && f.createWishListTplItem(i), _.push(i), localStorage.setItem("items", JSON.stringify(_))), f.setAddedForWishlistIcon(i)
                })
            },
            initWishListIcons: function() {
                var e = localStorage.getItem("items") ? JSON.parse(localStorage.getItem("items")) : [];
                if (e.length)
                    for (var a = 0; a < e.length; a++) {
                        var o = t('[data-product-handle="' + e[a] + '"]');
                        o.addClass("whislist-added"), t(".style_product_grid_3").length ? o.find(".wishlist-text").text(window.inventory_text.remove_wishlist_1) : o.find(".wishlist-text").text(window.inventory_text.remove_wishlist)
                    }
            },
            setAddedForCompareIcon: function(e) {
                var a = t('[data-compare-product-handle="' + e + '"]'),
                    o = g.indexOf(e),
                    i = t("[data-compare-count]");
                totalProduct = Math.ceil((compareItems = localStorage.getItem("compareArr") ? JSON.parse(localStorage.getItem("compareArr")) : []).length), o >= 0 ? (a.addClass("compare-added"), a.find("[data-change-text-compare]").text(window.inventory_text.remove_compare)) : (a.removeClass("compare-added"), a.find("[data-change-text-compare]").text(window.inventory_text.add_compare)), t(".l") && i.text(totalProduct), totalProduct >= 2 ? t(".compare-link").addClass("open") : t(".compare-link").removeClass("open")
            },
            doAddOrRemoveCompare: function() {
                var e = "[data-icon-compare]";
                n.off("click.doAddOrRemoveCompare", e).on("click.doAddOrRemoveCompare", e, function(e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.data("id"),
                        i = a.data("compare-product-handle"),
                        n = g.indexOf(i);
                    a.hasClass("compare-added") ? (a.removeClass("compare-added"), t('[data-compare-added="compare-' + o + '"]').length && t('[data-compare-added="compare-' + o + '"]').remove(), g.splice(n, 1), localStorage.setItem("compareArr", JSON.stringify(g))) : (g.push(i), localStorage.setItem("compareArr", JSON.stringify(g)), f.createCompareItem(i), a.addClass("compare-added")), f.setAddedForCompareIcon(i)
                })
            },
            initCompareIcons: function() {
                var e = t("[data-compare-count]");
                if (totalProduct = Math.ceil(g.length), e.text(totalProduct), g.length) {
                    for (var a = 0; a < g.length; a++) t('[data-compare-product-handle="' + g[a] + '"]').addClass("compare-added");
                    if ("undefined" != typeof Storage) {
                        if (g.length <= 0) return;
                        setTimeout(function() {
                            g.forEach(function(t) {
                                f.createCompareItem(t), f.setAddedForCompareIcon(t)
                            })
                        }, 1500)
                    } else alert("Sorry! No web storage support..")
                }
            },
            initCompareSelected: function() {
                var e = "[data-compare-selected]";
                compareModalProduct = (compareModal = t("[data-compare-modal]")).find(".product-grid"), compareModalMessage = t("[data-compare-message-modal]"), n.off("click.compareSelected", e).on("click.compareSelected", e, function(t) {
                    t.preventDefault(), t.stopPropagation(), "undefined" != typeof Storage ? g.length <= 1 ? (compareModalMessage.find(".halo-modal-body").text(window.inventory_text.message_compare), compareModalMessage.fadeIn(500, function() {
                        s.addClass("halo-modal-open")
                    }), i.addClass("has-popup")) : (g.forEach(function(t) {
                        f.removeCompareItem(t)
                    }), compareModal.fadeIn(600, function() {
                        s.addClass("halo-modal-open")
                    }), f.removeAllCompareItem()) : alert("Sorry! No web storage support.."), f.closeSuccessModal(), f.translateBlock(".ajax-compare"), f.translateBlock(".compare-message-modal")
                })
            },
            createCompareItem: function(e) {
                var a = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-grid"),
                    o = t("[data-compare-modal]").find(".halo-modal-body .compare-content .rating"),
                    i = t("[data-compare-modal]").find(".halo-modal-body .compare-content .description"),
                    n = (t("[data-compare-modal]").find(".halo-modal-body .compare-content .collection"), t("[data-compare-modal]").find(".halo-modal-body .compare-content .availability")),
                    s = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-type"),
                    r = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-sku"),
                    l = t("[data-compare-modal]").find(".option1"),
                    d = t("[data-compare-modal]").find(".option2"),
                    c = t("[data-compare-modal]").find(".option3");
                jQuery.getJSON("/products/" + e + ".js", function(e) {
                    var p = "",
                        u = "",
                        _ = "",
                        g = "",
                        h = "",
                        f = "",
                        v = "",
                        m = "";
                    Shopify.formatMoney(e.price_min, window.money_format);
                    var y = '<span class="shopify-product-reviews-badge" data-id="' + e.id + '"></span>',
                        b = e.description.substring(0, 100) + "...",
                        _ = new DOMParser().parseFromString(b, "text/html"),
                        w = (e.compare_at_price - e.price) / e.compare_at_price * 100,
                        C = e.tags,
                        k = e.options;
                    t.each(k, function(t, a) {
                        var o = a.position,
                            i = a.name.toLowerCase(),
                            n = a.values,
                            s = "";
                        n.forEach(function(t, e) {
                            t && (e > 0 && (s += ", "), s += t)
                        }), m += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>', "" == s || "Default Title" == s ? v += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>' : v += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + s + "</div>";
                        var r = window.option_ptoduct1,
                            p = window.option_ptoduct2;
                        optionThreeValue = window.option_ptoduct3, 1 == o && (i == r ? (l.append(v), d.append(m), c.append(m)) : i == p ? (l.append(m), d.append(v), c.append(m)) : "title" == i ? (l.append(m), d.append(m), c.append(m)) : (l.append(m), d.append(m), c.append(v))), 2 == o && (i == r ? l.find('[data-compare-added="compare-' + e.id + '"]').html(s) : i == p ? d.find('[data-compare-added="compare-' + e.id + '"]').html(s) : c.find('[data-compare-added="compare-' + e.id + '"]').html(s)), 3 == o && (i == r ? l.find('[data-compare-added="compare-' + e.id + '"]').html(s) : i == p ? d.find('[data-compare-added="compare-' + e.id + '"]').html(s) : c.find('[data-compare-added="compare-' + e.id + '"]').html(s))
                    }), "" == y || void 0 == y ? u += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '"></div>' : u += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + y + "</div>", o.append(u), "" == b || void 0 == b ? _ += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>' : _ += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + b + "</div>", i.append(_);
                    var x = e.variants;
                    if (x.length > 1 ? t.each(x, function(t, a) {
                            0 == t && ("" == (skuValue = a.sku) ? f += skuValueHTML = '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>' : f += skuValueHTML = '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + skuValue + "</div>")
                        }) : f += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>', r.append(f), p += '<div class="grid-item col-xl-3 product-item" data-compare-added="compare-' + e.id + '">', p += '<div class="inner" data-product-id="product-' + e.handle + '"><div class="inner-top"', p += '<div class="product-top"><div class="product-image">', p += '<a href="' + e.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">', e.featured_image && (p += '<img src="' + e.featured_image + '" alt="' + e.featured_image.alt + '">'), p += "</a></div>", p += '<div class="product-label">', e.compare_at_price > e.price && ("label_sale" == window.label_sale ? (p += '<strong class="label sale-label">' + window.inventory_text.salelabel + " </strong>", p += "<br>") : (p += '<strong class="label sale-label">- ' + Math.floor(w) + "% </strong>", p += "<br>")), !1 == e.available && (p += '<strong class="label sold-out-label">' + window.inventory_text.soldoutlabel + " </strong>", p += "<br>"), C.forEach(function(t) {
                            "new" == t && (p += '<strong class="label new-label">' + window.inventory_text.newlabel + " </strong>", p += "<br>"), "Custom Label" == t && (p += '<strong class="label custom-label">' + window.inventory_text.customlabel + " </strong>", p += "<br>"), "bundle" == t && (p += '<strong class="label bundle-label">' + window.inventory_text.bundlelabel + " </strong>", p += "<br>")
                        }), p += "</div></div></div>", p += '<div class="product-bottom">', p += '<div class="product-vendor">', p += '<a href="/collections/vendors?q=' + e.vendor + '" title="' + e.vendor + '">' + e.vendor + "</a></div>", p += '<a class="product-title" href="' + e.url + '" title="' + e.title + '">' + e.title + "</a>", p += '<div class="column col-price text-center"><div class="price-box">', e.compare_at_price > e.price ? (p += '<span class="price-sale">', p += '<span class="old-price">' + Shopify.formatMoney(e.variants[0].compare_at_price, window.money_format) + "</span>", p += '<span class="price special-price" itemprop="price"> ' + Shopify.formatMoney(e.price, window.money_format) + "</span>", p += "</span>") : p += "<span> " + Shopify.formatMoney(e.price, window.money_format) + "</span>", p += "</div></div>", p += '<div class="column col-options text-center">', p += '<form action="/cart/add" method="post" class="variants" id="-' + e.id + '" data-id="product-actions-' + e.id + '" enctype="multipart/form-data">', e.available ? (1 == e.variants.length && (p += '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" data-form-id="#-' + e.id + '" >' + window.inventory_text.add_to_cart + '</button><input type="hidden" name="id" value="' + e.variants[0].id + '" />'), e.variants.length > 1 && (p += '<a class="btn" title="' + e.title + '" href="' + e.url + '">' + window.inventory_text.select_options + "</a>"), g += '<div class="col-xl-3 in-stock" data-compare-added="compare-' + e.id + '">' + window.inventory_text.in_stock + "</div>") : (p += '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" disabled="disabled">' + window.inventory_text.unavailable + "</button>", g += '<div class="col-xl-3 unavailable" data-compare-added="compare-' + e.id + '">' + window.inventory_text.unavailable + "</div>"), p += "</form></div>", p += '<div class="column col-remove text-center"><a class="compare-added" href="#" data-icon-compare-added data-compare-product-handle="' + e.handle + '" data-id="' + e.id + '">' + window.inventory_text.remove + "</a></div></div>", p += "</div></div></div>", a.append(p), h += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + e.type + "</div>", n.append(g), s.append(h), t(".spr-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                })
            },
            removeCompareItem: function(e) {
                var a = "[data-icon-compare-added]";
                n.off("click.removeCompareItem", a).on("click.removeCompareItem", a, function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.data("id"),
                        i = a.data("compare-product-handle"),
                        n = g.indexOf(i);
                    t('[data-compare-added="compare-' + o + '"]').length && t('[data-compare-added="compare-' + o + '"]').remove(), g.splice(n, 1), localStorage.setItem("compareArr", JSON.stringify(g)), f.setAddedForCompareIcon(i)
                })
            },
            removeAllCompareItem: function(e) {
                var a = "[data-compare-remove-all]";
                compareCountNum = t("[data-compare-count]"), compareElm = t("[data-icon-compare]"), n.off("click.removeAllCompareItem", a).on("click.removeAllCompareItem", a, function(e) {
                    e.preventDefault(), e.stopPropagation(), t("[data-compare-added]").remove(), g.splice(0, g.length), localStorage.setItem("compareArr", JSON.stringify(g)), compareElm.hasClass("compare-added") && compareElm.removeClass("compare-added"), t(".compare-link").removeClass("open"), totalProduct = Math.ceil(g.length), compareCountNum.text(totalProduct)
                })
            },
            wrapTable: function() {
                var e = t(".tab-content").find("table");
                e.length && e.each(function() {
                    t(this).wrap('<div class="table-wrapper"></div>')
                })
            },
            initBundleProducts: function() {
                var e, a = "[data-bundle-addToCart]",
                    o = t("[data-bundle-images-slider]"),
                    s = ".fbt-toogle-options",
                    r = t(".products-grouped-action .bundle-price"),
                    l = ".bundle-checkbox",
                    d = function() {
                        t(".fbt-product-item").each(function() {
                            var e = t(this),
                                a = e.data("bundle-product-id"),
                                o = t(this).find('[name="group_id"]').val(),
                                i = e.find(".swatch"),
                                n = window.productVariants[a];
                            if (n) {
                                var s = n.find(function(t) {
                                    return t.id == o
                                });
                                i.each(function(e) {
                                    t(this).find('.swatch-element[data-value="' + s["option" + (e + 1)] + '"]').find("input").prop("checked", !0)
                                })
                            }
                        })
                    },
                    c = function() {
                        var e = t(".fbt-product-item.isChecked"),
                            a = t(".products-grouped-action .bundle-price"),
                            o = t(".products-grouped-action .old-price"),
                            i = a.data("discount-rate"),
                            n = 0,
                            s = t(".fbt-product-item.isChecked").length,
                            r = t(".fbt-product-item").length;
                        e.each(function() {
                            var e = t(this).find("select[name=group_id]"),
                                l = t(this).find("input[name=group_id]");
                            if (e.length) var d = e.find(":selected").data("price");
                            else if (l.length) var d = t(this).find("input[name=group_id]").data("price");
                            else var d = t(this).find("input[name=id]").data("price");
                            d && (n += d, a.length > 0 && o.length > 0 && (o.html(Shopify.formatMoney(n, window.money_format)), a.html(Shopify.formatMoney(n * (1 - i), window.money_format)), s == r ? (window.bundleMatch = !0, a.show(), o.show(), t(".products-grouped-action .price").hide()) : (window.bundleMatch = !1, a.hide(), o.hide(), t(".products-grouped-action .price").show())), t(".products-grouped-action .total .price").html(Shopify.formatMoney(n, window.money_format)))
                        }), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format")
                    },
                    p = function(e) {
                        var a = e.data("bundle-product-id");
                        void 0 == a && (a = e.data("fbt-pro-id"));
                        var o = window.productVariants[a],
                            i = e.find("[data-option-idx]"),
                            n = e.find('[data-option-idx="0"]').find("input:checked").val(),
                            s = e.find('[data-option-idx="1"]').find("input:checked").val();
                        e.find('[data-option-idx="2"]').find("input:checked").val(), i.each(function() {
                            var e = t(this).data("option-idx"),
                                a = t(this).find(".swatch-element");
                            switch (e) {
                                case 0:
                                    a.each(function() {
                                        var e = t(this).data("value");
                                        void 0 == o.find(function(t) {
                                            return t.option1 == e && t.available
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                    });
                                    break;
                                case 1:
                                    a.each(function() {
                                        var e = t(this).data("value");
                                        void 0 == o.find(function(t) {
                                            return t.option1 == n && t.option2 == e && t.available
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                    });
                                    break;
                                case 2:
                                    a.each(function() {
                                        var e = t(this).data("value");
                                        void 0 == o.find(function(t) {
                                            return t.option1 == n && t.option2 == s && t.option3 == e && t.available
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                    })
                            }
                        })
                    };
                (function() {
                    if (r.length > 0) {
                        var e = 100 * r.data("discount-rate"),
                            a = t(".products-grouped-action .discount-text span");
                        a.length > 0 && a.each(function() {
                            t(this).text(t(this).text().replace("[discount]", e)).parent().show()
                        })
                    }
                })(),
                function() {
                    if (o.length && o.not(".slick-initialized")) {
                        if ("layout_style_1170" == window.layout_style || "layout_style_fullwidth" == window.layout_style || "layout_style_flower" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "supermarket" == window.product_style || "layout_style_surfup" == window.layout_style) {
                            if ("skin_1" == window.product_style) var t = 3;
                            else if ("supermarket" == window.product_style) var t = 4;
                            else var t = o.data("rows")
                        } else var t = o.data("rows");
                        o.slick({
                            get slidesToShow() {
                                if (t >= 5) return this.slidesToShow = 5;
                                return this.slidesToShow = t
                            },
                            slidesToScroll: 1,
                            dots: !1,
                            infinite: !1,
                            speed: 800,
                            get nextArrow() {
                                if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
                            },
                            get prevArrow() {
                                if ("layout_style_1170" == window.layout_style || "layout_style_flower" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                                if ("layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "layout_style_surfup" == window.layout_style) return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                                return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>'
                            },
                            responsive: [{
                                breakpoint: 1025,
                                settings: {
                                    get slidesToShow() {
                                        if ("layout_style_suppermarket" == window.layout_style || "supermarket" == window.product_style || "layout_style_surfup" == window.layout_style) return this.slidesToShow = 3
                                    }
                                }
                            }, {
                                breakpoint: 992,
                                settings: {
                                    get slidesToShow() {
                                        if ("layout_style_suppermarket" == window.layout_style || "supermarket" == window.product_style || "layout_style_surfup" == window.layout_style) return this.slidesToShow = 2;
                                        if (t >= 4) return this.slidesToShow = 4;
                                        return this.slidesToShow = t
                                    }
                                }
                            }, {
                                breakpoint: 480,
                                settings: {
                                    get slidesToShow() {
                                        if ("layout_style_1170" == window.layout_style || "layout_style_fullwidth" == window.layout_style || "layout_style_suppermarket" == window.layout_style || "supermarket" == window.product_style || "layout_style_surfup" == window.layout_style) return this.slidesToShow = 2;
                                        if (t > 3) return this.slidesToShow = 3;
                                        return this.slidesToShow = t
                                    }
                                }
                            }]
                        })
                    }
                }(), t(".layout_style_1170 ").length || t(".layout_style_fullwidth.product_layout_skin_1").length || t(".layout_style_flower.product_layout_skin_1").length || t(".layout_style_suppermarket.product_layout_supermarket").length || t(".product_layout_supermarket").length || t(".product-template-surfup").length ? (i.off("click.toggleVariantOptions", s).on("click.toggleVariantOptions", s, function(e) {
                    e.preventDefault();
                    var a = t(this).data("product-id");
                    t("body").addClass("show_bundle_variant"), t(this).parents(".fbt-product-item").find(".product-options").prependTo(".product-review_variant"), t(".product-review_variant").find("[data-fbt-pro-id=" + a + "]").show(), p(t("[data-fbt-pro-id=" + a + "]"))
                }), t(document).off("click", ".close-options, .overplay_bundle").on("click", ".close-options, .overplay_bundle", function(e) {
                    e.preventDefault(), t("body").removeClass("show_bundle_variant"), t(".product-review_variant .product-options").hide()
                })) : i.off("click.toggleVariantOptions", s).on("click.toggleVariantOptions", s, function(e) {
                    e.preventDefault(), t(this).next().slideToggle()
                }), t(".fbt-checkbox input").prop("checked", !0), i.off("click.checkedProduct", l).on("click.checkedProduct", l, function(e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.prev(),
                        i = a.closest(".fbt-product-item").data("bundle-product-id");
                    o.prop("checked") ? (o.prop("checked", !1), t('[data-bundle-product-id="' + i + '"]').removeClass("isChecked")) : (o.prop("checked", !0), t('[data-bundle-product-id="' + i + '"]').addClass("isChecked")), c()
                }), d(), !t(".layout_style_1170 ").length && t(".fbt-product-item").each(function() {
                    var e = t(this);
                    p(e)
                }), e = ".fbt-product-item .swatch :radio, .product-review_variant .swatch :radio", n.off("change.changeBundleSwatch", e).on("change.changeBundleSwatch", e, function(e) {
                    var a = t(this);
                    if (a.prop("checked")) {
                        var o, i = t(this).closest("[data-fbt-pro-id]");
                        0 == i.length && (i = t(this).closest(".fbt-product-item"));
                        var n = t(this).parent().data("popup-bundle-product-id"),
                            s = window.productVariants[n],
                            r = a.closest("[data-option-idx]").data("option-idx"),
                            l = i.find(".swatch-element"),
                            u = a.val(),
                            _ = t('[data-bundle-product-id="' + n + '"]').find(".fbt-prices"),
                            g = _.find(".price-sale"),
                            h = _.find("[data-fbt-price-change]"),
                            v = t('[data-bundle-product-id="' + n + '"]').find("[name=group_id]"),
                            m = i.find('[data-option-idx="0"]').find("input:checked").val(),
                            y = i.find('[data-option-idx="1"]').find("input:checked").val();
                        switch (i.find('[data-option-idx="2"]').find("input:checked").val(), l.removeClass("soldout"), l.find(":radio").prop("disabled", !1), r) {
                            case 0:
                                var b = s.find(function(t) {
                                    return t.option1 == u && t.option2 == y && t.available
                                });
                                o = void 0 != b ? b : s.find(function(t) {
                                    return t.option1 == u && t.available
                                });
                                break;
                            case 1:
                                var b = s.find(function(t) {
                                    return t.option1 == m && t.option2 == u && t.available
                                });
                                void 0 != b ? o = b : console.log("Bundle Error: variant was soldout, on option selection #2");
                                break;
                            case 2:
                                var b = s.find(function(t) {
                                    return t.option1 == m && t.option2 == y && t.option3 == u && t.available
                                });
                                void 0 != b ? o = b : console.log("Bundle Error: variant was soldout, on option selection #3")
                        }
                        v.val(o.id), d(), p(i), h.html(Shopify.formatMoney(o.price, window.money_format)), i.find("input[name=id][type=hidden]").val(o.id), o.compare_at_price > o.price ? (g.find("[data-fbt-price-change]").addClass("special-price"), g.find(".old-price").html(Shopify.formatMoney(o.compare_at_price, window.money_format)).show()) : (g.find(".old-price").hide(), g.find("[data-fbt-price-change]").removeClass("special-price")), i.find("select").val(o.id).trigger("change"), c(), f.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                        var w = v.find("option:selected", this).attr("data-image");
                        void 0 != w && t('.fbt-image-item[data-bundle-product-id="' + n + '"]').find("img").attr("src", w), t(this).parents(".product-options").find(".swatch").each(function() {
                            t(this).find("input:checked").parents(".swatch-element").hasClass("soldout") && t(this).find(".swatch-element").not(".soldout").find("input").prop("checked", !0), t(this).find("[data-option-select]").text(t(this).find("input:checked").val())
                        })
                    }
                }), c(), n.off("click.bundleAddToCart", a).on("click.bundleAddToCart", a, function(e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.closest("form"),
                        i = o.find("[data-collections-related]"),
                        n = (i.data("collections-related"), o.find("[data-grouped-product-item].isChecked"));
                    t("h1.product-title").text(), t('[id^="product-featured-image"]').first().attr("src"), "disabled" !== a.attr("disabled") && (f.showLoading(), Shopify.queue = [], n.each(function() {
                        var e = t(this).find("[name=group_id]").val();
                        e && Shopify.queue.push({
                            variantId: e,
                            quantity: 1
                        })
                    }), Shopify.moveAlong = function() {
                        if (Shopify.queue.length) {
                            var e = Shopify.queue.shift();
                            f.showLoading(), Shopify.addItem(e.variantId, e.quantity, Shopify.moveAlong), f.ellaTimeout = setTimeout(function() {
                                f.hideLoading()
                            }, 5e3)
                        } else {
                            switch (f.hideLoading(), i.find("[name=id]").val(), t(a.data("form-id")).serialize(), window.ajax_cart) {
                                case "none":
                                case "normal":
                                case "cart-drawer":
                                case "upsell":
                                    o.submit()
                            }
                            try {
                                var n = "FBT-BUNDLE-" + meta.product.id;
                                f.apply_discount(n)
                            } catch (s) {
                                console.log(s)
                            }
                            return !1
                        }
                    }, Shopify.moveAlong())
                })
            },
            apply_discount: function(e) {
                window.bundleMatch && t.ajax({
                    url: "/discount/" + e + "?redirect=/cart",
                    success: function(t) {
                        window.location.href = "/discount/" + e + "?redirect=/cart", console.log("Discount code added")
                    }
                })
            },
            checkBundleProducts: function() {
                var e = t.cookie("discount_code");
                if ("" != e && null != e) {
                    var a = e.replace("FBT-BUNDLE-", "");
                    "" != a && function e() {
                        if (t("ul.cart-list li").length > 0) {
                            var i = !1,
                                n = [];
                            t("ul.cart-list li").each(function(e, o) {
                                var s = t(o).data("product_id");
                                s == a && (i = !0), -1 == n.indexOf(s) && n.push(s)
                            }), !0 == i ? t.ajax({
                                url: "/collections/bundle-" + a + "?view=bundle-json",
                                success: function(t) {
                                    var e, a, i, s = JSON.parse(t);
                                    n.length >= s.results.length ? (e = n, a = s.results, i = 0, a.forEach(function(t) {
                                        -1 != e.indexOf(t.id) && i++
                                    }), i != a.length && o()) : o()
                                }
                            }) : o()
                        }
                    }()
                }

                function o() {
                    t.ajax({
                        url: "/checkout?discount=%20",
                        success: function(t) {
                            console.log("Discount code removed")
                        }
                    })
                }
            },
            hide_filter: function() {
                t(".sidebar-tags .widget-content ul").each(function() {
                    t(this).children("li").length > 0 ? t(this).parents(".sidebar-tags").show() : t(this).parents(".sidebar-tags").hide()
                })
            },
            stickySidebar: function() {},
            productRecomendation: function() {
                var e = t(".js-product-recomendation"),
                    a = e.data("productId"),
                    o = e.data("template"),
                    i = e.data("sectionId"),
                    n = e.data("limit"),
                    s = window.router + "/recommendations/products?&section_id=" + i + "&limit=" + n + "&product_id=" + a + " .product-recommendations";
                e.parent().load(s, function() {
                    if (t('[data-toggle="tooltip"]').tooltip(), f.swapHoverVideo(), "" != o && t(".js-product-recomendation .products-grid").addClass("verticle"), f.initSliderRelatedProduct(), f.translateBlock("#product-recommendations"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                })
            },
            appendProductRecomendation: function() {
                if (!t(".product-template-surfup").length) {
                    var e = t("#product-recommendations"),
                        a = t(".template-product .product .product_bottom");
                    appenRecomendation1 = t(".template-product .product .product_bottom .relate-verticle"), appenRecomendation2 = t(".template-product .product .relate-verticle").find("[data-sticky-3]"), e.appendTo(a), e.appendTo(appenRecomendation1), e.appendTo(appenRecomendation2)
                }
            },
            checkbox_checkout: function() {
                var e = t(".checkbox-group label"),
                    a = t('.checkbox-group input[type="checkbox"]');
                setTimeout(function() {
                    a.each(function() {
                        t(this).is(":checked") ? t(this).parent().parent().find(".btn-checkout").removeClass("show") : t(this).parent().parent().find(".btn-checkout").addClass("show")
                    })
                }, 300), e.off("click").on("click", function(e) {
                    var a = t(this).parent().find(".conditions"),
                        o = t(this).parent().parent().find(".btn-checkout");
                    a.is(":checked") ? (o.addClass("show"), a.prop("checked", !1)) : (o.removeClass("show"), a.prop("checked", !0))
                })
            },
            menu_ajax: function() {
                if (t(".site-nav").length) {
                    if (1025 > r.innerWidth()) {
                        var e = !1;
                        window.addEventListener("load", function() {
                            document.body.addEventListener("touchstart", function(a) {
                                !1 == e && (e = !0, t.ajax({
                                    url: window.router + "/search?view=mega",
                                    beforeSend: function() {},
                                    success: function(e) {
                                        var a = t(".site-nav"),
                                            o = t(e).find(".site-nav");
                                        t(".wrapper_header_supermarket:not(.disable_vertical_menu)").length && t(".vertical-menu").length && (a = t(".horizontal-menu .nav-bar"), o = t(e).find(".horizontal-menu .nav-bar")), t(a).replaceWith(o), f.initToggleSubMenuMobile(), f.sliderMegaMenu()
                                    },
                                    error: function(e, a) {
                                        alert(t.parseJSON(e.responseText).description)
                                    },
                                    complete: function() {}
                                }))
                            }, !1)
                        }, !1), t("[data-menu-mb-toogle]").on("click", function(a) {
                            !1 == e && (e = !0, t.ajax({
                                url: window.router + "/search?view=mega",
                                beforeSend: function() {},
                                success: function(e) {
                                    var a = t(".site-nav"),
                                        o = t(e).find(".site-nav");
                                    t(".wrapper_header_supermarket:not(.disable_vertical_menu)").length && t(".vertical-menu").length && (a = t(".horizontal-menu .nav-bar"), o = t(e).find(".horizontal-menu .nav-bar")), t(a).replaceWith(o), console.log(e), f.initToggleSubMenuMobile(), f.sliderMegaMenu()
                                },
                                error: function(e, a) {
                                    alert(t.parseJSON(e.responseText).description)
                                },
                                complete: function() {}
                            }))
                        })
                    } else {
                        var e = !1;
                        n.mousemove(function() {
                            !1 == e && (e = !0, t.ajax({
                                url: window.router + "/search?view=mega",
                                beforeSend: function() {},
                                success: function(e) {
                                    var a = t(".site-nav"),
                                        o = t(e).find(".site-nav");
                                    t(".wrapper_header_supermarket:not(.disable_vertical_menu)").length && t(".vertical-menu").length && (a = t(".mb-area"), o = t(e).find(".mb-area")), a.replaceWith(o), setTimeout(function() {
                                        f.sliderMegaMenu()
                                    }, 1e3), f.initToggleSubMenuMobile()
                                },
                                error: function(e, a) {
                                    alert(t.parseJSON(e.responseText).description)
                                },
                                complete: function() {
                                    t("[data-masonry]").length && t(".site-nav-dropdown [data-masonry]").masonry({
                                        columnWidth: ".grid-sizer",
                                        itemSelector: "[data-gridItem]"
                                    })
                                }
                            }))
                        })
                    }
                }
            },
            loaderScript: function() {
                var e = function() {
                    var e = t("[data-loader-script]");
                    e.length && e.each(function() {
                        var e = t(this),
                            a = e.data("loader-script"),
                            o = this.getBoundingClientRect().top;
                        !e.hasClass("is-load") && o < window.innerHeight + 100 && (f.buildScript(a), t('[data-loader-script="' + a + '"]').addClass("is-load"))
                    })
                };
                window.addEventListener("load", function t() {
                    e(), window.addEventListener("scroll", e)
                })
            },
            buildScript: function(t) {
                var e = document.createElement("script");
                e.src = t, document.body.appendChild(e)
            },
            beforeYouLeave: function() {
                var e = "#before-you-leave",
                    a = t(e).find(".close"),
                    o = t(e).find(".before-you-leave__bg #reload_page"),
                    i = (t(e).find(".search"), t(e).find(".before-you-leave__wrapper").data("time"));
                if (t(e).length) {
                    var n = 0;
                    t(document).ready(function() {
                        setInterval(s, i)
                    }), t(document).on("mousemove", r).on("keydown", r).on("scroll", r), o.on("click", function(e) {
                        e.preventDefault(), t("body").removeClass("open_beforeYouLeave")
                    }), a.on("click", function(e) {
                        e.preventDefault(), t("body").removeClass("open_beforeYouLeave")
                    })
                }

                function s() {
                    (n += 1) >= 1 && !t("body.open_beforeYouLeave").length && t("body").addClass("open_beforeYouLeave"), t(window).unbind("click")
                }

                function r() {
                    n = 0
                }
            },
            modal_open: function(e, a) {
                var o = {
                    open: "open_" + a,
                    openClass: "modal--is-active"
                };
                t(e).fadeIn("fast"), t(e).addClass(o.openClass), t("body").addClass(o.open)
            },
            modal_close: function(e, a) {
                var o = {
                    open: "open_" + a,
                    openClass: "modal--is-active"
                };
                t(e).fadeOut("fast"), t(e).removeClass(o.openClass), t("body").removeClass(o.open)
            },
            _addonShareAPI: function() {
                let e = t(".share_toolbox").attr("title"),
                    a = t(".share_toolbox").data("href");
                navigator.share ? navigator.share({
                    title: e,
                    url: a
                }).then(() => {
                    console.log("Thank for sharing!")
                }).cath(console.error) : (t(".share_toolbox .txt_copy").val(a), t(".share_toolbox .button").attr("data-url", a).attr("data-title", e), t(".share_toolbox .modal-title-text").text(e)), t(".close-button").click(function() {
                    t(".share-modal").removeClass("show-share"), t(".pen-url").removeClass("share-success")
                }), t(".copy-link").click(function() {
                    var e = t(this).prev(".txt_copy");
                    t(".pen-url").addClass("share-success"), e.select(), document.execCommand("copy")
                })
            },
            _addonCompareColorPopup: function() {
                t(".compareColor-link").length && (t(document).on("click", ".compareColor-link", function(e) {
                    e.preventDefault();
                    var a = "#compareColor-modal",
                        o = t(a).find(".close"),
                        i = t(a).find(".modal-content");
                    t(a).length && (t(a).addClass("modal--is-active").fadeIn("fast"), o.on("click", function(e) {
                        e.preventDefault(), t(a).removeClass("modal--is-active").fadeOut("fast")
                    }), t(a).on("click", function(e) {
                        t(a).hasClass("modal--is-active") && 0 === t(e.target).closest(i).length && (e.preventDefault(), t(a).removeClass("modal--is-active").fadeOut("fast"))
                    }))
                }), t(document).on("click", ".compareColor-swatch label", function(e) {
                    e.preventDefault(), t(".compareColor-swatch label").removeClass("disabled2");
                    var a = t(this),
                        o = a.prev(),
                        i = a.data("image");
                    $value = a.data("value"), $value2 = a.html(), $limit = 0, o.prop("checked") ? (o.prop("checked", !1), a.parents("#compareColor-modal").find(".show-img ." + $value).remove(), $limit = t("#compareColor-modal .show-img .item").length) : (o.prop("checked", !0), a.parents("#compareColor-modal").find(".show-img").append('<div class="item text-center ' + $value + '"><img srcset="' + i + '" alt="" /><p>' + $value2 + "</p></div>"), $limit = t("#compareColor-modal .show-img .item").length), $limit < 5 ? t(".compareColor-swatch label").removeClass("disabled2") : t(".compareColor-swatch label").addClass("disabled2")
                }))
            },
            _cartCountDown: function() {
                if (t(".cart__count_down").length) {
                    var e, a = t(".cart__count_down .count_down").data("time");
                    t(document).ready(function() {
                        var t, o, i, n;
                        t = fiveMinutes = 60 * a, o = display = document.querySelector("#time"), e = t, setInterval(function() {
                            i = parseInt(e / 60, 10), n = parseInt(e % 60, 10), i = i < 10 ? "0" + i : i, n = n < 10 ? "0" + n : n, o.textContent = i + ":" + n, --e < 0 && (e = t)
                        }, 1e3)
                    })
                }

                function o() {
                    e = 60 * a
                }
            },
            _videoPopup: function() {
                t(".video-open-popup ").length && (t(".video-open-popup a").off("click").on("click", function() {
                    t(this).attr("data-id");
                    var e = t(this).attr("data-src"),
                        a = t("[data-popup-video]");
                    a.find(".halo-modal-body").html('<div class="fluid-width-video-wrapper"><iframe                                        id="player"                                        type="text/html"                                        width="100%"                                        frameborder="0"                                        webkitAllowFullScreen                                        mozallowfullscreen                                        allowFullScreen                                        src="https://www.youtube.com/embed/' + e + '?autoplay=1&mute=1"                                        data-video-player>                                    </iframe></div>'), a.fadeIn(600, function() {
                        t("[data-ajax-cart-success]").is(":visible") && t("[data-ajax-cart-success]").hide()
                    })
                }), t("[data-popup-video], [data-popup-video] .close-modal").on("click", function(e) {
                    var a = t("[data-popup-video] .halo-modal-body");
                    a.is(e.target) || a.has(e.target).length || t("[data-popup-video]").fadeOut(500, function() {
                        t("[data-popup-video] iframe").remove(), s.removeClass("halo-modal-open"), s.css({
                            overflow: ""
                        })
                    })
                }))
            },
            _multiHomepage: function() {
                t("[data-menu-tab] li").on("click", function() {
                    var e = t(this).data("load-page");
                    t(this).attr("href"), t.cookie("page-url", e, {
                        expires: 1,
                        path: "/"
                    })
                });
                var e = t("[canonical-shop-url]").attr("canonical-shop-url");
                document.URL != e && t("[data-load-page=" + t.cookie("page-url") + "]").addClass("active").siblings().removeClass("active");
                var a = t("[data-menu-tab] li.active").data("load-page");
                void 0 == a && (a = ""), t.ajax({
                    url: window.router + "/search?type=product&q=" + a + "&view=mega",
                    beforeSend: function() {},
                    success: function(e) {
                        var a = t(".site-nav"),
                            o = t(e).find(".site-nav");
                        t(".wrapper_header_supermarket:not(.wrapper_header_08)").length && (a = t(".mb-area"), o = t(e).find(".mb-area")), a.replaceWith(o), f.initToggleSubMenuMobile()
                    },
                    error: function(e, a) {
                        alert(t.parseJSON(e.responseText).description)
                    },
                    complete: function() {
                        n.mousemove(function() {
                            t(".featuredProductCarousel").hasClass("slick-initialized") || f.sliderMegaMenu()
                        }), t("[data-masonry]").length && t(".site-nav-dropdown [data-masonry]").masonry({
                            columnWidth: ".grid-sizer",
                            itemSelector: "[data-gridItem]"
                        })
                    }
                })
            },
            checkbox_submit: function() {
                var e = t(".newsletter-des #check_newsletter"),
                    a = !1;
                e.off("click").on("click", function(e) {
                    t(this).is(":checked") ? t(".footer-newsletter .block-content").find(".btn").addClass("show") : (a = !0, t(".footer-newsletter .block-content").find(".btn").removeClass("show"))
                }), t(".footer-newsletter .input-group-field").keypress(function(t) {
                    13 == t.keyCode && !1 == a && t.preventDefault()
                })
            },
            _notifySoldoutSlider: function() {
                t("a#soldOut-button1").off("click").on("click", function(e) {
                    e.preventDefault();
                    var a = t(this).prev().val();
                    t("#nofify_sold-out").find("#contactFormEmail").val(a), t("#soldOut-button").trigger("click")
                })
            },
            _showmore_html: function() {
                var e = t("#collection-des");
                if (e.outerHeight() > 70) {
                    var a = '<a class="btn-showmore" data-toggle="collapse" href="#collapseSummary" aria-expanded="false" aria-controls="collapseSummary"><span>' + window.inventory_text.show_more + "</span></a>";
                    e.append(a), t(".btn-showmore").on("click", function() {
                        t(this).parents("#collection-des").hasClass("show-more") ? (t(this).parents("#collection-des").removeClass("show-more"), t(this).find("span").text(window.inventory_text.show_more)) : (t(this).parents("#collection-des").addClass("show-more"), t(this).find("span").text(window.inventory_text.show_less))
                    })
                }
            },
            _giftCard: function() {
                Shopify.Cart = Shopify.Cart || {}, Shopify.Cart.GiftWrap = {}, Shopify.Cart.GiftWrap.set = function(t) {
                    var e = new Headers({
                        "Content-Type": "application/json"
                    });
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: e,
                        body: '{ "updates": { "' + t + '": "1" } }'
                    }).then(function() {
                        f.loadAjaxCart()
                    })
                }, t("#gift-wrapping").off("click").on("click", function() {
                    t(this).find(".icon-loader").show(), Shopify.Cart.GiftWrap.set(t(this).data("gift-id"))
                })
            },
            ask_an_expert_scroll: function() {
                if (t(".ask-an-expert-sticky").length) {
                    var e = t(".ask-an-expert-sticky"),
                        a = t(window).height() / 2;
                    t(window).scroll(function() {
                        t(this).scrollTop() > a ? (t(e).fadeIn(400), t(e).show()) : t(e).fadeOut(400)
                    })
                }
            },
            homeMoreLess: function() {
                t("#rich-text__lessMore").length && t("#rich-text__lessMore").off("click").on("click", function() {
                    var e = t(this).data("more"),
                        a = t(this).data("less"),
                        o = t(this).parents(".rich-text");
                    t(this).text() == e ? (o.find(".rich-text__bottom").slideDown(200), t(this).text(a)) : (o.find(".rich-text__bottom").slideUp(200), t(this).text(e))
                })
            },
            initMasonry: function() {
                var e = t(".collection-template .product-collection[data-layout]");
                if (e.length) {
                    var a = e.data("layout");
                    return e.isotope({
                        layoutMode: a,
                        itemSelector: "[data-gridItem]"
                    })
                }
            },
            hideSizechart: function() {
                setTimeout(function() {
                    "none" == t("#size_chart .size-chart-img .size-chart-img-display").css("display") && t(".size-chart-open-popup").hide()
                }, 1e3)
            },
            swapHoverVideo: function() {
                window.innerWidth > 1200 && (t(".inner-top").mouseenter(function() {
                    var e = t(this).find("video"),
                        a = t(this).find("video").get(0);
                    e.length > 0 && a.play()
                }), t(".inner-top").mouseleave(function() {
                    var e = t(this).find("video"),
                        a = t(this).find("video").get(0);
                    e.length > 0 && a.pause()
                }))
            }
        }
    }(jQuery), $(document).ready(function() {
        jQuery.getJSON("/cart.js", function(t) {
            t.item_count > 0 && shippingBar(t)
        })
    }), $(document).on("click", "button.add_to_cart.btn", function() {
        var t = $(this).data("id");
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=1&id=" + t,
            dataType: "json",
            success: function(t) {
                $.getJSON("/cart.json").then(t => {
                    fetch("/cart?view=item").then(t => t.text()).then(e => {
                        let a = new DOMParser().parseFromString(e, "text/html"),
                            o = a.querySelector(".mini-products-list").innerHTML,
                            i = a.querySelector(".wrapper-cartCount").innerHTML,
                            n = a.querySelector(".total").innerHTML;
                            console.log(i);
                            cartDiscountFreebar();
                            // window.updateFreeGiftProgress();
                            // window.updateFreeGiftProgressJewelry();
                            window.updateAllFreeGiftProgress();
                        $(".mini-products-list").html(o), $(".wrapper-cartCount").html(i), $(".total").html(n), shippingBar(t)
                    })
                }), setTimeout(function() {
                    checkGift()
                }, 3e3)
            },
            error: function(t) {
                console.log(t)
            }
        })
    });


   // custom js ap

// function cartDiscountFreebar(count){
//     fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//         console.log('🛒 Item Count:', cart.item_count);
//         const selectors = document.querySelectorAll('.get_discount_free_funcitonality');
//         if (!selectors.length) return;

//         selectors.forEach(el => {
//             const target = parseInt(el.dataset.itemdiscount) || 0;
//             const percent = target ? Math.min((cart.item_count / target) * 100, 100) : 0;
//             el.style.setProperty('--width_discount_funciton', `${percent}%`);
//             console.log("Normal percent:", percent);
//         });
//     })
//     .catch(error => {
//         console.error('Error fetching cart data:', error);
//     });
// }

function cartDiscountFreebar(count) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {

            const selectors      = document.querySelectorAll('.get_discount_free_funcitonality');
            const remainTexts    = document.querySelectorAll('.item-remain-off');
            const notUnlockMsg   = document.querySelectorAll('.feature-not-unlock-massage');
            const unlockMsg      = document.querySelectorAll('.freature-unlock-massage');

            if (!selectors.length) return;

            selectors.forEach(el => {
                const target = parseInt(el.dataset.itemdiscount) || 0;
                const currentCount = cart.item_count || 0;

                const percent = target ? Math.min((currentCount / target) * 100, 100) : 0;
                el.style.setProperty('--width_discount_funciton', `${percent}%`);
                console.log("Progress %:", percent);

                const remaining = Math.max(target - currentCount, 0);
                remainTexts.forEach(r => {
                    r.textContent = remaining;
                });
                if (currentCount >= target) {
                    notUnlockMsg.forEach(m => m.style.display = "none");
                    unlockMsg.forEach(m => {
                        m.style.display = "inline-block";
                        m.textContent = m.dataset.text;
                    });

                } else {
                    notUnlockMsg.forEach(m => m.style.display = "inline-block");
                    unlockMsg.forEach(m => m.style.display = "none");
                }
            });
        })
        .catch(error => {
            console.error('Error fetching cart data:', error);
        });
}

cartDiscountFreebar();


(function () {
  function updateAnnouncementBarHeight() {
    const bar = document.querySelector('.itg-main-custom-announcement-bar');
    if (!bar) return;

    const barHeight = bar.offsetHeight || 0;
    document.body.style.setProperty('--announcement-bar-height', `${barHeight}px`);
  }

  // ✅ On load
//   window.addEventListener('load', updateAnnouncementBarHeight);
  updateAnnouncementBarHeight();
  // ✅ On resize
//   window.addEventListener('resize', updateAnnouncementBarHeight);
})();

function setViewportHeight() {
  const vh = window.innerHeight; 
  document.body.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();


window.addEventListener('resize', setViewportHeight);
window.addEventListener('scroll', setViewportHeight);







document.addEventListener("DOMContentLoaded", function () {

    const myBagButton = document.querySelector('.wrapper-cartCount');
    const wishlistButtonCartPage = document.querySelector('.whislist-icon-cart-page');

    if (myBagButton) {
    myBagButton.addEventListener('click', () => {
        if (wishlistButtonCartPage) {
        wishlistButtonCartPage.classList.remove('active');
        }
    });
    }

    // ✅ Handle "Wishlist" button click
    if (wishlistButtonCartPage) {
    wishlistButtonCartPage.addEventListener('click', (event) => {
        event.currentTarget.classList.add('active');
    });
    }



  const discountInput = document.querySelector(".hvg-discount-input");
  const applyBtn = document.querySelector(".hvg-apply-button");
  const messageBox = document.querySelector(".hvg-discount-message");

  if (!applyBtn) return;

  applyBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    const discountCode = discountInput.value.trim();
    if (!discountCode) {
      showMessage("Please enter a discount code.", "error");
      return;
    }

    applyBtn.classList.add("loading");
    applyBtn.textContent = "Applying...";

    try {
      const response = await fetch("/discount/" + discountCode);
      if (response.ok) {
        // showMessage("Discount code applied successfully!", "success");
        disocuntdataupdate(discountCode);
      } else {
        // showMessage("Invalid or expired discount code.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Something went wrong. Try again.", "error");
    } finally {
      applyBtn.classList.remove("loading");
      applyBtn.textContent = "Apply";
    }
  });

    function showMessage(msg, type) {
        messageBox.style.display = "block";
        messageBox.textContent = msg;
        messageBox.style.color = type === "error" ? "#d9534f" : "#28a745";
    }
   function disocuntdataupdate(codeCurrent) {
  codeCurrent = codeCurrent.toUpperCase();

  fetch(location.href, { method: "GET" })
    .then(response => response.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const dicountdata = doc.querySelector('.dicount-data-main-wrapper');
      if (!dicountdata) return; 
      const discountCodes = Array.from(dicountdata.querySelectorAll('ul li'))
        .map(item => item.getAttribute('data-code').toUpperCase());

      if (discountCodes.includes(codeCurrent)) {
        showMessage("Discount code applied successfully!", "success");
      } else {
        showMessage("Invalid or expired discount code.", "error");
      }

      const discountmaindiv = document.querySelector('.dicount-data-main-wrapper');
      if (discountmaindiv) {
        discountmaindiv.innerHTML = dicountdata.innerHTML;
      } else {
        console.warn("No discount data container found on the current page.");
        showMessage("Invalid or expired discount code.", "error");
      }
      const buttonUpdateDrawer = document.querySelector('.whislist-data-update-button');
        if (buttonUpdateDrawer) {
        const nativeClick = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
        });
        buttonUpdateDrawer.dispatchEvent(nativeClick);
        }
    })
    .catch(err => console.error("Error fetching page:", err));
}


document.addEventListener('click', function (e) {
  const button = e.target.closest('.ga-addalltocart');
  if (!button) return;

  const initialText = button.innerHTML.trim();
  let elapsed = 0;

  const interval = setInterval(() => {
    elapsed += 300;
    const currentText = button.innerHTML.trim();

    if (currentText !== initialText && currentText.toLowerCase().includes('added')) {
      clearInterval(interval);
      setTimeout(() => {
        openCartDrawer();
      }, 1000);
      const cartDrawer = document.querySelector('.translate-header');
        if (!cartDrawer) return;
            const buttonUpdateDrawer = document.querySelector('.whislist-data-update-button');
            if (buttonUpdateDrawer) {
            const nativeClick = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            buttonUpdateDrawer.dispatchEvent(nativeClick);
        }
    }

    if (elapsed >= 3000) {
      clearInterval(interval);
    }
  }, 300);

  function openCartDrawer() {
    document.documentElement.classList.add('cart-show');
  }
});
 
});

// new functionality 

// var runTrue = true;
// window.updateFreeGiftProgress = async function () {
//     const bars = document.querySelectorAll('.get_items_free_funcitonality');
//     if (!bars.length) return;

//     try {
//         const cart = await fetch('/cart.js').then(r => r.json());
//         const cartTotal = cart.total_price || 0;
//         const cartTotal_inner = (cart.total_price || 0) / 100;
//         let newProgress = 0;
//         const hasFreeGift = cart.items.some(i => i.properties && i.properties._free_gift);

//         for (const el of bars) {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             const targetOrginalConvert = parseFloat(el.dataset.priceapply || '0') / 100;
//             if (!targetPrice) continue; if (!targetOrginalConvert) continue;
//             let progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             newProgress = progress;

//             el.style.setProperty('--width_threshold_funciton', progress + "%");

//             const awayBox = document.querySelector('.limited-away-price');
//             const unlockedMessage = document.querySelector('.mistry-unlocked-massage');
//             const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data');
//             if (awayBox && unlockedMessage && unlockeddivhide) {

//                 if (progress < 100) {
//                     const remaining = (targetOrginalConvert - cartTotal_inner);
//                     if (window.Shopify.currency.active == 'USD') {
//                     awayBox.textContent = `$${remaining}`;   
//                     // awayBox.textContent = `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                     }else{
//                       awayBox.textContent = `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                     }
//                     unlockedMessage.textContent = ""; // clear
//                     unlockeddivhide.classList.remove('hidden');
//                 } else {
//                     unlockeddivhide.classList.add('hidden');
//                     awayBox.textContent = "🎉 Unlocked";
//                     let getmassageold = unlockedMessage.getAttribute('data-text');
//                     unlockedMessage.textContent = `You have unlocked the ${getmassageold}`;
//                 }
//             }

//             const modal = document.querySelector('.freeGiftModalWrapper');
//             if (!modal) continue;

//             if (progress === 100) {
//                 if (hasFreeGift) {
//                     modal.classList.remove('active');
//                 } else {
//                     modal.classList.add('active');
//                 }
//             } else {
//                 modal.classList.remove('active');
//                 if (hasFreeGift) {
//                     const freeItem = cart.items.find(i => i.properties && i.properties._free_gift);

//                     if (freeItem) {
//                         await fetch('/cart/change.js', {
//                             method: 'POST',
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                         });

//                         if (typeof window.cartUpdateFunction === 'function') {
//                             window.cartUpdateFunction();
//                         }
//                     }
//                 }
//             }
//         }
//         if (newProgress === 100 && runTrue) {
//             if (typeof window.triggerTargetConfetti === 'function') {
//                 window.triggerTargetConfetti('#confetti-container');
//             }
//             runTrue = false;
//         } else if (newProgress < 100) {
//             runTrue = true;
//         }
//     } catch (err) {
//         console.error("Free gift progress error:", err);
//     }
// };


// // Add free gift
// window.addSelectedFreeGift = async function () {
//     try {
//         const selected = document.querySelector('input[name="product_free_variant"]:checked');
//         if (!selected) {
//             alert("Please select a free gift item.");
//             return;
//         }

//         const variantId = selected.value;

//         const cart = await fetch('/cart.js').then(r => r.json());
//         const exists = cart.items.some(i => String(i.id) === String(variantId));
//         const addloaderbutton = document.querySelector('.free-gift-add-button .loading__spinner');
//         if (exists) return;
//         if (addloaderbutton) {
//             addloaderbutton.classList.remove('hidden');
//         }

//         await fetch('/cart/add.js', {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//                 id: variantId,
//                 quantity: 1,
//                 properties: { "_free_gift": "true" }
//             })
//         });

//         if (typeof window.cartUpdateFunction === "function") {
//             window.cartUpdateFunction();
//         }

//         window.triggerTargetConfetti('#confetti-container');
//         if (addloaderbutton) {
//             addloaderbutton.classList.add('hidden');
//         }

//         document.querySelector(".freeGiftModalWrapper")?.classList.remove("active");

//     } catch (err) {
//         console.error("Error adding free gift:", err);
//         if (addloaderbutton) {
//             addloaderbutton.classList.add('hidden');
//         }
//     }
// };
// var runTruenew = true;
// window.updateFreeGiftProgressJewelry = async function () {
//     const bars = document.querySelectorAll('.get_items_box_free_funcitonality');
//     if (!bars.length) return;

//     try {
//         const cart = await fetch('/cart.js').then(r => r.json());
//         // const cartTotal = (cart.total_price || 0) / 100;
//         const cartTotal = cart.total_price || 0;
//         const cartTotal_inner = (cart.total_price || 0) / 100;

//         let newProgress = 0;
//         const hasFreeGift = cart.items.some(i => i.properties && i.properties._free_gift_Jewelry_box);

//         for (const el of bars) {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             const targetOrginalConvert = parseFloat(el.dataset.priceapply || '0') / 100;
//             if (!targetPrice) continue;

//             let progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             newProgress = progress;

//             el.style.setProperty('--width_threshold_funciton_jwelery_box', progress + "%");

//             const awayBox = document.querySelector('.limited-away-price_jewelery_box');
//             const unlockedMessage = document.querySelector('.mistry-unlocked-massage_jewelery_box');
//             const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data_jewelery_box');
//             if (awayBox && unlockedMessage && unlockeddivhide) {

//                 if (progress < 100) {
//                     const remaining = (targetOrginalConvert - cartTotal_inner).toFixed(2);
//                     if (window.Shopify.currency.active == 'USD') {
//                     awayBox.textContent = `$${remaining}`;   
//                     }else{
//                       awayBox.textContent = `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                     }
//                     unlockedMessage.textContent = ""; // clear
//                     unlockeddivhide.classList.remove('hidden');
//                 } else {
//                     unlockeddivhide.classList.add('hidden');
//                     awayBox.textContent = "🎉 Unlocked";
//                     let getmassageold = unlockedMessage.getAttribute('data-text');
//                     unlockedMessage.textContent = `You have unlocked the ${getmassageold}`;
//                 }
//             }

//             const modal = document.querySelector('.freeGiftModalWrapperjewelrybox');
//             console.log(modal);
//             if (!modal) continue;
//             console.log('modal avaial');
//             if (progress === 100) {
//                 if (hasFreeGift) {
//                     modal.classList.remove('active');
//                 } else {
//                     modal.classList.add('active');
//                 }
//             } else {
//                 modal.classList.remove('active');
//                 if (hasFreeGift) {
//                     const freeItem = cart.items.find(i => i.properties && i.properties._free_gift_Jewelry_box);

//                     if (freeItem) {
//                         await fetch('/cart/change.js', {
//                             method: 'POST',
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                         });

//                         if (typeof window.cartUpdateFunction === 'function') {
//                             window.cartUpdateFunction();
//                         }
//                     }
//                 }
//             }
//         }
//         if (newProgress === 100 && runTruenew) {
//             if (typeof window.triggerTargetConfetti === 'function') {
//                 window.triggerTargetConfetti('#confetti-container');
//             }
//             runTruenew = false;
//         } else if (newProgress < 100) {
//             runTruenew = true;
//         }
//     } catch (err) {
//         console.error("Free gift progress error:", err);
//     }
// };

// window.addSelectedFreeGiftJewelry = async function () {
//     try {
//         const selected = document.querySelector('input[name="product_free_variant_box"]:checked');
//         if (!selected) {
//             alert("Please select a free gift item.");
//             return;
//         }

//         const variantId = selected.value;

//         const cart = await fetch('/cart.js').then(r => r.json());
//         const exists = cart.items.some(i => String(i.id) === String(variantId));
//         const addloaderbutton = document.querySelector('.free-gift-add-button_new .loading__spinner_jewelrybox');
//         if (exists) return;
//         if (addloaderbutton) {
//             addloaderbutton.classList.remove('hidden');
//         }

//         await fetch('/cart/add.js', {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//                 id: variantId,
//                 quantity: 1,
//                 properties: { "_free_gift_Jewelry_box": "true" }
//             })
//         });

//         if (typeof window.cartUpdateFunction === "function") {
//             window.cartUpdateFunction();
//         }

//         window.triggerTargetConfetti('#confetti-container');
//         if (addloaderbutton) {
//             addloaderbutton.classList.add('hidden');
//         }

//         document.querySelector(".freeGiftModalWrapperjewelrybox")?.classList.remove("active");

//     } catch (err) {
//         console.error("Error adding free gift:", err);
//         if (addloaderbutton) {
//             addloaderbutton.classList.add('hidden');
//         }
//     }
// };

// // new correct code ok 
// window.updateAllFreeGiftProgress = async function () {
//     const bars1 = document.querySelectorAll('.get_items_free_funcitonality');
//     const bars2 = document.querySelectorAll('.get_items_box_free_funcitonality');
//     if (!bars1.length && !bars2.length) return;

//     try {
//         // -------------------
//         // SINGLE CART FETCH
//         // -------------------
//         const cart = await fetch('/cart.js').then(r => r.json());
//         const cartTotal = cart.total_price || 0;
//         const cartTotalInner = cartTotal / 100;

//         // -------------------
//         // PROGRESS CALC
//         // -------------------
//         let progress1Max = 0;
//         let progress2Max = 0;

//         bars1.forEach(el => {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             if (!targetPrice) return;
//             const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             if (progress > progress1Max) progress1Max = progress;
//         });

//         bars2.forEach(el => {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             if (!targetPrice) return;
//             const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             if (progress > progress2Max) progress2Max = progress;
//         });

//         // -------------------
//         // SYNC LOGIC
//         // -------------------
//         if (progress1Max < 100) progress2Max = 0; // Second group can't start
//         if (progress2Max > 0 && progress1Max === 100) {
//             // Second group can progress
//         }

//         // Reverse logic: second must empty first bar to decrease
//         if (progress2Max < 100 && progress1Max === 100 && cartTotal < bars1[0]?.dataset.priceapply) {
//             if (progress2Max === 0) {
//                 progress1Max = Math.min((cartTotal / bars1[0].dataset.priceapply) * 100, 100);
//             }
//         }

//         // -------------------
//         // APPLY PROGRESS TO UI
//         // -------------------
//         bars1.forEach(el => updateBarUI(el, progress1Max, cartTotalInner, 'standard'));
//         bars2.forEach(el => updateBarUI(el, progress2Max, cartTotalInner, 'jewelry'));

//     } catch (err) {
//         console.error("Free gift multi-bar progress error:", err);
//     }
// };

// // -------------------
// // HELPER FUNCTION
// // -------------------
// function updateBarUI(el, progress, cartTotalInner, type) {
//     if (type === 'standard') {
//         el.style.setProperty('--width_threshold_funciton', progress + "%");

//         const awayBox = document.querySelector('.limited-away-price');
//         const unlockedMessage = document.querySelector('.mistry-unlocked-massage');
//         const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data');

//         if (awayBox && unlockedMessage && unlockeddivhide) {
//             if (progress < 100) {
//                 const targetConverted = parseFloat(el.dataset.priceapply || '0') / 100;
//                 const remaining = (targetConverted - cartTotalInner);
//                 awayBox.textContent = window.Shopify.currency.active === 'USD' ? `$${remaining}` : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                 unlockedMessage.textContent = "";
//                 unlockeddivhide.classList.remove('hidden');
//             } else {
//                 unlockeddivhide.classList.add('hidden');
//                 awayBox.textContent = "🎉 Unlocked";
//                 unlockedMessage.textContent = `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//             }
//         }
//     } else if (type === 'jewelry') {
//         el.style.setProperty('--width_threshold_funciton_jwelery_box', progress + "%");

//         const awayBox = document.querySelector('.limited-away-price_jewelery_box');
//         const unlockedMessage = document.querySelector('.mistry-unlocked-massage_jewelery_box');
//         const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data_jewelery_box');

//         if (awayBox && unlockedMessage && unlockeddivhide) {
//             if (progress < 100) {
//                 const targetConverted = parseFloat(el.dataset.priceapply || '0') / 100;
//                 const remaining = (targetConverted - cartTotalInner).toFixed(2);
//                 awayBox.textContent = window.Shopify.currency.active === 'USD' ? `$${remaining}` : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                 unlockedMessage.textContent = "";
//                 unlockeddivhide.classList.remove('hidden');
//             } else {
//                 unlockeddivhide.classList.add('hidden');
//                 awayBox.textContent = "🎉 Unlocked";
//                 unlockedMessage.textContent = `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//             }
//         }
//     }
// }








// var runTrue = true;
// var runTruenew = true;

// window.updateAllFreeGiftProgress = async function () {
//     const bars1 = document.querySelectorAll('.get_items_free_funcitonality');
//     const bars2 = document.querySelectorAll('.get_items_box_free_funcitonality');

//     if (!bars1.length && !bars2.length) return;

//     try {
//         // -------------------
//         // SINGLE CART FETCH
//         // -------------------
//         const cart = await fetch('/cart.js').then(r => r.json());
//         const cartTotal = cart.total_price || 0;
//         const cartTotalInner = cartTotal / 100;

//         // -------------------
//         // Calculate Max Progress
//         // -------------------
//         let progress1Max = 0;
//         let progress2Max = 0;

//         bars1.forEach(el => {
//             const targetPrice = parseFloat(el.dataset.priceapply || 0);
//             if (!targetPrice) return;
//             const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             if (progress > progress1Max) progress1Max = progress;
//         });

//         bars2.forEach(el => {
//             const targetPrice = parseFloat(el.dataset.priceapply || 0);
//             if (!targetPrice) return;
//             const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//             if (progress > progress2Max) progress2Max = progress;
//         });

//         // -------------------
//         // SYNC LOGIC
//         // -------------------
//         if (progress1Max < 100) progress2Max = 0; // Second group can't start
//         if (progress2Max > 0 && progress1Max === 100) {
//             // Second group can progress naturally
//         }

//         // Reverse logic: second must empty before first decreases
//         if (progress2Max < 100 && progress1Max === 100 && cartTotal < bars1[0]?.dataset.priceapply) {
//             if (progress2Max === 0) {
//                 progress1Max = Math.min((cartTotal / bars1[0].dataset.priceapply) * 100, 100);
//             }
//         }

//         // -------------------
//         // UPDATE UI & EXISTING LOGIC
//         // -------------------
//         // Bars Group 1 (Standard)
//         for (const el of bars1) {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             const targetConverted = targetPrice / 100;
//             const progress = progress1Max;

//             el.style.setProperty('--width_threshold_funciton', progress + "%");

//             const awayBox = document.querySelector('.limited-away-price');
//             const unlockedMessage = document.querySelector('.mistry-unlocked-massage');
//             const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data');

//             if (awayBox && unlockedMessage && unlockeddivhide) {
//                 if (progress < 100) {
//                     const remaining = (targetConverted - cartTotalInner).toFixed(2);
//                     awayBox.textContent = window.Shopify.currency.active === 'USD' ? `$${remaining}` : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                     unlockedMessage.textContent = "";
//                     unlockeddivhide.classList.remove('hidden');
//                 } else {
//                     unlockeddivhide.classList.add('hidden');
//                     awayBox.textContent = "🎉 Unlocked";
//                     unlockedMessage.textContent = `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//                 }
//             }

//             const modal = document.querySelector('.freeGiftModalWrapper');
//             const hasFreeGift = cart.items.some(i => i.properties && i.properties._free_gift);

//             if (modal) {
//                 if (progress === 100) {
//                     if (hasFreeGift) modal.classList.remove('active');
//                     else modal.classList.add('active');
//                 } else {
//                     modal.classList.remove('active');
//                     if (hasFreeGift) {
//                         const freeItem = cart.items.find(i => i.properties && i.properties._free_gift);
//                         if (freeItem) {
//                             await fetch('/cart/change.js', {
//                                 method: 'POST',
//                                 headers: { 'Content-Type': 'application/json' },
//                                 body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                             });
//                             if (typeof window.cartUpdateFunction === 'function') {
//                                 window.cartUpdateFunction();
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         // Bars Group 2 (Jewelry Box)
//         for (const el of bars2) {
//             const targetPrice = parseFloat(el.dataset.priceapply || '0');
//             const targetConverted = targetPrice / 100;
//             const progress = progress2Max;

//             el.style.setProperty('--width_threshold_funciton_jwelery_box', progress + "%");

//             const awayBox = document.querySelector('.limited-away-price_jewelery_box');
//             const unlockedMessage = document.querySelector('.mistry-unlocked-massage_jewelery_box');
//             const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data_jewelery_box');

//             if (awayBox && unlockedMessage && unlockeddivhide) {
//                 if (progress < 100) {
//                     const remaining = (targetConverted - cartTotalInner).toFixed(2);
//                     awayBox.textContent = window.Shopify.currency.active === 'USD' ? `$${remaining}` : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                     unlockedMessage.textContent = "";
//                     unlockeddivhide.classList.remove('hidden');
//                 } else {
//                     unlockeddivhide.classList.add('hidden');
//                     awayBox.textContent = "🎉 Unlocked";
//                     unlockedMessage.textContent = `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//                 }
//             }

//             const modal = document.querySelector('.freeGiftModalWrapperjewelrybox');
//             const hasFreeGift = cart.items.some(i => i.properties && i.properties._free_gift_Jewelry_box);

//             if (modal) {
//                 if (progress === 100) {
//                     if (hasFreeGift) modal.classList.remove('active');
//                     else modal.classList.add('active');
//                 } else {
//                     modal.classList.remove('active');
//                     if (hasFreeGift) {
//                         const freeItem = cart.items.find(i => i.properties && i.properties._free_gift_Jewelry_box);
//                         if (freeItem) {
//                             await fetch('/cart/change.js', {
//                                 method: 'POST',
//                                 headers: { 'Content-Type': 'application/json' },
//                                 body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                             });
//                             if (typeof window.cartUpdateFunction === 'function') {
//                                 window.cartUpdateFunction();
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         // -------------------
//         // CONFETTI LOGIC
//         // -------------------
//         if ((progress1Max === 100 || progress2Max === 100) && (runTrue || runTruenew)) {
//             if (typeof window.triggerTargetConfetti === 'function') {
//                 window.triggerTargetConfetti('#confetti-container');
//             }
//             runTrue = false;
//             runTruenew = false;
//         } else if (progress1Max < 100 || progress2Max < 100) {
//             runTrue = true;
//             runTruenew = true;
//         }

//     } catch (err) {
//         console.error("Free gift multi-bar progress error:", err);
//     }
// };




// var runTrue = true;
// var runTruenew = true;

// window.updateAllFreeGiftProgress = async function () {
//     const bars1 = document.querySelectorAll('.get_items_free_funcitonality');
//     const bars2 = document.querySelectorAll('.get_items_box_free_funcitonality');

//     const hasBar1 = bars1.length > 0;
//     const hasBar2 = bars2.length > 0;

//     // If no bars exist, skip
//     if (!hasBar1 && !hasBar2) return;

//     try {
//         // -------------------
//         // SINGLE CART FETCH
//         // -------------------
//         const cart = await fetch('/cart.js').then(r => r.json());
//         const cartTotal = cart.total_price || 0;
//         const cartTotalInner = cartTotal / 100;

//         // -------------------
//         // Calculate Progress
//         // -------------------
//         let progress1Max = hasBar1 ? 0 : null;
//         let progress2Max = hasBar2 ? 0 : null;

//         if (hasBar1) {
//             bars1.forEach(el => {
//                 const targetPrice = parseFloat(el.dataset.priceapply || 0);
//                 if (!targetPrice) return;
//                 const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//                 if (progress > progress1Max) progress1Max = progress;
//             });
//         }

//         if (hasBar2) {
//             bars2.forEach(el => {
//                 const targetPrice = parseFloat(el.dataset.priceapply || 0);
//                 if (!targetPrice) return;
//                 const progress = Math.min((cartTotal / targetPrice) * 100, 100);
//                 if (progress > progress2Max) progress2Max = progress;
//             });
//         }

//         // -------------------
//         // SMART SYNC LOGIC
//         // Only if BOTH bars exist
//         // -------------------
//         if (hasBar1 && hasBar2) {
//             // second only starts after first hits 100
//             if (progress1Max < 100) progress2Max = 0;

//             // reverse logic
//             if (progress1Max === 100 && progress2Max < 100) {
//                 const target1 = bars1[0]?.dataset.priceapply;
//                 if (cartTotal < target1) {
//                     if (progress2Max === 0) {
//                         progress1Max = Math.min((cartTotal / target1) * 100, 100);
//                     }
//                 }
//             }
//         }

//         // -------------------
//         // UPDATE BAR GROUP 1
//         // -------------------
//         if (hasBar1) {
//             for (const el of bars1) {
//                 const targetPrice = parseFloat(el.dataset.priceapply || "0");
//                 const targetConverted = targetPrice / 100;
//                 const progress = progress1Max;

//                 el.style.setProperty('--width_threshold_funciton', progress + "%");

//                 const awayBox = document.querySelector('.limited-away-price');
//                 const unlockedMessage = document.querySelector('.mistry-unlocked-massage');
//                 const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data');

//                 if (awayBox && unlockedMessage && unlockeddivhide) {
//                     if (progress < 100) {
//                         const remaining = (targetConverted - cartTotalInner).toFixed(2);
//                         awayBox.textContent = window.Shopify.currency.active === 'USD'
//                             ? `$${remaining}`
//                             : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                         unlockedMessage.textContent = "";
//                         unlockeddivhide.classList.remove('hidden');
//                     } else {
//                         unlockeddivhide.classList.add('hidden');
//                         awayBox.textContent = "🎉 Unlocked";
//                         unlockedMessage.textContent =
//                             `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//                     }
//                 }

//                 // Modal logic
//                 const modal = document.querySelector('.freeGiftModalWrapper');
//                 const hasFreeGift = cart.items.some(i => i.properties?._free_gift);

//                 if (modal) {
//                     if (progress === 100) {
//                         if (hasFreeGift) modal.classList.remove('active');
//                         else modal.classList.add('active');
//                     } else {
//                         modal.classList.remove('active');
//                         if (hasFreeGift) {
//                             const freeItem = cart.items.find(i => i.properties?._free_gift);
//                             if (freeItem) {
//                                 await fetch('/cart/change.js', {
//                                     method: 'POST',
//                                     headers: { 'Content-Type': 'application/json' },
//                                     body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                                 });
//                                 if (typeof window.cartUpdateFunction === 'function') {
//                                     window.cartUpdateFunction();
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         // -------------------
//         // UPDATE BAR GROUP 2
//         // -------------------
//         if (hasBar2) {
//             for (const el of bars2) {
//                 const targetPrice = parseFloat(el.dataset.priceapply || "0");
//                 const targetConverted = targetPrice / 100;
//                 const progress = progress2Max;

//                 el.style.setProperty('--width_threshold_funciton_jwelery_box', progress + "%");

//                 const awayBox = document.querySelector('.limited-away-price_jewelery_box');
//                 const unlockedMessage = document.querySelector('.mistry-unlocked-massage_jewelery_box');
//                 const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data_jewelery_box');

//                 if (awayBox && unlockedMessage && unlockeddivhide) {
//                     if (progress < 100) {
//                         const remaining = (targetConverted - cartTotalInner).toFixed(2);
//                         awayBox.textContent = window.Shopify.currency.active === 'USD'
//                             ? `$${remaining}`
//                             : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
//                         unlockedMessage.textContent = "";
//                         unlockeddivhide.classList.remove('hidden');
//                     } else {
//                         unlockeddivhide.classList.add('hidden');
//                         awayBox.textContent = "🎉 Unlocked";
//                         unlockedMessage.textContent =
//                             `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
//                     }
//                 }

//                 const modal = document.querySelector('.freeGiftModalWrapperjewelrybox');
//                 const hasFreeGift = cart.items.some(i => i.properties?._free_gift_Jewelry_box);

//                 if (modal) {
//                     if (progress === 100) {
//                         if (hasFreeGift) modal.classList.remove('active');
//                         else modal.classList.add('active');
//                     } else {
//                         modal.classList.remove('active');
//                         if (hasFreeGift) {
//                             const freeItem = cart.items.find(i => i.properties?._free_gift_Jewelry_box);
//                             if (freeItem) {
//                                 await fetch('/cart/change.js', {
//                                     method: 'POST',
//                                     headers: { 'Content-Type': 'application/json' },
//                                     body: JSON.stringify({ id: freeItem.key, quantity: 0 })
//                                 });
//                                 if (typeof window.cartUpdateFunction === 'function') {
//                                     window.cartUpdateFunction();
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         // -------------------
//         // CONFETTI LOGIC
//         // -------------------
//         const anyProgressFull =
//             (hasBar1 && progress1Max === 100) ||
//             (hasBar2 && progress2Max === 100);

//         if (anyProgressFull && (runTrue || runTruenew)) {
//             if (typeof window.triggerTargetConfetti === 'function') {
//                 window.triggerTargetConfetti('#confetti-container');
//             }
//             runTrue = false;
//             runTruenew = false;
//         } else if (!anyProgressFull) {
//             runTrue = true;
//             runTruenew = true;
//         }

//     } catch (err) {
//         console.error("Free gift multi-bar progress error:", err);
//     }
// };



var runTrue = true;
var runTruenew = true;

window.updateAllFreeGiftProgress = async function () {
    const bars1 = document.querySelectorAll('.get_items_free_funcitonality');
    const bars2 = document.querySelectorAll('.get_items_box_free_funcitonality');

    const hasBar1 = bars1.length > 0;
    const hasBar2 = bars2.length > 0;

    // If no bars exist, skip
    if (!hasBar1 && !hasBar2) return;

    try {
        // -------------------
        // SINGLE CART FETCH
        // -------------------
        const cart = await fetch('/cart.js').then(r => r.json());
        const cartTotal = cart.total_price || 0; // Cents
        const cartTotalInner = cartTotal / 100;  // Dollars/Unit

        // -------------------
        // 1. GET TARGET PRICES
        // -------------------
        let target1 = 0;
        let target2 = 0;

        if (hasBar1) {
            target1 = parseFloat(bars1[0].dataset.priceapply || 0); 
        }

        if (hasBar2) {
            target2 = parseFloat(bars2[0].dataset.priceapply || 0);
        }

        // -------------------
        // 2. MAIN LOGIC (Sync & Reverse Handling)
        // -------------------
        let progress1Max = 0;
        let progress2Max = 0;

        if (hasBar1 && hasBar2) {
            if (cartTotal < target1) {
                // CASE A: Cart value Target 1 se kam hai.
                progress1Max = (cartTotal / target1) * 100;
                progress2Max = 0; 
            } else {
                // CASE B: Cart value Target 1 ko cross kar gayi hai.
                progress1Max = 100;
                if (target2 > 0) {
                     progress2Max = (cartTotal / target2) * 100;
                }
            }
        } 
        else {
            if (hasBar1 && target1 > 0) {
                progress1Max = (cartTotal / target1) * 100;
            }
            if (hasBar2 && target2 > 0) {
                progress2Max = (cartTotal / target2) * 100;
            }
        }

        // Clamp values
        progress1Max = Math.min(Math.max(progress1Max, 0), 100);
        progress2Max = Math.min(Math.max(progress2Max, 0), 100);


        // -------------------
        // 3. UPDATE DOM elements (UI Update)
        // -------------------

        // Helper: Capture initial width of Bar 1 to check if it's currently filling
        let bar1StartWidth = 0;
        if (hasBar1) {
            bar1StartWidth = parseFloat(bars1[0].style.getPropertyValue('--width_threshold_funciton') || 0);
        }

        // --- UPDATE BAR GROUP 1 ---
        if (hasBar1) {
            for (const el of bars1) {
                // Current visual width for Reverse Check
                const currentWidthVal = parseFloat(el.style.getPropertyValue('--width_threshold_funciton') || 0);

                const updateBar1UI = async () => {
                    // Update Width
                    el.style.setProperty('--width_threshold_funciton', progress1Max + "%");

                    // Update Text & Unlocked Status
                    const awayBox = document.querySelector('.limited-away-price');
                    const unlockedMessage = document.querySelector('.mistry-unlocked-massage');
                    const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data');
                    
                    const targetConverted = target1 / 100;

                    if (awayBox && unlockedMessage && unlockeddivhide) {
                        if (progress1Max < 100) {
                            const remaining = (targetConverted - cartTotalInner).toFixed(2);
                            awayBox.textContent = window.Shopify.currency.active === 'USD'
                                ? `$${remaining}`
                                : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
                            unlockedMessage.textContent = "";
                            unlockeddivhide.classList.remove('hidden');
                        } else {
                            unlockeddivhide.classList.add('hidden');
                            awayBox.textContent = "🎉 Unlocked";
                            unlockedMessage.textContent =
                                `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
                        }
                    }

                    // Modal logic for Gift 1
                    const modal = document.querySelector('.freeGiftModalWrapper');
                    const hasFreeGift = cart.items.some(i => i.properties?._free_gift);

                    if (modal) {
                        if (progress1Max === 100) {
                            if (hasFreeGift) modal.classList.remove('active');
                            else modal.classList.add('active');
                        } else {
                            modal.classList.remove('active');
                            if (hasFreeGift) {
                                const freeItem = cart.items.find(i => i.properties?._free_gift);
                                if (freeItem) {
                                    await fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ id: freeItem.key, quantity: 0 })
                                    });
                                    if (typeof window.cartUpdateFunction === 'function') {
                                        window.cartUpdateFunction();
                                    }
                                }
                            }
                        }
                    }
                };

                // REVERSE DELAY LOGIC (Bar 1):
                // Wait if Bar 2 exists AND Bar 1 is shrinking
                if (hasBar2 && progress1Max < currentWidthVal) {
                    setTimeout(updateBar1UI, 1000);
                } else {
                    updateBar1UI();
                }
            }
        }

        // --- UPDATE BAR GROUP 2 ---
        if (hasBar2) {
            for (const el of bars2) {
                // Current visual width for Forward Check
                const currentWidthVal = parseFloat(el.style.getPropertyValue('--width_threshold_funciton_jwelery_box') || 0);

                const updateBar2UI = async () => {
                    // Update Width
                    el.style.setProperty('--width_threshold_funciton_jwelery_box', progress2Max + "%");

                    // Update Text & Unlocked Status
                    const awayBox = document.querySelector('.limited-away-price_jewelery_box');
                    const unlockedMessage = document.querySelector('.mistry-unlocked-massage_jewelery_box');
                    const unlockeddivhide = document.querySelector('.not-unlock-limited-mystry-data_jewelery_box');
                    
                    const targetConverted = target2 / 100;

                    if (awayBox && unlockedMessage && unlockeddivhide) {
                        if (progress2Max < 100) {
                            const remaining = (targetConverted - cartTotalInner).toFixed(2);
                            awayBox.textContent = window.Shopify.currency.active === 'USD'
                                ? `$${remaining}`
                                : `${Shopify.formatMoney(100 * remaining, window.money_format)}`;
                            unlockedMessage.textContent = "";
                            unlockeddivhide.classList.remove('hidden');
                        } else {
                            unlockeddivhide.classList.add('hidden');
                            awayBox.textContent = "🎉 Unlocked";
                            unlockedMessage.textContent =
                                `You have unlocked the ${unlockedMessage.getAttribute('data-text')}`;
                        }
                    }

                    // Modal logic for Gift 2
                    const modal = document.querySelector('.freeGiftModalWrapperjewelrybox');
                    const hasFreeGift = cart.items.some(i => i.properties?._free_gift_Jewelry_box);

                    if (modal) {
                        if (progress2Max === 100) {
                            if (hasFreeGift) modal.classList.remove('active');
                            else modal.classList.add('active');
                        } else {
                            modal.classList.remove('active');
                            if (hasFreeGift) {
                                const freeItem = cart.items.find(i => i.properties?._free_gift_Jewelry_box);
                                if (freeItem) {
                                    await fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ id: freeItem.key, quantity: 0 })
                                    });
                                    if (typeof window.cartUpdateFunction === 'function') {
                                        window.cartUpdateFunction();
                                    }
                                }
                            }
                        }
                    }
                };

                // FORWARD DELAY LOGIC (Bar 2):
                // Check if Bar 1 was NOT full yet (bar1StartWidth < 100)
                // AND Bar 2 needs to grow (progress2Max > currentWidthVal)
                // This means Bar 1 is currently filling up, so Bar 2 should wait.
                if (hasBar1 && bar1StartWidth < 100 && progress2Max > currentWidthVal) {
                    setTimeout(updateBar2UI, 1000);
                } else {
                    updateBar2UI();
                }
            }
        }

        // -------------------
        // CONFETTI LOGIC
        // -------------------
        const anyProgressFull =
            (hasBar1 && progress1Max === 100) ||
            (hasBar2 && progress2Max === 100);

        if (anyProgressFull && (runTrue || runTruenew)) {
            if (typeof window.triggerTargetConfetti === 'function') {
                window.triggerTargetConfetti('#confetti-container');
            }
            runTrue = false;
            runTruenew = false;
        } else if (!anyProgressFull) {
            runTrue = true;
            runTruenew = true;
        }

    } catch (err) {
        console.error("Free gift multi-bar progress error:", err);
    }
};



window.addSelectedFreeGift = async function () {
    try {
        const selected = document.querySelector('input[name="product_free_variant"]:checked');
        if (!selected) {
            alert("Please select a free gift item.");
            return;
        }

        const variantId = selected.value;

        const cart = await fetch('/cart.js').then(r => r.json());
        const exists = cart.items.some(i => String(i.id) === String(variantId));
        const addloaderbutton = document.querySelector('.free-gift-add-button .loading__spinner');
        if (exists) return;
        if (addloaderbutton) {
            addloaderbutton.classList.remove('hidden');
        }

        await fetch('/cart/add.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: { "_free_gift": "true" }
            })
        });

        if (typeof window.cartUpdateFunction === "function") {
            window.cartUpdateFunction();
        }

        window.triggerTargetConfetti('#confetti-container');
        if (addloaderbutton) {
            addloaderbutton.classList.add('hidden');
        }

        document.querySelector(".freeGiftModalWrapper")?.classList.remove("active");

    } catch (err) {
        console.error("Error adding free gift:", err);
        if (addloaderbutton) {
            addloaderbutton.classList.add('hidden');
        }
    }
};
window.addSelectedFreeGiftJewelry = async function () {
    try {
        const selected = document.querySelector('input[name="product_free_variant_box"]:checked');
        if (!selected) {
            alert("Please select a free gift item.");
            return;
        }

        const variantId = selected.value;

        const cart = await fetch('/cart.js').then(r => r.json());
        const exists = cart.items.some(i => String(i.id) === String(variantId));
        const addloaderbutton = document.querySelector('.free-gift-add-button_new .loading__spinner_jewelrybox');
        if (exists) return;
        if (addloaderbutton) {
            addloaderbutton.classList.remove('hidden');
        }

        await fetch('/cart/add.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: { "_free_gift_Jewelry_box": "true" }
            })
        });

        if (typeof window.cartUpdateFunction === "function") {
            window.cartUpdateFunction();
        }

        window.triggerTargetConfetti('#confetti-container');
        if (addloaderbutton) {
            addloaderbutton.classList.add('hidden');
        }

        document.querySelector(".freeGiftModalWrapperjewelrybox")?.classList.remove("active");

    } catch (err) {
        console.error("Error adding free gift:", err);
        if (addloaderbutton) {
            addloaderbutton.classList.add('hidden');
        }
    }
};










// CONFETTI FIXED & FAST
window.triggerTargetConfetti = function (selector) {
    
    const target = document.querySelector(selector);
    if (!target) return;
console.log('triggerTargetConfetti');
    const colors = ['#FF0A47', '#FFD300', '#00C2FF', '#AFFF00', '#FF8C00'];

    for (let i = 0; i < 50; i++) {
        const piece = document.createElement('div');
        piece.classList.add('confetti-piece');

        // const size = Math.random() * 5 + 2;

        // Object.assign(piece.style, {
        //     position: 'absolute',
        //     top: '-10px',
        //     left: Math.random() * target.offsetWidth + 'px',
        //     width: size + 'px',
        //     height: size + 'px',
        //     backgroundColor: colors[Math.floor(Math.random() * colors.length)],
        //     opacity: 0.9,
        //     animation: `fall ${Math.random() * 1.5 + 2}s linear`,
        //     transform: `rotate(${Math.random() * 360}deg)`
        // });
        const sizePx = Math.random() * 3 + 2; // 2px–5px
        const sizeVw = sizePx / 15.36;

        const topPx = -10;
        const topVw = topPx / 15.36;

        const leftVw = (Math.random() * target.offsetWidth) / 15.36;

        Object.assign(piece.style, {
            position: 'absolute',
            top: topVw + 'vw',
            left: leftVw + 'vw',
            width: sizeVw + 'vw',
            height: sizeVw + 'vw',
            backgroundColor: colors[Math.floor(Math.random() * colors.length)],
            opacity: 0.9,
            animation: `fall ${Math.random() * 1.5 + 2}s linear`,
            transform: `rotate(${Math.random() * 360}deg)`
        });

        target.appendChild(piece);
        setTimeout(() => piece.remove(), 3000);
    }
};



window.cartUpdateFunction = function () {
    const buttonUpdateDrawer = document.querySelector('.whislist-data-update-button');
    if (buttonUpdateDrawer) {
        const nativeClick = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
        });
        buttonUpdateDrawer.dispatchEvent(nativeClick);
    }
};

window.cartDiscountUpdate = function(){
     fetch(location.href, { method: "GET" })
    .then(response => response.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const dicountdata = doc.querySelector('.dicount-data-main-wrapper');
      if (!dicountdata) return; 
      const discountmaindiv = document.querySelector('.dicount-data-main-wrapper');
      if (discountmaindiv) {
        discountmaindiv.innerHTML = dicountdata.innerHTML;
      } else {
        console.warn("No discount data container found on the current page.");
      }
    })
    .catch(err => console.error("Error fetching page:", err));
}



document.addEventListener('DOMContentLoaded', function () {
  const freeGiftAddButton = document.querySelector('.free-gift-add-button');

    if (freeGiftAddButton) {
    freeGiftAddButton.addEventListener('click', () => {
        if (typeof window.addSelectedFreeGift === 'function') {
        window.addSelectedFreeGift();
        } else {
        console.warn('addSelectedFreeGift() is not defined on window.');
        }
    });
    }

    const freeGiftAddButtonjewelrybox = document.querySelector('.free-gift-add-button_new');

    if (freeGiftAddButtonjewelrybox) {
    freeGiftAddButtonjewelrybox.addEventListener('click', () => {
        if (typeof window.addSelectedFreeGiftJewelry === 'function') {
        window.addSelectedFreeGiftJewelry();
        } else {
        console.warn('addSelectedFreeGift() is not defined on window.');
        }
    });
    }

  window.cartUpdateFunction();
//   window.updateFreeGiftProgress();
//   window.updateFreeGiftProgressJewelry();
window.updateAllFreeGiftProgress();
  window.cartDiscountUpdate();
});

// window.updateFreeGiftProgress();
// window.updateFreeGiftProgressJewelry();
window.updateAllFreeGiftProgress();

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('messageContainer');
    const messages = container.querySelectorAll('.shipping-line-data-item');
    if (!container || messages.length === 0) return;
    let currentIndex = 0;
    const cycleInterval = 4000; 
    const transitionDuration = 500; 

    function deactivateCurrent() {
        messages.forEach(msg => msg.classList.remove('active'));
    }
    function showNextMessage() {
        deactivateCurrent();

        messages[currentIndex].classList.add('active');
        currentIndex = (currentIndex + 1) % messages.length; 
    }
    showNextMessage();
    setInterval(showNextMessage, cycleInterval + transitionDuration);
});